import "./luna-vue-ui.css";
import { inject as He, defineComponent as ae, useAttrs as Gt, computed as C, openBlock as l, createBlock as _, resolveDynamicComponent as pt, mergeProps as We, createCommentVNode as w, useSlots as Zt, createElementBlock as s, normalizeClass as E, renderSlot as N, toDisplayString as I, ref as R, onBeforeUnmount as dt, Transition as we, withCtx as ne, createVNode as U, createElementVNode as i, createTextVNode as $e, watch as me, nextTick as pe, onUnmounted as Ie, Teleport as De, normalizeStyle as re, Fragment as te, createSlots as At, useId as Jt, unref as Z, withDirectives as xt, withModifiers as fe, vModelText as Rt, renderList as oe, onMounted as wt, toValue as Ue, toRef as ft, provide as nt, TransitionGroup as Ye, vShow as Qt, withKeys as $t, resolveComponent as _t, shallowRef as ea } from "vue";
import { X as ta, Trash2 as aa, Star as la, Search as ra, Save as na, Plus as sa, Pencil as oa, Minimize2 as ia, Maximize2 as ua, Loader2 as da, List as ca, Lightbulb as fa, Inbox as ma, Info as va, HelpCircle as ba, FolderTree as ha, Database as ga, ChevronsRight as ya, ChevronsLeft as pa, ChevronRight as xa, ChevronLeft as wa, ChevronDown as ka, CheckCircle2 as $a, Check as Ca, ArrowLeft as La, AlertTriangle as Sa, AlertCircle as za, RotateCw as Pt, LoaderCircle as Ba, EyeOff as Ta, Eye as Ea } from "lucide-vue-next";
const Ht = /* @__PURE__ */ Symbol.for("lunagoai.vue-ui.iconRegistry"), Ma = {
  AlertCircle: za,
  AlertTriangle: Sa,
  ArrowLeft: La,
  Check: Ca,
  CheckCircle2: $a,
  ChevronDown: ka,
  ChevronLeft: wa,
  ChevronRight: xa,
  ChevronsLeft: pa,
  ChevronsRight: ya,
  Database: ga,
  FolderTree: ha,
  HelpCircle: ba,
  Info: va,
  Inbox: ma,
  Lightbulb: fa,
  List: ca,
  Loader2: da,
  Maximize2: ua,
  Minimize2: ia,
  Pencil: oa,
  Plus: sa,
  Save: na,
  Search: ra,
  Star: la,
  Trash2: aa,
  X: ta
};
function ut(e) {
  return e.split(/[-_\s]+/).filter(Boolean).map((r) => r.charAt(0).toUpperCase() + r.slice(1)).join("");
}
function Wt(e = {}) {
  const r = {
    custom: /* @__PURE__ */ new Map(),
    defaults: /* @__PURE__ */ new Map()
  };
  for (const [t, a] of Object.entries(Ma))
    r.defaults.set(t, a), r.defaults.set(ut(t), a);
  return Da(e, r), r;
}
const lt = Wt();
function Ia(e, r, t = lt) {
  t.custom.set(e, r), t.custom.set(ut(e), r);
}
function Da(e, r = lt) {
  for (const [t, a] of Object.entries(e))
    Ia(t, a, r);
}
function Va(e, r = lt) {
  return r.custom.get(e) ?? r.custom.get(ut(e)) ?? r.defaults.get(e) ?? r.defaults.get(ut(e)) ?? null;
}
function li() {
  lt.custom.clear();
}
function Aa() {
  return He(Ht, lt);
}
const Ra = /* @__PURE__ */ ae({
  inheritAttrs: !1,
  __name: "BaseIcon",
  props: {
    name: {},
    size: { default: 16 },
    color: {},
    strokeWidth: { default: 2 },
    label: {},
    decorative: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const r = e, t = Gt(), a = Aa(), n = C(() => {
      if (!r.name) return null;
      if (typeof r.name != "string") return r.name;
      const u = r.name.split(/[-_\s]+/).filter(Boolean).map((d) => d.charAt(0).toUpperCase() + d.slice(1)).join("");
      return Va(u, a);
    }), o = C(() => {
      const u = !!(r.label || t["aria-label"]);
      return {
        ...t,
        "aria-label": r.label ?? t["aria-label"],
        "aria-hidden": r.decorative === !0 || !u && t["aria-hidden"] === void 0 ? "true" : t["aria-hidden"],
        role: u ? t.role ?? "img" : t.role
      };
    });
    return (u, d) => n.value ? (l(), _(pt(n.value), We({
      key: 0,
      size: e.size,
      color: e.color,
      "stroke-width": e.strokeWidth
    }, o.value, { class: "luna-icon" }), null, 16, ["size", "color", "stroke-width"])) : w("", !0);
  }
}), ce = (e, r) => {
  const t = e.__vccOpts || e;
  for (const [a, n] of r)
    t[a] = n;
  return t;
}, X = /* @__PURE__ */ ce(Ra, [["__scopeId", "data-v-7dcfc498"]]), Pa = ["type", "data-variant", "disabled", "aria-busy", "aria-label"], Ha = { key: 3 }, Wa = /* @__PURE__ */ ae({
  __name: "BaseButton",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: {},
    label: {},
    loadingLabel: { default: "Loading" },
    block: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    align: { default: "center" },
    display: { default: "inline-flex" }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = Zt(), o = C(() => (t.icon || t.loading) && !t.label && !n.default), u = C(() => t.display === "grid" ? "grid" : t.display === "flex" ? "flex items-center" : "inline-flex items-center"), d = C(
      () => [
        "font-semibold transition-all duration-200 outline-none",
        "focus-visible:ring-2 focus-visible:ring-offset-1 disabled:opacity-60 disabled:cursor-not-allowed",
        "active:scale-95 whitespace-nowrap",
        t.rounded ? "rounded-full" : "rounded-lg"
      ].join(" ")
    ), m = C(() => t.display === "grid" ? t.align === "start" ? "place-items-start" : t.align === "end" ? "place-items-end" : "place-items-center" : t.align === "start" ? "justify-start" : t.align === "end" ? "justify-end" : "justify-center"), y = C(() => {
      switch (t.variant) {
        case "primary":
          return "bg-primary text-white hover:bg-primary-hover shadow-md shadow-primary/20 focus:ring-primary/50 border border-transparent";
        case "primary-glass":
          return "bg-primary/10 text-primary-400 hover:bg-primary/20 hover:text-primary-300 ring-1 ring-inset ring-primary-400/10 border-transparent focus:ring-primary-500/50";
        case "secondary":
          return "bg-surface-muted text-ui-muted hover:bg-surface-elevated border border-ui focus:ring-ui-focus";
        case "danger":
          return "bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/40 border border-red-100 dark:border-red-900/30 focus:ring-red-200 dark:focus:ring-red-800";
        case "danger-solid":
          return "bg-red-600 text-white hover:bg-red-700 shadow-sm shadow-red-900/20 focus:ring-red-500 border border-transparent";
        case "danger-glass":
          return "bg-red-500/15 text-red-400 hover:bg-red-500/25 hover:text-red-300 ring-1 ring-inset ring-red-400/10 border-transparent focus:ring-red-500/50";
        case "success":
          return "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/40 border border-emerald-100 dark:border-emerald-900/30 focus:ring-emerald-200 dark:focus:ring-emerald-800";
        case "success-solid":
          return "bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm shadow-emerald-900/20 focus:ring-emerald-500 border border-transparent";
        case "info":
          return "bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40 border border-blue-100 dark:border-blue-900/30 focus:ring-blue-200 dark:focus:ring-blue-800";
        case "info-solid":
          return "bg-blue-600 text-white hover:bg-blue-700 shadow-sm shadow-blue-900/20 focus:ring-blue-500 border border-transparent";
        case "warning":
          return "bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/40 border border-amber-100 dark:border-amber-900/30 focus:ring-amber-200 dark:focus:ring-amber-800";
        case "outline":
          return "bg-transparent border border-primary text-primary hover:bg-primary/5 focus:ring-primary/30 dark:border-dark-200 dark:text-dark-text-muted dark:hover:bg-dark-100";
        case "ghost":
          return "bg-transparent text-ui-muted hover:bg-surface-muted hover:text-ui border border-transparent focus:ring-ui-focus";
        case "accent-ghost":
          return "bg-transparent text-ui-muted hover:bg-primary/15 hover:text-primary-light border border-transparent focus:ring-primary/40";
        case "accent-outline":
          return "bg-surface-muted text-ui-muted hover:bg-primary/15 hover:text-primary-light border border-ui focus:ring-primary/40";
        case "transparent":
          return "focus:ring-0";
        default:
          return "bg-primary text-white hover:bg-primary-hover";
      }
    }), p = C(() => o.value ? t.size === "sm" ? "w-8 h-8 p-0" : t.size === "lg" ? "w-12 h-12 p-0" : "w-10 h-10 p-0" : t.size === "sm" ? "px-4 py-1.5 text-xs gap-1" : t.size === "lg" ? "px-8 py-3 text-base gap-2.5" : "px-6 py-2 text-sm gap-1.5");
    function b(L) {
      !t.disabled && !t.loading && a("click", L);
    }
    return (L, c) => (l(), s("button", {
      type: e.type,
      "data-variant": e.variant,
      disabled: e.disabled || e.loading,
      "aria-busy": e.loading || void 0,
      "aria-label": e.loading && !e.label && !L.$slots.default ? e.loadingLabel : void 0,
      class: E([u.value, d.value, m.value, y.value, p.value, e.block ? "w-full" : "", L.$attrs.class]),
      onClick: b
    }, [
      e.loading ? (l(), _(X, {
        key: 0,
        name: "Loader2",
        class: "animate-spin",
        decorative: ""
      })) : w("", !0),
      e.icon && !e.loading ? (l(), _(X, {
        key: 1,
        name: e.icon,
        size: e.size === "sm" ? 16 : 18
      }, null, 8, ["name", "size"])) : w("", !0),
      !e.loading && L.$slots.start && !e.icon ? N(L.$slots, "start", {}, void 0, !0, 2) : w("", !0),
      e.label ? (l(), s("span", Ha, I(e.label), 1)) : N(L.$slots, "default", {}, void 0, !0, 4),
      N(L.$slots, "end", {}, void 0, !0)
    ], 10, Pa));
  }
}), at = /* @__PURE__ */ ce(Wa, [["__scopeId", "data-v-f4f744b3"]]), Oa = ["role", "aria-live"], ja = { class: "min-w-0 flex-1" }, Re = 200, ri = /* @__PURE__ */ ae({
  __name: "BaseAlert",
  props: {
    severity: { default: "info" },
    dismissible: { type: Boolean, default: !0 },
    closeLabel: { default: "Close" }
  },
  emits: ["close"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => {
      switch (t.severity) {
        case "success":
          return "CheckCircle2";
        case "error":
          return "AlertCircle";
        case "warning":
          return "AlertTriangle";
        case "info":
          return "Info";
      }
    }), o = C(() => t.severity === "error" ? "alert" : "status"), u = R(!1), d = /* @__PURE__ */ new WeakMap();
    let m, y;
    const p = C(() => {
      switch (t.severity) {
        case "success":
          return "bg-success/10 text-success border-success/30";
        case "error":
          return "bg-danger/10 text-danger border-danger/30";
        case "warning":
          return "bg-warning/10 text-warning border-warning/30";
        case "info":
          return "bg-info/10 text-info border-info/30";
      }
    });
    function b(k) {
      const M = window.getComputedStyle(k);
      return {
        maxHeight: "",
        opacity: "1",
        paddingTop: M.paddingTop,
        paddingBottom: M.paddingBottom,
        marginBottom: M.marginBottom,
        borderColor: M.borderColor
      };
    }
    function L(k) {
      k.style.overflow = "hidden", k.style.transition = [
        `opacity ${Re}ms ease-out`,
        `max-height ${Re}ms ease-out`,
        `padding-top ${Re}ms ease-out`,
        `padding-bottom ${Re}ms ease-out`,
        `margin-bottom ${Re}ms ease-out`,
        `border-color ${Re}ms ease-out`
      ].join(", ");
    }
    function c(k) {
      k.style.overflow = "", k.style.transition = "", k.style.maxHeight = "", k.style.opacity = "", k.style.paddingTop = "", k.style.paddingBottom = "", k.style.marginBottom = "", k.style.borderColor = "";
    }
    function v(k) {
      const M = k;
      d.set(M, b(M)), L(M), M.style.maxHeight = "0px", M.style.opacity = "0", M.style.paddingTop = "0px", M.style.paddingBottom = "0px", M.style.marginBottom = "0px", M.style.borderColor = "transparent";
    }
    function f(k, M) {
      const F = k, V = {
        ...d.get(F) ?? b(F),
        maxHeight: `${F.scrollHeight}px`
      };
      m = requestAnimationFrame(() => {
        Object.assign(F.style, V), y = setTimeout(() => {
          c(F), d.delete(F), M();
        }, Re);
      });
    }
    function h(k) {
      const M = k, F = {
        ...b(M),
        maxHeight: `${M.scrollHeight}px`
      };
      d.set(M, F), L(M), Object.assign(M.style, F);
    }
    function x(k, M) {
      const F = k;
      m = requestAnimationFrame(() => {
        F.style.maxHeight = "0px", F.style.opacity = "0", F.style.paddingTop = "0px", F.style.paddingBottom = "0px", F.style.marginBottom = "0px", F.style.borderColor = "transparent", y = setTimeout(() => {
          c(F), d.delete(F), M(), a("close");
        }, Re);
      });
    }
    function S() {
      u.value || (u.value = !0);
    }
    return dt(() => {
      m !== void 0 && cancelAnimationFrame(m), y && clearTimeout(y);
    }), (k, M) => (l(), _(we, {
      appear: "",
      css: !1,
      onBeforeEnter: v,
      onEnter: f,
      onBeforeLeave: h,
      onLeave: x
    }, {
      default: ne(() => [
        u.value ? w("", !0) : (l(), s("div", {
          key: 0,
          class: E(["flex min-w-0 items-center gap-3 overflow-hidden rounded-[9px] border px-3.5 py-3 leading-[1.45]", p.value]),
          role: o.value,
          "aria-live": o.value === "alert" ? "assertive" : "polite"
        }, [
          U(X, {
            name: n.value,
            size: 18,
            class: "shrink-0",
            "aria-hidden": "true"
          }, null, 8, ["name"]),
          i("div", ja, [
            N(k.$slots, "default")
          ]),
          e.dismissible ? (l(), _(at, {
            key: 0,
            size: "sm",
            variant: "ghost",
            icon: "X",
            "aria-label": e.closeLabel,
            class: "!h-7 !w-7 !shrink-0 !p-0",
            onClick: S
          }, null, 8, ["aria-label"])) : w("", !0)
        ], 10, Oa))
      ]),
      _: 3
    }));
  }
}), Fa = { class: "flex flex-col gap-1 w-full relative" }, Ka = ["for"], Na = {
  key: 0,
  class: "font-bold"
}, Ua = ["id", "placeholder", "disabled", "readonly", "required", "rows", "autocomplete", "value"], qa = ["id", "type", "placeholder", "disabled", "readonly", "required", "autocomplete", "value"], Xa = {
  key: 0,
  class: "font-bold"
}, Ya = {
  key: 1,
  class: "mt-1 text-[11px] text-red-500 font-medium flex items-center gap-1"
}, Ga = /* @__PURE__ */ ae({
  inheritAttrs: !1,
  __name: "BaseInput",
  props: {
    modelValue: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [Boolean, String], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    label: { default: "" },
    size: { default: "md" },
    variant: { default: "default" },
    rows: { default: 3 },
    hideZero: { type: Boolean },
    inputClass: {},
    textAlign: { default: "left" },
    prefix: {},
    suffix: {},
    color: { default: "primary" },
    autocomplete: {},
    autoSave: {}
  },
  emits: ["update:modelValue", "blur", "focus", "click", "keyup", "enter"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = R(null);
    function u(h) {
      const x = h.target;
      n("update:modelValue", x.value), a.autoSave?.();
    }
    function d(h) {
      h.key === "Enter" && n("enter", h), n("keyup", h);
    }
    r({
      focus: () => o.value?.focus(),
      blur: () => o.value?.blur(),
      select: () => o.value?.select(),
      ref: o
    });
    const m = C(() => a.error === !0 || typeof a.error == "string" && a.error.trim() !== ""), y = C(() => typeof a.error == "string" ? a.error : ""), p = C(() => ({
      primary: "focus:border-primary focus:ring-primary/20",
      teal: "focus:border-teal-500 focus:ring-teal-500/20",
      indigo: "focus:border-indigo-500 focus:ring-indigo-500/20",
      orange: "focus:border-orange-500 focus:ring-orange-500/20",
      red: "focus:border-red-500 focus:ring-red-500/20"
    })[a.color]), b = C(() => ({
      primary: "focus:border-primary dark:focus:border-primary",
      teal: "focus:border-teal-500 dark:focus:border-teal-400",
      indigo: "focus:border-indigo-500 dark:focus:border-indigo-400",
      orange: "focus:border-orange-500 dark:focus:border-orange-400",
      red: "focus:border-red-500 dark:focus:border-red-400"
    })[a.color]), L = C(() => {
      const h = "font-medium placeholder:text-gray-400 dark:placeholder:text-gray-600 outline-none w-full transition-all";
      if (m.value)
        return `${h} bg-gray-50 dark:bg-red-900/10 border border-red-300 dark:border-red-800 focus:ring-2 focus:ring-red-100 dark:focus:ring-red-900/30 focus:border-red-500 text-red-900 dark:text-red-400 placeholder:text-red-300 dark:placeholder:text-red-500/50`;
      switch (a.variant) {
        case "filled":
          return `${h} bg-surface-muted border border-transparent focus:bg-surface ${p.value} text-ui`;
        case "outlined":
          return `${h} bg-transparent border-2 border-ui-strong ${p.value} text-ui`;
        case "plain":
          return `${h} bg-transparent border-0 focus:ring-0 text-ui-muted p-0`;
        case "underlined":
          return `${h} bg-transparent border-0 border-b border-transparent ${b.value} focus:ring-0 text-gray-800 dark:text-dark-text rounded-none px-0`;
        case "underlined-gray":
          return `${h} bg-transparent border-0 border-b border-ui ${b.value} focus:ring-0 text-ui rounded-none px-0`;
        default:
          return `${h} bg-surface border border-ui ${p.value} text-ui-muted shadow-sm`;
      }
    }), c = C(() => a.hideZero && (a.modelValue === 0 || a.modelValue === "0") ? "" : a.modelValue), v = C(() => {
      const h = a.variant === "underlined" || a.variant === "underlined-gray";
      return a.size === "xs" ? a.type === "textarea" ? "px-2 py-1 text-[10px] rounded" : `${h ? "px-0" : "px-2"} h-6 text-[10px] rounded` : a.size === "sm" ? a.type === "textarea" ? "px-2.5 py-1.5 text-xs rounded-lg" : `${h ? "px-0" : "px-2.5"} h-7.5 text-xs rounded-lg` : a.size === "lg" ? `${h ? "px-0" : "px-5"} py-3 text-base rounded-xl` : `${h ? "px-0" : "px-4"} py-2 text-sm rounded-lg`;
    }), f = C(() => a.textAlign === "center" ? "text-center" : a.textAlign === "right" ? "text-right" : "text-left");
    return (h, x) => (l(), s("div", Fa, [
      e.label ? (l(), s("label", {
        key: 0,
        for: e.id,
        class: "block text-[11px] font-bold text-gray-500 dark:text-dark-text-dim uppercase tracking-tight"
      }, I(e.label), 9, Ka)) : w("", !0),
      i("div", {
        class: E(["relative flex", e.type === "textarea" ? "items-start" : "items-center"])
      }, [
        h.$slots.start || e.prefix ? (l(), s("div", {
          key: 0,
          class: E(["absolute left-2.5 text-gray-400 flex items-center", [e.size === "xs" ? "text-[9px]" : "text-xs", e.type === "textarea" ? "mt-2.5" : ""]])
        }, [
          N(h.$slots, "start", {}, void 0, !0),
          e.prefix ? (l(), s("span", Na, I(e.prefix), 1)) : w("", !0)
        ], 2)) : w("", !0),
        e.type === "textarea" ? (l(), s("textarea", We({
          key: 1,
          ref_key: "inputRef",
          ref: o,
          id: e.id,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          required: e.required,
          rows: e.rows,
          autocomplete: e.autocomplete,
          class: ["disabled:bg-gray-50 dark:disabled:bg-dark-100 dark:disabled:text-dark-text-dim disabled:cursor-not-allowed disabled:opacity-60 resize-none", [L.value, v.value, f.value, h.$slots.start || e.prefix ? e.size === "xs" || e.size === "sm" ? "pl-7" : "pl-10" : "", h.$slots.end || e.suffix ? e.size === "xs" || e.size === "sm" ? "pr-7" : "pr-10" : "", e.inputClass]],
          value: c.value
        }, h.$attrs, {
          onInput: u,
          onBlur: x[0] || (x[0] = (S) => n("blur", S)),
          onFocus: x[1] || (x[1] = (S) => n("focus", S)),
          onClick: x[2] || (x[2] = (S) => n("click", S)),
          onKeyup: d
        }), null, 16, Ua)) : (l(), s("input", We({
          key: 2,
          ref_key: "inputRef",
          ref: o,
          id: e.id,
          type: e.type,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          required: e.required,
          autocomplete: e.autocomplete,
          class: ["disabled:bg-gray-50 dark:disabled:bg-dark-100 dark:disabled:text-dark-text-dim disabled:cursor-not-allowed disabled:opacity-60", [L.value, v.value, f.value, h.$slots.start || e.prefix ? e.size === "xs" || e.size === "sm" ? "pl-8" : "pl-10" : "", h.$slots.end || e.suffix ? e.size === "xs" || e.size === "sm" ? "pr-8" : "pr-10" : "", e.inputClass]],
          value: c.value
        }, h.$attrs, {
          onInput: u,
          onBlur: x[3] || (x[3] = (S) => n("blur", S)),
          onFocus: x[4] || (x[4] = (S) => n("focus", S)),
          onClick: x[5] || (x[5] = (S) => n("click", S)),
          onKeyup: d
        }), null, 16, qa)),
        h.$slots.end || e.suffix ? (l(), s("div", {
          key: 3,
          class: E(["absolute right-3 text-gray-400 flex items-center", e.size === "xs" ? "text-[9px]" : "text-xs"])
        }, [
          e.suffix ? (l(), s("span", Xa, I(e.suffix), 1)) : w("", !0),
          N(h.$slots, "end", {}, void 0, !0)
        ], 2)) : w("", !0)
      ], 2),
      y.value ? (l(), s("p", Ya, [
        U(X, {
          name: "AlertCircle",
          size: 11
        }),
        $e(" " + I(y.value), 1)
      ])) : w("", !0)
    ]));
  }
}), Ke = /* @__PURE__ */ ce(Ga, [["__scopeId", "data-v-acc20f0a"]]), Za = /* @__PURE__ */ ae({
  inheritAttrs: !1,
  __name: "BasePopover",
  props: {
    visible: { type: Boolean },
    triggerRef: {},
    width: { default: "w-56" },
    placement: { default: "bottom" },
    offset: { default: 8 },
    teleport: { type: Boolean, default: !0 },
    className: { default: "" },
    padding: { default: "py-2" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnScroll: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 },
    matchTriggerWidth: { type: Boolean, default: !1 },
    minWidthPx: {},
    constrainHeight: { type: Boolean, default: !1 },
    positioning: { default: "anchor" }
  },
  emits: ["update:visible", "update:resolvedPlacement", "close", "popover-mouseenter", "popover-mouseleave"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = R(null), o = R({}), u = R(t.placement);
    let d = null;
    function m(v) {
      return v === "bottom" ? "top" : v === "bottom-start" ? "top-start" : v === "bottom-end" ? "top-end" : v === "top" ? "bottom" : v === "top-start" ? "bottom-start" : v === "top-end" ? "bottom-end" : v;
    }
    function y(v, f, h, x) {
      const S = f.left + f.width / 2, k = f.top + f.height / 2;
      switch (v) {
        case "bottom":
          return { top: f.bottom + t.offset, left: S - h / 2 };
        case "bottom-start":
          return { top: f.bottom + t.offset, left: f.left };
        case "bottom-end":
          return { top: f.bottom + t.offset, left: f.right - h };
        case "top":
          return { top: f.top - x - t.offset, left: S - h / 2 };
        case "top-start":
          return { top: f.top - x - t.offset, left: f.left };
        case "top-end":
          return { top: f.top - x - t.offset, left: f.right - h };
        case "right":
          return { top: k - x / 2, left: f.right + t.offset };
        case "right-start":
          return { top: f.top, left: f.right + t.offset };
        case "right-end":
          return { top: f.bottom - x, left: f.right + t.offset };
        case "left":
          return { top: k - x / 2, left: f.left - h - t.offset };
        case "left-start":
          return { top: f.top, left: f.left - h - t.offset };
        case "left-end":
          return { top: f.bottom - x, left: f.left - h - t.offset };
      }
    }
    function p() {
      if (!t.triggerRef || !t.visible) return;
      const v = t.triggerRef.getBoundingClientRect(), f = t.matchTriggerWidth ? v.width : 0, h = Math.max(n.value?.offsetWidth || 224, f), x = n.value?.offsetHeight || 0, S = 8, k = window.innerWidth, M = window.innerHeight;
      let F = t.placement;
      if (t.flip) {
        if (F.startsWith("bottom")) {
          const j = M - v.bottom - t.offset - S, J = v.top - t.offset - S;
          x > j && J > j && (F = m(F));
        } else if (F.startsWith("top")) {
          const j = v.top - t.offset - S, J = M - v.bottom - t.offset - S;
          x > j && J > j && (F = m(F));
        }
      }
      u.value = F, a("update:resolvedPlacement", F);
      const V = y(F, v, h, x);
      let B;
      t.constrainHeight && (F.startsWith("top") ? B = v.top - t.offset - S : F.startsWith("bottom") ? B = M - v.bottom - t.offset - S : B = M - S * 2, B = Math.max(B, 80));
      const O = t.matchTriggerWidth ? f : t.minWidthPx ?? 0;
      if (t.positioning === "center") {
        o.value = {
          position: "fixed",
          top: "50%",
          left: "50%",
          zIndex: "9999",
          ...O > 0 ? { minWidth: `${O}px` } : {},
          ...B !== void 0 ? { maxHeight: `${B}px` } : {}
        };
        return;
      }
      o.value = {
        position: "fixed",
        top: `${Math.max(S, Math.min(V.top, M - x - S))}px`,
        left: `${Math.max(S, Math.min(V.left, k - h - S))}px`,
        zIndex: "9999",
        ...O > 0 ? { minWidth: `${O}px` } : {},
        ...B !== void 0 ? { maxHeight: `${B}px` } : {}
      };
    }
    function b(v) {
      if (!t.visible) return;
      const f = v.target, h = !!f && !!t.triggerRef?.contains(f), x = !!f && !!n.value?.contains(f);
      !h && !x && (a("update:visible", !1), a("close"));
    }
    function L() {
      const v = document.activeElement;
      v instanceof HTMLIFrameElement && (t.triggerRef?.contains(v) || n.value?.contains(v) || (a("update:visible", !1), a("close")));
    }
    function c(v) {
      if (t.visible && !(n.value && v.composedPath().includes(n.value))) {
        if (t.closeOnScroll) {
          a("update:visible", !1), a("close");
          return;
        }
        p();
      }
    }
    return me(() => t.visible, async (v) => {
      v ? (await pe(), p(), t.closeOnClickOutside && window.addEventListener("pointerdown", b, !0), t.closeOnClickOutside && window.addEventListener("blur", L), window.addEventListener("resize", p), window.addEventListener("scroll", c, !0), n.value && (d = new ResizeObserver(p), d.observe(n.value))) : (window.removeEventListener("pointerdown", b, !0), window.removeEventListener("blur", L), window.removeEventListener("resize", p), window.removeEventListener("scroll", c, !0), d?.disconnect(), d = null);
    }), Ie(() => {
      window.removeEventListener("pointerdown", b, !0), window.removeEventListener("blur", L), window.removeEventListener("resize", p), window.removeEventListener("scroll", c, !0), d?.disconnect();
    }), (v, f) => (l(), _(De, {
      to: "body",
      disabled: !e.teleport
    }, [
      U(we, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": `transform scale-95 opacity-0 ${u.value.startsWith("top") ? "translate-y-2" : "-translate-y-2"}`,
        "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "transform scale-100 opacity-100 translate-y-0",
        "leave-to-class": `transform scale-95 opacity-0 ${u.value.startsWith("top") ? "translate-y-2" : "-translate-y-2"}`
      }, {
        default: ne(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            ref_key: "popoverRef",
            ref: n,
            style: re(e.teleport ? o.value : {}),
            class: E(["base-popover-surface rounded-xl shadow-2xl border z-50 overflow-hidden", [e.width, e.className, e.padding, e.teleport ? "fixed" : "absolute mt-2", e.constrainHeight ? "flex flex-col" : ""]]),
            onMouseenter: f[0] || (f[0] = (h) => a("popover-mouseenter")),
            onMouseleave: f[1] || (f[1] = (h) => a("popover-mouseleave"))
          }, [
            N(v.$slots, "default", {}, void 0, !0)
          ], 38)) : w("", !0)
        ]),
        _: 3
      }, 8, ["enter-from-class", "leave-to-class"])
    ], 8, ["disabled"]));
  }
}), Ot = /* @__PURE__ */ ce(Za, [["__scopeId", "data-v-816f7050"]]), Ja = /* @__PURE__ */ ae({
  inheritAttrs: !1,
  __name: "BasePopoverButton",
  props: {
    visible: { type: Boolean },
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: {},
    label: {},
    loadingLabel: { default: "Loading" },
    block: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    align: { default: "center" },
    display: { default: "inline-flex" },
    showChevron: { type: Boolean, default: !0 },
    chevronIcon: { default: "ChevronDown" },
    chevronSize: { default: 15 },
    chevronRotateOn: { default: "open" },
    hasPopup: {},
    placement: { default: "bottom" },
    offset: { default: 8 },
    teleport: { type: Boolean, default: !0 },
    popoverWidth: { default: "w-56" },
    popoverClassName: { default: "" },
    popoverPadding: { default: "py-2" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnScroll: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 },
    matchTriggerWidth: { type: Boolean, default: !1 },
    minWidthPx: {},
    constrainHeight: { type: Boolean, default: !1 }
  },
  emits: ["update:visible", "click", "open", "close"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = R(null), u = C(() => {
      const c = o.value?.$el;
      return c instanceof HTMLElement ? c : null;
    }), d = R(a.placement), m = C(() => a.visible ? d.value : a.placement), y = C(() => ({
      "rotate-180": m.value.startsWith("top") ? a.chevronRotateOn === "open" ? !a.visible : a.visible : a.chevronRotateOn === "open" ? a.visible : !a.visible
    }));
    function p(c) {
      c !== a.visible && (n("update:visible", c), n(c ? "open" : "close"));
    }
    function b(c) {
      n("click", c), p(!a.visible);
    }
    function L() {
      p(!1);
    }
    return r({ close: L, triggerRef: u }), (c, v) => (l(), s(te, null, [
      U(at, We({
        ref_key: "triggerComponent",
        ref: o
      }, c.$attrs, {
        variant: e.variant,
        size: e.size,
        type: e.type,
        disabled: e.disabled,
        loading: e.loading,
        icon: e.icon,
        label: e.label,
        "loading-label": e.loadingLabel,
        block: e.block,
        rounded: e.rounded,
        align: e.align,
        display: e.display,
        "aria-haspopup": e.hasPopup,
        "aria-expanded": e.visible,
        onClick: b
      }), At({
        end: ne(() => [
          N(c.$slots, "end"),
          e.showChevron ? (l(), _(X, {
            key: 0,
            name: e.chevronIcon,
            size: e.chevronSize,
            class: E(["ml-auto transition-transform duration-200", y.value]),
            decorative: ""
          }, null, 8, ["name", "size", "class"])) : w("", !0)
        ]),
        _: 2
      }, [
        c.$slots.default ? {
          name: "default",
          fn: ne(() => [
            N(c.$slots, "default")
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["variant", "size", "type", "disabled", "loading", "icon", "label", "loading-label", "block", "rounded", "align", "display", "aria-haspopup", "aria-expanded"]),
      U(Ot, {
        visible: e.visible,
        "onUpdate:visible": p,
        "onUpdate:resolvedPlacement": v[0] || (v[0] = (f) => d.value = f),
        "trigger-ref": u.value,
        placement: e.placement,
        offset: e.offset,
        teleport: e.teleport,
        width: e.popoverWidth,
        "class-name": e.popoverClassName,
        padding: e.popoverPadding,
        "close-on-click-outside": e.closeOnClickOutside,
        "close-on-scroll": e.closeOnScroll,
        flip: e.flip,
        "match-trigger-width": e.matchTriggerWidth,
        "min-width-px": e.minWidthPx,
        "constrain-height": e.constrainHeight
      }, {
        default: ne(() => [
          N(c.$slots, "popover")
        ]),
        _: 3
      }, 8, ["visible", "trigger-ref", "placement", "offset", "teleport", "width", "class-name", "padding", "close-on-click-outside", "close-on-scroll", "flip", "match-trigger-width", "min-width-px", "constrain-height"])
    ], 64));
  }
}), jt = R(typeof window < "u" ? window.innerWidth : 1024);
typeof window < "u" && window.addEventListener("resize", () => {
  jt.value = window.innerWidth;
}, { passive: !0 });
function Ft(e = 640) {
  return C(() => jt.value < e);
}
const _e = /* @__PURE__ */ new Set();
let ht = null;
function Qa(e) {
  typeof document > "u" || _e.has(e) || (_e.size === 0 && (ht = document.body.style.overflow), _e.add(e), document.body.style.overflow = "hidden");
}
function _a(e) {
  typeof document > "u" || !_e.delete(e) || _e.size === 0 && (document.body.style.overflow = ht ?? "", ht = null);
}
const el = ["for"], tl = ["id", "disabled", "aria-expanded", "aria-label", "aria-invalid", "aria-controls", "aria-activedescendant", "aria-describedby"], al = {
  key: 0,
  class: "px-3 py-2 border-b border-gray-100 dark:border-dark-200"
}, ll = ["placeholder"], rl = ["id", "aria-multiselectable"], nl = ["data-selected", "aria-selected"], sl = { class: "truncate" }, ol = {
  key: 0,
  class: "base-select-radio-dot"
}, il = {
  key: 1,
  class: "px-4 py-3 text-sm text-gray-500 text-center"
}, ul = {
  key: 0,
  class: "base-select-group-label px-3 pt-3 pb-1 text-[11px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400",
  role: "presentation",
  "aria-hidden": "true"
}, dl = ["data-selected", "id", "aria-selected", "onClick"], cl = { class: "flex items-center gap-2 min-w-0" }, fl = { class: "truncate" }, ml = {
  key: 0,
  class: "base-select-radio-dot"
}, vl = {
  key: 2,
  class: "px-4 py-8 text-center text-xs text-gray-400 dark:text-gray-500 italic font-medium"
}, bl = ["id"], hl = /* @__PURE__ */ ae({
  __name: "BaseSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: {},
    disabled: { type: Boolean },
    error: { type: [Boolean, String] },
    id: {},
    ariaLabel: {},
    size: { default: "md" },
    variant: { default: "default" },
    dropdownClass: {},
    showFocusRing: { type: Boolean, default: !0 },
    multiple: { type: Boolean, default: !1 },
    hideChevron: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search..." },
    emptySearchText: { default: "No matching options" },
    emptyOptionsText: { default: "No options" },
    scrollSelectedIntoView: { type: Boolean, default: !0 },
    autoSave: {},
    dropdownPlacement: { default: "bottom-start" }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = R(!1), u = Jt(), d = C(() => a.id ?? `${u}-trigger`), m = C(() => `${d.value}-listbox`), y = R(-1), p = R(null), b = R(""), L = R(null), c = R(null), v = Ft(), f = /* @__PURE__ */ Symbol("BaseSelectMobileScrollLock"), h = C(() => {
      if (a.multiple && Array.isArray(a.modelValue)) {
        const G = a.modelValue;
        return a.options.filter((Q) => G.includes(Q.value));
      }
      const q = a.options.find((G) => G.value === a.modelValue);
      return q ? [q] : [];
    }), x = C(() => {
      if (!a.searchable || !b.value) return a.options;
      const q = b.value.toLowerCase();
      return a.options.filter((G) => G.label.toLowerCase().includes(q) || String(G.value).toLowerCase().includes(q));
    }), S = C(() => a.multiple ? h.value.map((q) => q.label).join(", ") : h.value[0]?.label ?? "");
    function k() {
      a.disabled || (o.value = !o.value, o.value && n("focus"));
    }
    function M() {
      o.value = !1;
    }
    function F() {
      a.disabled || (o.value = !0, n("focus"));
    }
    function V(q) {
      return `${m.value}-option-${q}`;
    }
    function B() {
      const q = x.value.findIndex((G) => $(G));
      y.value = q >= 0 ? q : -1;
    }
    function O() {
      y.value < 0 || document.getElementById(V(y.value))?.scrollIntoView({ block: "nearest" });
    }
    function j(q) {
      if (!a.disabled)
        if (q.key === "ArrowDown" || q.key === "ArrowUp") {
          if (q.preventDefault(), !o.value) {
            F(), pe(() => {
              const be = x.value.length;
              y.value = be ? q.key === "ArrowDown" ? 0 : be - 1 : -1;
            });
            return;
          }
          const G = x.value.length;
          if (!G) return;
          const Q = q.key === "ArrowDown" ? 1 : -1;
          y.value = y.value < 0 ? Q > 0 ? 0 : G - 1 : (y.value + Q + G) % G, pe(O);
        } else if ((q.key === "Enter" || q.key === " ") && o.value) {
          q.preventDefault();
          const G = x.value[y.value];
          G && J(G);
        } else q.key === "Escape" && o.value && (q.preventDefault(), M());
    }
    r({
      close: M,
      open: F,
      toggle: k
    }), me(o, (q) => {
      if (!q) {
        n("blur");
        return;
      }
      a.searchable && (b.value = "", pe(() => L.value?.focus())), B(), a.scrollSelectedIntoView && pe(() => {
        c.value?.querySelector('[data-selected="true"]')?.scrollIntoView({ block: "nearest" });
      });
    }), me(x, () => {
      o.value && B();
    });
    function J(q) {
      y.value = x.value.findIndex((Q) => Q.value === q.value);
      let G;
      if (a.multiple) {
        const Q = Array.isArray(a.modelValue) ? [...a.modelValue] : [], be = Q.indexOf(q.value);
        be > -1 ? Q.splice(be, 1) : Q.push(q.value), G = Q;
      } else
        G = q.value, o.value = !1;
      n("update:modelValue", G), n("change", G), a.autoSave?.();
    }
    function $(q) {
      return a.multiple && Array.isArray(a.modelValue) ? a.modelValue.includes(q.value) : a.modelValue === q.value;
    }
    const A = C(() => ({ label: a.placeholder ?? "", value: "" })), z = C(() => a.error === !0 || typeof a.error == "string" && a.error.trim() !== ""), K = C(() => typeof a.error == "string" ? a.error : ""), de = C(() => [
      "base-select-dropdown",
      v.value ? "base-select-mobile-modal" : "",
      a.dropdownClass
    ].filter(Boolean).join(" "));
    function ue(q, G) {
      typeof document > "u" || (q && G ? Qa(f) : _a(f));
    }
    me([o, v], ([q, G]) => {
      ue(q, G);
    }), Ie(() => {
      ue(!1, !1);
    });
    const ie = C(() => {
      const q = "font-medium outline-none w-full cursor-pointer transition-all duration-200 flex items-center justify-between text-left";
      if (z.value)
        return `${q} bg-gray-50 dark:bg-red-900/10 border border-red-300 dark:border-red-800 ring-2 ring-red-100 dark:ring-red-900/30 text-red-900 dark:text-red-400 rounded-lg`;
      switch (a.variant) {
        case "filled":
          return `${q} bg-surface-muted border border-transparent focus:bg-surface focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui rounded-lg`;
        case "outlined":
          return `${q} bg-transparent border-2 border-ui-strong focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui rounded-lg`;
        case "plain":
          return `${q} bg-transparent border-0 focus:ring-0 text-ui-muted p-0 h-full w-auto min-w-0 flex-shrink-0`;
        default:
          return `${q} bg-surface border border-ui focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui-muted shadow-sm rounded-lg`;
      }
    }), ge = C(() => a.size === "sm" ? a.variant === "plain" ? "text-xs" : "h-8 px-3 text-xs" : a.size === "lg" ? "h-12 px-5 text-base rounded-xl" : a.variant === "plain" ? "text-sm" : "h-10 px-4 text-sm");
    return (q, G) => (l(), s("div", {
      class: E(["w-full", { "flex flex-col gap-1.5": e.label }])
    }, [
      e.label ? (l(), s("label", {
        key: 0,
        for: d.value,
        class: "block text-[11px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-widest px-0.5"
      }, I(e.label), 9, el)) : w("", !0),
      i("div", {
        ref_key: "triggerRef",
        ref: p,
        class: "relative group h-full"
      }, [
        i("button", {
          id: d.value,
          type: "button",
          disabled: e.disabled,
          "aria-haspopup": "listbox",
          "aria-expanded": o.value,
          "aria-label": e.ariaLabel || e.label,
          "aria-invalid": z.value || void 0,
          "aria-controls": m.value,
          "aria-activedescendant": o.value && y.value >= 0 ? V(y.value) : void 0,
          "aria-describedby": z.value ? `${d.value}-error` : void 0,
          class: E(["disabled:bg-surface-muted disabled:text-ui-dim disabled:cursor-not-allowed disabled:opacity-60", ["group flex items-center justify-between transition-all duration-200 overflow-hidden min-w-0", ie.value, ge.value, o.value && e.showFocusRing ? "ring-2 ring-primary/20 border-primary" : ""]]),
          onClick: k,
          onKeydown: j
        }, [
          N(q.$slots, "selected", { selectedOptions: h.value }, () => [
            i("span", {
              class: E(["min-w-0 truncate grow", { "text-gray-400 dark:text-gray-500": !S.value }])
            }, I(S.value || e.placeholder), 3)
          ], !0),
          e.hideChevron ? w("", !0) : (l(), _(X, {
            key: 0,
            name: "ChevronDown",
            size: 16,
            class: E(["ml-2 shrink-0 transition-transform duration-200", { "rotate-180": o.value }])
          }, null, 8, ["class"]))
        ], 42, tl),
        (l(), _(De, { to: "body" }, [
          U(we, {
            "enter-active-class": "transition-opacity duration-200",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition-opacity duration-150",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: ne(() => [
              o.value && Z(v) ? (l(), s("div", {
                key: 0,
                class: "base-select-mobile-backdrop",
                "aria-hidden": "true",
                onClick: M
              })) : w("", !0)
            ]),
            _: 1
          })
        ])),
        U(Ot, {
          visible: o.value,
          "onUpdate:visible": G[4] || (G[4] = (Q) => o.value = Q),
          "trigger-ref": p.value,
          placement: e.dropdownPlacement,
          flip: !0,
          positioning: Z(v) ? "center" : "anchor",
          "match-trigger-width": e.variant !== "plain" && !Z(v),
          "min-width-px": e.variant === "plain" && !Z(v) ? 120 : void 0,
          width: Z(v) ? "" : "w-56",
          padding: Z(v) ? "" : "py-1.5",
          "class-name": de.value
        }, {
          default: ne(() => [
            e.searchable ? (l(), s("div", al, [
              xt(i("input", {
                ref_key: "searchInputRef",
                ref: L,
                "onUpdate:modelValue": G[0] || (G[0] = (Q) => b.value = Q),
                type: "text",
                placeholder: e.searchPlaceholder,
                class: "w-full bg-gray-50 dark:bg-dark-50 border border-gray-200 dark:border-dark-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 dark:text-dark-text",
                onClick: G[1] || (G[1] = fe(() => {
                }, ["stop"])),
                onKeydown: G[2] || (G[2] = fe(() => {
                }, ["stop"]))
              }, null, 40, ll), [
                [Rt, b.value]
              ])
            ])) : w("", !0),
            i("div", {
              id: m.value,
              ref_key: "optionsScrollRef",
              ref: c,
              class: "base-select-options overflow-y-auto custom-scrollbar max-h-60",
              role: "listbox",
              "aria-multiselectable": e.multiple || void 0
            }, [
              e.placeholder && !e.multiple ? (l(), s("div", {
                key: 0,
                "data-selected": $(A.value) ? "true" : void 0,
                class: E(["base-select-option base-select-placeholder-option px-4 py-2 text-xs font-bold uppercase tracking-tight cursor-pointer hover:bg-gray-50 dark:hover:bg-dark-50/50 transition-colors", [$(A.value) ? "font-bold" : "text-gray-400 dark:text-dark-text-dim"]]),
                role: "option",
                "aria-selected": $(A.value),
                onClick: G[3] || (G[3] = (Q) => J(A.value))
              }, [
                i("span", sl, I(e.placeholder), 1),
                Z(v) && !e.multiple ? (l(), s("span", {
                  key: 0,
                  class: E(["base-select-radio", { "base-select-radio-selected": $(A.value) }]),
                  "aria-hidden": "true"
                }, [
                  $(A.value) ? (l(), s("span", ol)) : w("", !0)
                ], 2)) : $(A.value) ? (l(), _(X, {
                  key: 1,
                  name: "Check",
                  size: 16,
                  class: "base-select-option-check text-primary shrink-0 ml-2"
                })) : w("", !0)
              ], 10, nl)) : w("", !0),
              x.value.length === 0 ? (l(), s("div", il, I(e.emptySearchText), 1)) : w("", !0),
              (l(!0), s(te, null, oe(x.value, (Q) => (l(), s("div", {
                key: Q.value,
                class: "contents"
              }, [
                Q.group && x.value[x.value.indexOf(Q) - 1]?.group !== Q.group ? (l(), s("div", ul, I(Q.group), 1)) : w("", !0),
                i("div", {
                  "data-selected": $(Q) ? "true" : void 0,
                  id: V(x.value.indexOf(Q)),
                  class: E(["base-select-option px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer flex items-center justify-between gap-4 flex-nowrap", [$(Q) ? "font-bold" : "", y.value === x.value.indexOf(Q) ? "ring-1 ring-inset ring-primary/40" : ""]]),
                  role: "option",
                  "aria-selected": $(Q),
                  onClick: (be) => J(Q)
                }, [
                  i("div", cl, [
                    N(q.$slots, "option", {
                      option: Q,
                      isSelected: $(Q)
                    }, () => [
                      Q.icon ? (l(), _(X, {
                        key: 0,
                        name: Q.icon,
                        size: 14
                      }, null, 8, ["name"])) : w("", !0),
                      i("span", fl, I(Q.label), 1)
                    ], !0)
                  ]),
                  Z(v) && !e.multiple ? (l(), s("span", {
                    key: 0,
                    class: E(["base-select-radio", { "base-select-radio-selected": $(Q) }]),
                    "aria-hidden": "true"
                  }, [
                    $(Q) ? (l(), s("span", ml)) : w("", !0)
                  ], 2)) : $(Q) ? (l(), _(X, {
                    key: 1,
                    name: "Check",
                    size: 16,
                    class: "base-select-option-check text-primary shrink-0 ml-2"
                  })) : w("", !0)
                ], 10, dl)
              ]))), 128)),
              e.options.length === 0 ? (l(), s("div", vl, I(e.emptyOptionsText), 1)) : w("", !0)
            ], 8, rl)
          ]),
          _: 3
        }, 8, ["visible", "trigger-ref", "placement", "positioning", "match-trigger-width", "min-width-px", "width", "padding", "class-name"])
      ], 512),
      z.value && K.value ? (l(), s("p", {
        key: 1,
        id: z.value ? `${d.value}-error` : void 0,
        class: "mt-1 text-[11px] text-red-500 font-medium flex items-center gap-1 px-1"
      }, [
        U(X, {
          name: "AlertCircle",
          size: 11
        }),
        $e(" " + I(K.value), 1)
      ], 8, bl)) : w("", !0)
    ], 2));
  }
}), gt = /* @__PURE__ */ ce(hl, [["__scopeId", "data-v-cf62f1c0"]]), gl = { key: 0 }, ni = /* @__PURE__ */ ae({
  __name: "BaseTag",
  props: {
    label: {},
    severity: { default: "secondary" },
    icon: {},
    rounded: { type: Boolean, default: !1 },
    variant: { default: "subtle" },
    size: { default: "md" },
    class: {}
  },
  setup(e) {
    const r = e, t = C(() => {
      const o = r.variant === "outline", u = r.variant === "filled";
      switch (r.severity) {
        case "success":
          return u ? "bg-success text-surface-inverse border-success" : o ? "bg-transparent text-success border-success" : "bg-success/10 text-success border-success/30";
        case "info":
          return u ? "bg-info text-surface-inverse border-info" : o ? "bg-transparent text-info border-info" : "bg-info/10 text-info border-info/30";
        case "warning":
          return u ? "bg-warning text-surface-inverse border-warning" : o ? "bg-transparent text-warning border-warning" : "bg-warning/10 text-warning border-warning/30";
        case "danger":
          return u ? "bg-danger text-surface-inverse border-danger" : o ? "bg-transparent text-danger border-danger" : "bg-danger/10 text-danger border-danger/30";
        case "primary":
          return u ? "bg-primary text-surface-inverse border-primary" : o ? "bg-transparent text-primary border-primary" : "bg-primary/10 dark:bg-primary/20 text-primary border-primary/20 dark:border-primary/30";
        default:
          return u ? "bg-surface-inverse text-surface border-surface-inverse" : o ? "bg-transparent text-ui-muted border-ui-strong" : "bg-surface-muted text-ui-muted border-ui";
      }
    }), a = C(() => r.size === "sm" ? "px-2 py-0.5 text-[0.65rem] gap-1" : r.size === "lg" ? "px-4 py-1.5 text-base gap-2" : "px-2.5 py-1 text-xs gap-1.5"), n = C(() => r.size === "sm" ? 12 : r.size === "lg" ? 18 : 14);
    return (o, u) => (l(), s("div", {
      class: E(["inline-flex items-center font-medium border transition-colors duration-200", [t.value, a.value, e.rounded ? "rounded-full" : "rounded-md", r.class]])
    }, [
      e.icon ? (l(), _(X, {
        key: 0,
        name: e.icon,
        size: n.value
      }, null, 8, ["name", "size"])) : w("", !0),
      N(o.$slots, "default", {}, () => [
        e.label ? (l(), s("span", gl, I(e.label), 1)) : w("", !0)
      ])
    ], 2));
  }
});
let Ne = null;
function yl(e) {
  Ne && Ne !== e && Ne(), Ne = e;
}
function Ct(e) {
  Ne === e && (Ne = null);
}
const pl = { class: "cursor-help text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400 transition-colors" }, xl = /* @__PURE__ */ ae({
  __name: "BaseTooltip",
  props: {
    text: {},
    widthClass: {},
    placement: { default: "top" },
    theme: { default: "dark" },
    fontSize: { default: "xs" },
    paddingClass: { default: "px-4 py-3" },
    maxWidth: { default: "320px" },
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const r = e, t = R(!1), a = R(!1);
    let n = null;
    const o = R(null), u = R(null), d = R({ top: "0px", left: "0px" }), m = R({ left: "50%" }), y = R(r.placement);
    function p() {
      n && (clearTimeout(n), n = null);
    }
    function b() {
      p(), a.value = !1, t.value = !1, Ct(b);
    }
    function L() {
      yl(b);
    }
    const c = C(
      () => r.theme === "dark" ? "border-white/10 bg-dark-200 text-dark-text" : "border-gray-100 bg-white text-gray-700"
    ), v = C(() => y.value === "top" ? r.theme === "dark" ? "top-full border-t-dark-200" : "top-full border-t-white" : r.theme === "dark" ? "bottom-full border-b-dark-200" : "bottom-full border-b-white");
    function f() {
      if (!o.value || !u.value) return;
      const B = o.value.getBoundingClientRect(), O = document.documentElement.clientWidth || window.innerWidth, j = document.documentElement.clientHeight || window.innerHeight, J = u.value.offsetWidth, $ = u.value.offsetHeight, A = 24, z = 16, K = B.left + B.width / 2 - J / 2, de = Math.min(Math.max(A, K), O - A - J);
      let ue = r.placement, ie = 0;
      r.placement === "top" ? B.top < $ + z + 10 ? (ue = "bottom", ie = B.bottom + z) : ie = B.top - z : j - B.bottom < $ + z + 10 ? (ue = "top", ie = B.top - z) : ie = B.bottom + z, y.value = ue, d.value = { left: `${de}px`, top: `${ie}px` }, m.value = { left: `${B.left + B.width / 2 - de}px` };
    }
    async function h() {
      a.value || (p(), L(), t.value = !0, await pe(), f(), setTimeout(f, 50));
    }
    function x() {
      a.value || (r.interactive ? n = setTimeout(() => {
        b();
      }, 150) : b());
    }
    async function S(B) {
      B.stopPropagation(), L(), a.value = !a.value, t.value = a.value, a.value || b(), t.value && (await pe(), f(), setTimeout(f, 50));
    }
    function k() {
      a.value && b();
    }
    let M = null;
    const F = () => {
      t.value && f();
    }, V = () => {
      t.value && f();
    };
    return wt(() => {
      window.addEventListener("scroll", F, !0), window.addEventListener("resize", V), M = new ResizeObserver(() => {
        t.value && f();
      }), document.addEventListener("click", k);
    }), Ie(() => {
      Ct(b), window.removeEventListener("scroll", F, !0), window.removeEventListener("resize", V), M?.disconnect(), document.removeEventListener("click", k);
    }), me(u, (B) => {
      B && M ? M.observe(B) : M?.disconnect();
    }), (B, O) => (l(), s("div", {
      ref_key: "iconRef",
      ref: o,
      class: "relative inline-block w-max",
      onMouseenter: h,
      onMouseleave: x,
      onClick: S
    }, [
      N(B.$slots, "trigger", {}, () => [
        i("div", pl, [
          U(X, {
            name: "HelpCircle",
            size: 16
          })
        ])
      ], !0),
      (l(), _(De, { to: "body" }, [
        U(we, { name: "tooltip-fade" }, {
          default: ne(() => [
            t.value ? (l(), s("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: u,
              class: E(["fixed rounded-xl border shadow-2xl z-10000 pointer-events-auto whitespace-pre-wrap wrap-break-word text-left leading-relaxed min-w-30", [c.value, e.paddingClass, e.fontSize === "sm" ? "text-sm" : e.fontSize === "base" ? "text-base" : "text-xs", e.widthClass || "w-max", y.value === "top" ? "-translate-y-full" : ""]]),
              style: re({
                ...d.value,
                maxWidth: e.maxWidth
              }),
              onMouseenter: h,
              onMouseleave: x
            }, [
              N(B.$slots, "default", {
                hide: () => t.value = !1
              }, () => [
                $e(I(e.text), 1)
              ], !0),
              i("div", {
                class: E(["absolute -translate-x-1/2 border-4 border-transparent", v.value]),
                style: re(m.value)
              }, null, 6)
            ], 38)) : w("", !0)
          ]),
          _: 3
        })
      ]))
    ], 544));
  }
}), si = /* @__PURE__ */ ce(xl, [["__scopeId", "data-v-bde2cca5"]]);
let yt = 0, et = null;
function wl() {
  et && (clearTimeout(et), et = null);
}
function Kt(e) {
  const r = Math.max(0, e);
  yt = Date.now() + r, wl(), et = setTimeout(() => {
    yt = 0, et = null;
  }, r);
}
function Nt() {
  return yt > Date.now();
}
const kl = /* @__PURE__ */ ae({
  __name: "BaseHoverLabel",
  props: {
    text: {},
    triggerClass: {},
    delay: { default: 450 },
    recentWindow: { default: 1500 },
    placement: { default: "bottom" },
    maxWidth: { default: "240px" }
  },
  setup(e) {
    const r = e, t = R(null), a = R(null), n = R(!1), o = R(!1), u = R({ top: "0px", left: "0px" });
    let d = null;
    function m() {
      d && (clearTimeout(d), d = null);
    }
    function y() {
      if (!t.value || !a.value || !n.value) return;
      const c = t.value.getBoundingClientRect(), v = a.value.getBoundingClientRect(), f = 6, h = 8, x = document.documentElement.clientWidth || window.innerWidth, S = document.documentElement.clientHeight || window.innerHeight, k = Math.max(h, x - v.width - h), M = Math.max(h, S - v.height - h), F = Math.min(
        Math.max(h, c.left + c.width / 2 - v.width / 2),
        k
      ), V = Math.min(Math.max(h, c.top + c.height / 2 - v.height / 2), M), B = c.bottom + f, O = c.top - v.height - f, j = B + v.height <= S - h, J = O >= h, $ = () => j ? B : J ? O : V, A = c.right + f, z = c.left - v.width - f, K = A + v.width <= x - h, de = z >= h;
      let ue = F, ie = $();
      r.placement === "right" ? K ? (ue = A, ie = V) : de && (ue = z, ie = V) : r.placement === "left" ? de ? (ue = z, ie = V) : K && (ue = A, ie = V) : r.placement === "top" && J ? ie = O : (r.placement === "bottom" && j || r.placement === "top" && j) && (ie = B), u.value = {
        top: `${Math.max(h, Math.min(ie, M))}px`,
        left: `${Math.max(h, Math.min(ue, k))}px`
      };
    }
    async function p() {
      if (m(), !!r.text) {
        if (Nt()) {
          n.value = !0, o.value = !0, await pe(), y();
          return;
        }
        d = setTimeout(async () => {
          n.value = !0, o.value = !0, await pe(), y();
        }, Math.max(0, r.delay));
      }
    }
    function b() {
      m(), n.value = !1, o.value && (o.value = !1, Kt(r.recentWindow));
    }
    function L() {
      n.value && y();
    }
    return me(n, (c) => {
      c ? (window.addEventListener("scroll", L, !0), window.addEventListener("resize", L)) : (window.removeEventListener("scroll", L, !0), window.removeEventListener("resize", L));
    }), Ie(() => {
      m(), window.removeEventListener("scroll", L, !0), window.removeEventListener("resize", L);
    }), (c, v) => (l(), s(te, null, [
      i("span", {
        ref_key: "triggerRef",
        ref: t,
        class: E(["inline-flex", r.triggerClass]),
        onMouseenter: p,
        onMouseleave: b,
        onClick: b
      }, [
        N(c.$slots, "trigger", {}, void 0, !0)
      ], 34),
      (l(), _(De, { to: "body" }, [
        U(we, { name: "base-hover-label-fade" }, {
          default: ne(() => [
            n.value && r.text ? (l(), s("span", {
              key: 0,
              ref_key: "labelRef",
              ref: a,
              role: "tooltip",
              class: "pointer-events-none fixed z-10000 w-max rounded-md border px-2 py-1 text-left text-xs font-semibold leading-4 shadow-lg whitespace-normal break-words",
              style: re({ ...u.value, backgroundColor: "var(--color-tooltip-surface)", borderColor: "var(--color-tooltip-border)", color: "var(--color-tooltip-text)", width: "max-content", maxWidth: `min(${r.maxWidth}, calc(100vw - 16px))` })
            }, I(r.text), 5)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), oi = /* @__PURE__ */ ce(kl, [["__scopeId", "data-v-c0139823"]]), st = {
  delay: 450,
  recentWindow: 1500,
  placement: "bottom",
  maxWidth: "240px"
};
function Ut(e) {
  const r = typeof e == "string" ? { text: e } : e ?? {};
  return {
    text: r.text,
    delay: r.delay ?? st.delay,
    recentWindow: r.recentWindow ?? st.recentWindow,
    placement: r.placement ?? st.placement,
    maxWidth: r.maxWidth ?? st.maxWidth
  };
}
function qt(e) {
  e.showTimer && (clearTimeout(e.showTimer), e.showTimer = null);
}
function kt(e, r) {
  if (!r.label || !r.visible) return;
  const t = e.getBoundingClientRect(), a = r.label.getBoundingClientRect(), n = 6, o = 8, u = document.documentElement.clientWidth || window.innerWidth, d = document.documentElement.clientHeight || window.innerHeight, m = Math.max(o, u - a.width - o), y = Math.max(o, d - a.height - o), p = Math.min(
    Math.max(o, t.left + t.width / 2 - a.width / 2),
    m
  ), b = Math.min(Math.max(o, t.top + t.height / 2 - a.height / 2), y), L = t.bottom + n, c = t.top - a.height - n, v = L + a.height <= d - o, f = c >= o, h = () => v ? L : f ? c : b, x = t.right + n, S = t.left - a.width - n, k = x + a.width <= u - o, M = S >= o;
  let F = p, V = h();
  r.options.placement === "right" ? k ? (F = x, V = b) : M && (F = S, V = b) : r.options.placement === "left" ? M ? (F = S, V = b) : k && (F = x, V = b) : r.options.placement === "top" && f ? V = c : (r.options.placement === "bottom" && v || r.options.placement === "top" && v) && (V = L), r.label.style.top = `${Math.max(o, Math.min(V, y))}px`, r.label.style.left = `${Math.max(o, Math.min(F, m))}px`;
}
function tt(e, r) {
  if (qt(r), r.visible = !1, r.label) {
    const t = r.label;
    t.style.opacity = "0", t.style.transform = "translateY(-2px)", window.setTimeout(() => {
      !r.visible && r.label === t && (t.remove(), r.label = null);
    }, 120);
  }
  r.hasShown && (r.hasShown = !1, Kt(r.options.recentWindow)), window.removeEventListener("scroll", r.refreshPosition, !0), window.removeEventListener("resize", r.refreshPosition);
}
function Lt(e, r) {
  if (qt(r), !r.options.text) return;
  const t = () => {
    if (!r.options.text || r.visible) return;
    r.label && (r.label.remove(), r.label = null);
    const a = document.createElement("span");
    a.dataset.baseHoverLabel = "true", a.setAttribute("role", "tooltip"), a.className = "pointer-events-none fixed z-[10000] w-max rounded-md border px-2 py-1 text-left text-xs font-semibold leading-4 shadow-lg whitespace-normal break-words", a.style.backgroundColor = "var(--color-tooltip-surface)", a.style.borderColor = "var(--color-tooltip-border)", a.style.color = "var(--color-tooltip-text)", a.style.boxShadow = "0 10px 24px var(--color-shadow, rgb(15 23 42 / 18%))", a.style.width = "max-content", a.style.maxWidth = `min(${r.options.maxWidth}, calc(100vw - 16px))`, a.style.opacity = "0", a.style.transform = "translateY(-2px)", a.style.transition = "opacity 120ms ease, transform 120ms ease", a.textContent = r.options.text, document.body.appendChild(a), r.label = a, r.visible = !0, r.hasShown = !0, kt(e, r), requestAnimationFrame(() => {
      r.label === a && r.visible && (a.style.opacity = "1", a.style.transform = "translateY(0)");
    }), window.addEventListener("scroll", r.refreshPosition, !0), window.addEventListener("resize", r.refreshPosition);
  };
  if (Nt()) {
    t();
    return;
  }
  r.showTimer = window.setTimeout(t, Math.max(0, r.options.delay));
}
function $l(e, r, t) {
  r.options = Ut(t), r.options.text || tt(e, r), r.label && (r.label.textContent = r.options.text ?? "", r.label.style.maxWidth = `min(${r.options.maxWidth}, calc(100vw - 16px))`, kt(e, r));
}
function Cl(e, r) {
  const t = {
    options: Ut(r),
    label: null,
    showTimer: null,
    hasShown: !1,
    visible: !1,
    onMouseEnter: () => Lt(e, t),
    onMouseLeave: () => tt(e, t),
    onFocusIn: () => Lt(e, t),
    onFocusOut: (a) => {
      a.relatedTarget instanceof Node && e.contains(a.relatedTarget) || tt(e, t);
    },
    onClick: () => tt(e, t),
    refreshPosition: () => kt(e, t)
  };
  return e.addEventListener("mouseenter", t.onMouseEnter), e.addEventListener("mouseleave", t.onMouseLeave), e.addEventListener("focusin", t.onFocusIn), e.addEventListener("focusout", t.onFocusOut), e.addEventListener("click", t.onClick), t;
}
function Ll(e, r) {
  tt(e, r), e.removeEventListener("mouseenter", r.onMouseEnter), e.removeEventListener("mouseleave", r.onMouseLeave), e.removeEventListener("focusin", r.onFocusIn), e.removeEventListener("focusout", r.onFocusOut), e.removeEventListener("click", r.onClick);
}
const ot = {
  mounted(e, r) {
    e.__baseHoverLabel = Cl(e, r.value);
  },
  updated(e, r) {
    const t = e.__baseHoverLabel;
    t && $l(e, t, r.value);
  },
  unmounted(e) {
    const r = e.__baseHoverLabel;
    r && Ll(e, r), delete e.__baseHoverLabel;
  }
}, Sl = { class: "w-full" }, zl = {
  key: 0,
  class: "flex justify-between mb-1"
}, ii = /* @__PURE__ */ ae({
  __name: "BaseProgressBar",
  props: {
    value: { default: 0 },
    showValue: { type: Boolean, default: !0 },
    variant: { default: "primary" },
    size: { default: "md" },
    height: {}
  },
  setup(e) {
    const r = e, t = C(() => {
      if (r.height) return r.height;
      switch (r.size) {
        case "sm":
          return "h-1.5";
        case "lg":
          return "h-4";
        default:
          return "h-2.5";
      }
    }), a = C(() => {
      switch (r.variant) {
        case "success":
          return "bg-green-500";
        case "warning":
          return "bg-yellow-500";
        case "danger":
          return "bg-red-600";
        default:
          return "bg-primary";
      }
    }), n = C(() => Math.min(Math.max(r.value, 0), 100));
    return (o, u) => (l(), s("div", Sl, [
      e.showValue ? (l(), s("div", zl, [
        i("span", {
          class: E(["text-xs font-medium", {
            "text-primary": e.variant === "primary",
            "text-green-500": e.variant === "success",
            "text-yellow-500": e.variant === "warning",
            "text-red-600": e.variant === "danger"
          }])
        }, I(n.value) + "% ", 3)
      ])) : w("", !0),
      i("div", {
        class: E(["w-full bg-gray-200 rounded-full dark:bg-dark-200 overflow-hidden", [e.height && !e.height.startsWith("h-") ? "" : t.value]]),
        style: re(e.height && !e.height.startsWith("h-") ? { height: e.height } : {})
      }, [
        i("div", {
          class: E(["rounded-full transition-all duration-500 ease-out", [a.value, t.value]]),
          style: re({ width: `${n.value}%`, ...e.height && !e.height.startsWith("h-") ? { height: e.height } : {} })
        }, null, 6)
      ], 6)
    ]));
  }
});
function Bl({
  scrollElement: e,
  refresh: r,
  enabled: t = !0,
  threshold: a = 64,
  maxDistance: n = 140,
  loadingDistance: o = 56,
  visibleDistance: u = 16,
  topTolerance: d = 0.5,
  interactiveSelector: m = 'button, a, input, textarea, select, [contenteditable="true"]',
  onError: y
}) {
  const p = R(0), b = R(!1), L = R(!1), c = C(() => p.value >= a), v = C(() => L.value || p.value >= u), f = C(() => Math.min(p.value / a, 1));
  let h = null, x = null;
  function S() {
    h = null, b.value = !1, L.value || (p.value = 0);
  }
  function k(B) {
    const O = e.value;
    if (L.value || !Ue(t) || !O || O.scrollTop > d || B.touches.length !== 1 || B.target instanceof Element && B.target.closest(m)) return;
    const j = B.touches[0];
    h = { x: j.clientX, y: j.clientY };
  }
  function M(B) {
    const O = e.value;
    if (!h || !O || B.touches.length !== 1) return;
    if (!Ue(t) || O.scrollTop > d) {
      S();
      return;
    }
    const j = B.touches[0], J = j.clientX - h.x, $ = j.clientY - h.y;
    if ($ <= 0 || Math.abs(J) > Math.abs($)) {
      S();
      return;
    }
    B.preventDefault(), b.value = !0, p.value = Math.min($, n);
  }
  async function F() {
    if (!h) return;
    const B = c.value;
    if (h = null, b.value = !1, !B) {
      p.value = 0;
      return;
    }
    L.value = !0, p.value = o;
    try {
      await r();
    } catch (O) {
      y?.(O);
    } finally {
      L.value = !1, p.value = 0;
    }
  }
  function V(B) {
    x?.(), x = null, B && (B.addEventListener("touchstart", k, { passive: !0 }), B.addEventListener("touchmove", M, { passive: !1 }), B.addEventListener("touchend", F, { passive: !0 }), B.addEventListener("touchcancel", S, { passive: !0 }), x = () => {
      B.removeEventListener("touchstart", k), B.removeEventListener("touchmove", M), B.removeEventListener("touchend", F), B.removeEventListener("touchcancel", S);
    });
  }
  return me(e, V, { flush: "post", immediate: !0 }), me(() => Ue(t), (B) => {
    B || S();
  }), Ie(() => x?.()), {
    pullDistance: p,
    pullDragging: b,
    pullProgress: f,
    pullReady: c,
    pullRefreshing: L,
    pullVisible: v,
    resetGesture: S
  };
}
const Tl = ["aria-label", "aria-busy", "data-refreshing"], El = /* @__PURE__ */ ae({
  __name: "BasePullToRefresh",
  props: {
    refresh: {},
    enabled: { type: Boolean, default: !0 },
    threshold: { default: 64 },
    maxDistance: { default: 140 },
    loadingDistance: { default: 56 },
    visibleDistance: { default: 16 },
    topTolerance: { default: 0.5 },
    interactiveSelector: { default: 'button, a, input, textarea, select, [contenteditable="true"]' },
    theme: { default: "auto" },
    indicatorLabel: { default: "Refresh" }
  },
  emits: ["refreshStart", "refreshEnd", "refreshError"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = R(null), u = C(() => a.enabled);
    async function d() {
      n("refreshStart");
      try {
        await a.refresh();
      } catch (h) {
        throw n("refreshError", h), h;
      } finally {
        n("refreshEnd");
      }
    }
    const {
      pullDistance: m,
      pullDragging: y,
      pullProgress: p,
      pullReady: b,
      pullRefreshing: L,
      pullVisible: c
    } = Bl({
      scrollElement: o,
      refresh: d,
      enabled: u,
      threshold: a.threshold,
      maxDistance: a.maxDistance,
      loadingDistance: a.loadingDistance,
      visibleDistance: a.visibleDistance,
      topTolerance: a.topTolerance,
      interactiveSelector: a.interactiveSelector
    }), v = C(() => ({ height: `${m.value}px` })), f = C(() => L.value ? void 0 : { transform: `rotate(${m.value * 4.5}deg)` });
    return r({
      scrollElement: o,
      pullDistance: m,
      pullDragging: y,
      pullProgress: p,
      pullReady: b,
      pullRefreshing: L,
      pullVisible: c
    }), (h, x) => (l(), s("div", {
      ref_key: "scrollElement",
      ref: o,
      class: E(["base-pull-to-refresh", [`base-pull-to-refresh--${e.theme}`, { "base-pull-to-refresh--dragging": Z(y) }]]),
      "data-pull-to-refresh-part": "scroll"
    }, [
      i("div", {
        class: "base-pull-to-refresh__gap",
        style: re(v.value),
        "data-pull-to-refresh-part": "gap"
      }, [
        Z(c) ? N(h.$slots, "indicator", {
          distance: Z(m),
          progress: Z(p),
          ready: Z(b),
          refreshing: Z(L)
        }, () => [
          i("div", {
            class: E(["base-pull-to-refresh__indicator", { "base-pull-to-refresh__indicator--ready": Z(b) || Z(L) }]),
            "aria-label": e.indicatorLabel,
            "aria-busy": Z(L),
            "data-refreshing": Z(L) ? "true" : "false",
            "data-pull-to-refresh-part": "indicator",
            role: "status"
          }, [
            U(Z(Pt), {
              class: E(["base-pull-to-refresh__icon", { "base-pull-to-refresh__icon--refreshing": Z(L) }]),
              style: re(f.value),
              "data-pull-to-refresh-part": "icon"
            }, null, 8, ["class", "style"])
          ], 10, Tl)
        ], !0, 0) : w("", !0)
      ], 4),
      N(h.$slots, "default", {
        distance: Z(m),
        dragging: Z(y),
        progress: Z(p),
        ready: Z(b),
        refreshing: Z(L)
      }, void 0, !0)
    ], 2));
  }
}), ui = /* @__PURE__ */ ce(El, [["__scopeId", "data-v-8a58d4fc"]]);
function Ml({
  gestureElement: e,
  refresh: r,
  enabled: t = !0,
  threshold: a = 64,
  maxDistance: n = 140,
  loadingDistance: o = 56,
  visibleDistance: u = 16,
  interactiveSelector: d = 'button, a, input, textarea, select, [contenteditable="true"]',
  onError: m
}) {
  const y = R(0), p = R(!1), b = R(!1), L = C(() => y.value >= a), c = C(() => b.value || y.value >= u), v = C(() => Math.min(y.value / a, 1));
  let f = null, h = null;
  function x() {
    f = null, p.value = !1, b.value || (y.value = 0);
  }
  function S(V) {
    const B = e.value;
    if (b.value || !Ue(t) || !B || V.touches.length !== 1 || V.target instanceof Element && V.target.closest(d)) return;
    const O = V.touches[0];
    f = { x: O.clientX, y: O.clientY };
  }
  function k(V) {
    const B = e.value;
    if (!f || !B || V.touches.length !== 1) return;
    if (!Ue(t)) {
      x();
      return;
    }
    const O = V.touches[0], j = O.clientX - f.x, J = O.clientY - f.y;
    if (J <= 0 || Math.abs(j) > Math.abs(J)) {
      x();
      return;
    }
    V.preventDefault(), p.value = !0, y.value = Math.min(J, n);
  }
  async function M() {
    if (!f) return;
    const V = L.value;
    if (f = null, p.value = !1, !V) {
      y.value = 0;
      return;
    }
    b.value = !0, y.value = o;
    try {
      await r();
    } catch (B) {
      m?.(B);
    } finally {
      b.value = !1, y.value = 0;
    }
  }
  function F(V) {
    h?.(), h = null, V && (V.addEventListener("touchstart", S, { passive: !0 }), V.addEventListener("touchmove", k, { passive: !1 }), V.addEventListener("touchend", M, { passive: !0 }), V.addEventListener("touchcancel", x, { passive: !0 }), h = () => {
      V.removeEventListener("touchstart", S), V.removeEventListener("touchmove", k), V.removeEventListener("touchend", M), V.removeEventListener("touchcancel", x);
    });
  }
  return me(e, F, { flush: "post", immediate: !0 }), me(() => Ue(t), (V) => {
    V || x();
  }), Ie(() => h?.()), {
    pullDistance: y,
    pullDragging: p,
    pullProgress: v,
    pullReady: L,
    pullRefreshing: b,
    pullVisible: c,
    resetGesture: x
  };
}
const Il = ["aria-label", "aria-busy", "data-refreshing"], Dl = /* @__PURE__ */ ae({
  __name: "BasePullToRefreshTrigger",
  props: {
    refresh: {},
    enabled: { type: Boolean, default: !0 },
    threshold: { default: 64 },
    maxDistance: { default: 140 },
    loadingDistance: { default: 56 },
    visibleDistance: { default: 16 },
    interactiveSelector: { default: 'button, a, input, textarea, select, [contenteditable="true"]' },
    theme: { default: "auto" },
    indicatorLabel: { default: "Refresh" }
  },
  emits: ["refreshStart", "refreshEnd", "refreshError"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = R(null);
    async function u() {
      n("refreshStart");
      try {
        await a.refresh();
      } catch (f) {
        throw n("refreshError", f), f;
      } finally {
        n("refreshEnd");
      }
    }
    const {
      pullDistance: d,
      pullDragging: m,
      pullProgress: y,
      pullReady: p,
      pullRefreshing: b,
      pullVisible: L
    } = Ml({
      gestureElement: o,
      refresh: u,
      enabled: () => a.enabled,
      threshold: a.threshold,
      maxDistance: a.maxDistance,
      loadingDistance: a.loadingDistance,
      visibleDistance: a.visibleDistance,
      interactiveSelector: a.interactiveSelector
    }), c = C(() => ({
      transform: `translate(-50%, calc(-100% + ${d.value}px))`
    })), v = C(() => b.value ? void 0 : { transform: `rotate(${d.value * 4.5}deg)` });
    return r({
      gestureElement: o,
      pullDistance: d,
      pullDragging: m,
      pullProgress: y,
      pullReady: p,
      pullRefreshing: b,
      pullVisible: L
    }), (f, h) => (l(), s("div", {
      ref_key: "gestureElement",
      ref: o,
      class: E(["base-pull-to-refresh-trigger", [`base-pull-to-refresh-trigger--${e.theme}`, { "base-pull-to-refresh-trigger--dragging": Z(m) }]]),
      "data-pull-to-refresh-part": "trigger"
    }, [
      Z(L) ? (l(), s("div", {
        key: 0,
        class: E(["base-pull-to-refresh-trigger__indicator", { "base-pull-to-refresh-trigger__indicator--ready": Z(p) || Z(b) }]),
        style: re(c.value),
        "aria-label": e.indicatorLabel,
        "aria-busy": Z(b),
        "data-refreshing": Z(b) ? "true" : "false",
        "data-pull-to-refresh-part": "indicator",
        role: "status"
      }, [
        N(f.$slots, "indicator", {
          distance: Z(d),
          progress: Z(y),
          ready: Z(p),
          refreshing: Z(b)
        }, () => [
          U(Z(Pt), {
            class: E(["base-pull-to-refresh-trigger__icon", { "base-pull-to-refresh-trigger__icon--refreshing": Z(b) }]),
            style: re(v.value),
            "data-pull-to-refresh-part": "icon"
          }, null, 8, ["class", "style"])
        ], !0)
      ], 14, Il)) : w("", !0),
      N(f.$slots, "default", {
        distance: Z(d),
        dragging: Z(m),
        progress: Z(y),
        ready: Z(p),
        refreshing: Z(b)
      }, void 0, !0)
    ], 2));
  }
}), di = /* @__PURE__ */ ce(Dl, [["__scopeId", "data-v-61214d6f"]]), Vl = { class: "flex items-center gap-3" }, Al = ["id", "disabled"], Rl = ["for"], ci = /* @__PURE__ */ ae({
  __name: "BaseSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    disabled: { type: Boolean, default: !1 },
    id: { default: () => `switch-${Math.random().toString(36).slice(2, 11)}` }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: r }) {
    const t = e, a = r;
    function n() {
      t.disabled || a("update:modelValue", !t.modelValue);
    }
    return (o, u) => (l(), s("div", Vl, [
      i("button", {
        type: "button",
        id: e.id,
        disabled: e.disabled,
        class: E([
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-dark-50",
          e.modelValue ? "bg-primary" : "bg-gray-200 dark:bg-dark-200",
          e.disabled ? "cursor-not-allowed opacity-50" : ""
        ]),
        onClick: n
      }, [
        i("span", {
          "aria-hidden": "true",
          class: E([
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
            e.modelValue ? "translate-x-5" : "translate-x-0"
          ])
        }, null, 2)
      ], 10, Al),
      e.label ? (l(), s("label", {
        key: 0,
        for: e.id,
        class: "text-sm font-medium text-gray-700 dark:text-dark-text-muted cursor-pointer",
        onClick: n
      }, I(e.label), 9, Rl)) : w("", !0)
    ]));
  }
}), Pl = { class: "overflow-hidden rounded-xl border border-ui bg-surface" }, Hl = { class: "flex items-center gap-2 p-3" }, Wl = ["aria-expanded", "disabled"], Ol = { class: "min-w-0 truncate" }, jl = {
  key: 0,
  class: "base-accordion-content grid border-t border-ui bg-surface-muted"
}, Fl = { class: "min-h-0 p-3" }, Kl = /* @__PURE__ */ ae({
  __name: "BaseAccordion",
  props: {
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: r }) {
    const t = e, a = r;
    function n() {
      t.disabled || a("update:modelValue", !t.modelValue);
    }
    return (o, u) => (l(), s("article", Pl, [
      i("div", Hl, [
        i("button", {
          type: "button",
          class: "flex min-w-0 flex-1 items-center gap-2 text-left font-semibold text-ui transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50",
          "aria-expanded": e.modelValue,
          disabled: e.disabled,
          onClick: n
        }, [
          U(X, {
            name: "ChevronDown",
            size: 16,
            class: E(["shrink-0 transition-transform duration-200", e.modelValue ? "rotate-180" : ""]),
            decorative: ""
          }, null, 8, ["class"]),
          i("span", Ol, [
            N(o.$slots, "title", {}, void 0, !0)
          ])
        ], 8, Wl),
        i("div", {
          class: "shrink-0",
          onClick: u[0] || (u[0] = fe(() => {
          }, ["stop"]))
        }, [
          N(o.$slots, "actions", {}, void 0, !0)
        ])
      ]),
      U(we, { name: "base-accordion" }, {
        default: ne(() => [
          e.modelValue ? (l(), s("div", jl, [
            i("div", Fl, [
              N(o.$slots, "default", {}, void 0, !0)
            ])
          ])) : w("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), fi = /* @__PURE__ */ ce(Kl, [["__scopeId", "data-v-45ead6df"]]), Nl = {
  class: "flex",
  "aria-label": "Breadcrumb"
}, Ul = { class: "inline-flex items-center space-x-1 md:space-x-3" }, ql = { class: "flex items-center" }, Xl = ["disabled", "onClick"], mi = /* @__PURE__ */ ae({
  __name: "BaseBreadcrumb",
  props: {
    items: {}
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = (o, u) => {
      u < t.items.length - 1 && a("click", o, u);
    };
    return (o, u) => (l(), s("nav", Nl, [
      i("ol", Ul, [
        (l(!0), s(te, null, oe(e.items, (d, m) => (l(), s("li", {
          key: m,
          class: "inline-flex items-center"
        }, [
          i("div", ql, [
            m > 0 ? (l(), _(X, {
              key: 0,
              name: "chevron-right",
              size: 14,
              class: "mx-1 text-gray-400 dark:text-gray-500"
            })) : w("", !0),
            i("button", {
              type: "button",
              class: E([
                "inline-flex items-center text-sm font-medium transition-colors duration-200",
                m === e.items.length - 1 ? "text-gray-700 dark:text-gray-200 cursor-default" : "text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary-light"
              ]),
              disabled: m === e.items.length - 1,
              onClick: (y) => n(d, m)
            }, [
              d.icon ? (l(), _(X, {
                key: 0,
                name: d.icon,
                size: 16,
                class: "mr-2"
              }, null, 8, ["name"])) : w("", !0),
              $e(" " + I(d.label), 1)
            ], 10, Xl)
          ])
        ]))), 128))
      ])
    ]));
  }
}), Yl = ["aria-label", "aria-busy"], Gl = {
  key: 0,
  class: "base-pagination-total items-center gap-1.5 text-[11px] text-ui-muted font-medium whitespace-nowrap px-3 py-1.5 bg-surface-muted rounded-lg border border-ui"
}, Zl = { class: "text-ui font-bold px-1 bg-surface border border-ui rounded min-w-5 text-center" }, Jl = {
  key: 1,
  class: "base-pagination-dense-total flex items-center gap-1 text-[10px] text-ui-dim font-mono px-2 py-1 bg-surface-muted rounded-lg border border-ui"
}, Ql = { class: "font-bold text-ui-muted" }, _l = { class: "flex items-center gap-1.5" }, er = ["disabled", "title", "aria-label", "aria-busy"], tr = ["disabled", "title", "aria-label", "aria-busy"], ar = { class: "flex items-center gap-1 mx-1" }, lr = ["aria-current", "aria-busy", "aria-label", "disabled", "onClick"], rr = {
  key: 1,
  class: "base-pagination-page-ellipsis min-w-8 h-8 items-center justify-center text-ui-dim font-medium",
  "aria-hidden": "true"
}, nr = ["disabled", "title", "aria-label", "aria-busy"], sr = ["disabled", "title", "aria-label", "aria-busy"], or = {
  key: 2,
  class: "base-pagination-page-size items-center gap-2"
}, ir = { class: "text-[10px] uppercase text-ui-dim font-bold tracking-wider whitespace-nowrap" }, ur = { class: "flex min-w-0 items-center gap-1.5" }, dr = { class: "truncate" }, cr = /* @__PURE__ */ ae({
  __name: "BasePagination",
  props: {
    modelValue: {},
    total: {},
    pageSize: {},
    pageSizes: { default: () => [10, 20, 50, 100] },
    dense: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: "Loading" },
    totalLabel: { default: "Total" },
    recordsLabel: { default: "records" },
    perPageLabel: { default: "Per page" },
    rowsLabel: { default: "rows" },
    pageLabel: { default: "Page" },
    paginationLabel: { default: "Pagination" },
    showTotal: { type: Boolean, default: !0 },
    showPageSize: { type: Boolean, default: !0 },
    firstPageLabel: { default: "First page" },
    previousPageLabel: { default: "Previous page" },
    nextPageLabel: { default: "Next page" },
    lastPageLabel: { default: "Last page" }
  },
  emits: ["update:modelValue", "update:pageSize", "change"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => Math.ceil(t.total / t.pageSize) || 1), o = R(null), u = (v) => {
      const f = o.value;
      return !!(t.loading && f && f.kind === v.kind && f.value === v.value);
    }, d = (v) => u({ kind: "page", value: v }), m = (v) => u({ kind: "control", value: v }), y = () => u({ kind: "pageSize", value: t.pageSize });
    me(() => t.loading, (v) => {
      v || (o.value = null);
    });
    const p = (v, f = { kind: "page", value: v }) => {
      v < 1 || v > n.value || v === t.modelValue || (o.value = f, a("update:modelValue", v), a("change", { page: v, pageSize: t.pageSize, reason: "page" }));
    }, b = (v) => {
      if (Array.isArray(v)) return;
      const f = typeof v == "number" ? v : parseInt(v, 10);
      !Number.isFinite(f) || f <= 0 || f === t.pageSize || (o.value = { kind: "pageSize", value: f }, a("update:pageSize", f), a("update:modelValue", 1), a("change", { page: 1, pageSize: f, reason: "pageSize" }));
    }, L = C(() => t.pageSizes.map((v) => ({
      label: `${v} ${t.rowsLabel}`,
      value: v
    }))), c = C(() => {
      const v = n.value, f = t.modelValue;
      if (v <= 7)
        return Array.from({ length: v }, (S, k) => k + 1);
      const x = [];
      if (f <= 4) {
        for (let S = 1; S <= 5; S++) x.push(S);
        x.push("..."), x.push(v);
      } else if (f >= v - 3) {
        x.push(1), x.push("...");
        for (let S = v - 4; S <= v; S++) x.push(S);
      } else
        x.push(1), x.push("..."), x.push(f - 1), x.push(f), x.push(f + 1), x.push("..."), x.push(v);
      return x;
    });
    return (v, f) => (l(), s("nav", {
      class: E(["base-pagination flex items-center px-0 sm:px-1", [e.compact ? "justify-center gap-2" : "justify-between gap-4", e.dense ? "h-10" : "py-3"]]),
      "aria-label": e.paginationLabel,
      "aria-busy": e.loading || void 0
    }, [
      !e.compact && e.showTotal ? (l(), s("div", Gl, [
        U(X, {
          name: "Database",
          size: 10,
          class: "text-ui-dim"
        }),
        i("span", null, I(e.totalLabel), 1),
        i("span", Zl, I(e.total), 1),
        i("span", null, I(e.recordsLabel), 1)
      ])) : w("", !0),
      e.dense && !e.compact ? (l(), s("div", Jl, [
        i("span", Ql, I(e.total), 1)
      ])) : w("", !0),
      i("div", _l, [
        e.compact ? w("", !0) : (l(), s("button", {
          key: 0,
          class: "base-pagination-edge p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue <= 1 || m("first"),
          title: e.firstPageLabel,
          "aria-label": e.firstPageLabel,
          "aria-busy": m("first") || void 0,
          onClick: f[0] || (f[0] = (h) => p(1, { kind: "control", value: "first" }))
        }, [
          U(X, {
            name: m("first") ? "Loader2" : "ChevronsLeft",
            size: 14,
            class: E(m("first") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, er)),
        i("button", {
          class: "p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue <= 1 || m("previous"),
          title: e.previousPageLabel,
          "aria-label": e.previousPageLabel,
          "aria-busy": m("previous") || void 0,
          onClick: f[1] || (f[1] = (h) => p(e.modelValue - 1, { kind: "control", value: "previous" }))
        }, [
          U(X, {
            name: m("previous") ? "Loader2" : "ChevronLeft",
            size: 14,
            class: E(m("previous") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, tr),
        i("div", ar, [
          (l(!0), s(te, null, oe(c.value, (h, x) => (l(), s(te, { key: x }, [
            typeof h == "number" ? (l(), s("button", {
              key: 0,
              class: E(["min-w-8 h-8 rounded-lg text-[10px] font-bold transition-all border flex items-center justify-center active:scale-95", [
                e.modelValue === h ? e.compact ? "bg-primary/15 text-primary border-primary/50 shadow-sm shadow-primary/10 ring-1 ring-primary/20" : "bg-primary/15 text-primary border-primary/50 shadow-sm shadow-primary/10" : "bg-surface text-ui-muted border-ui hover:border-ui-strong hover:text-ui shadow-xs",
                Math.abs(h - e.modelValue) > 1 && h !== 1 && h !== n.value ? "base-pagination-page-hidden" : ""
              ]]),
              "aria-current": e.modelValue === h ? "page" : void 0,
              "aria-busy": d(h) || void 0,
              "aria-label": `${e.pageLabel} ${h}`,
              disabled: d(h),
              onClick: (S) => p(h)
            }, [
              d(h) ? (l(), _(X, {
                key: 0,
                name: "Loader2",
                size: 13,
                class: "animate-spin"
              })) : (l(), s(te, { key: 1 }, [
                $e(I(h), 1)
              ], 64))
            ], 10, lr)) : (l(), s("span", rr, " ... "))
          ], 64))), 128))
        ]),
        i("button", {
          class: "p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue >= n.value || m("next"),
          title: e.nextPageLabel,
          "aria-label": e.nextPageLabel,
          "aria-busy": m("next") || void 0,
          onClick: f[2] || (f[2] = (h) => p(e.modelValue + 1, { kind: "control", value: "next" }))
        }, [
          U(X, {
            name: m("next") ? "Loader2" : "ChevronRight",
            size: 14,
            class: E(m("next") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, nr),
        e.compact ? w("", !0) : (l(), s("button", {
          key: 1,
          class: "base-pagination-edge p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue >= n.value || m("last"),
          title: e.lastPageLabel,
          "aria-label": e.lastPageLabel,
          "aria-busy": m("last") || void 0,
          onClick: f[3] || (f[3] = (h) => p(n.value, { kind: "control", value: "last" }))
        }, [
          U(X, {
            name: m("last") ? "Loader2" : "ChevronsRight",
            size: 14,
            class: E(m("last") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, sr))
      ]),
      !e.compact && e.showPageSize ? (l(), s("div", or, [
        i("span", ir, I(e.perPageLabel), 1),
        U(gt, {
          class: "!w-[108px] shrink-0",
          "model-value": e.pageSize,
          options: L.value,
          "aria-label": e.perPageLabel,
          "hide-chevron": y(),
          size: "sm",
          "onUpdate:modelValue": b
        }, {
          selected: ne(({ selectedOptions: h }) => [
            i("span", ur, [
              y() ? (l(), _(X, {
                key: 0,
                name: "Loader2",
                size: 12,
                class: "shrink-0 animate-spin text-primary"
              })) : w("", !0),
              i("span", dr, I(h[0]?.label), 1)
            ])
          ]),
          _: 1
        }, 8, ["model-value", "options", "aria-label", "hide-chevron"])
      ])) : w("", !0)
    ], 10, Yl));
  }
}), vi = /* @__PURE__ */ ce(cr, [["__scopeId", "data-v-dd7b486c"]]), fr = { class: "w-full" }, mr = ["disabled", "aria-label", "aria-busy"], vr = {
  key: 0,
  class: "mt-2"
}, br = { class: "flex items-center justify-between mb-1" }, hr = { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, gr = { class: "h-1.5 w-full bg-gray-100 dark:bg-dark-100 rounded-full overflow-hidden" }, yr = {
  key: 1,
  class: "mt-2"
}, pr = { class: "text-xs text-gray-500 dark:text-gray-400 pl-4 list-disc space-y-1" }, bi = /* @__PURE__ */ ae({
  __name: "BasePasswordInput",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    placeholder: { default: "Enter password" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    showStrength: { type: Boolean, default: !1 },
    showRules: { type: Boolean, default: !1 },
    toggleMask: { type: Boolean, default: !0 },
    visible: { type: Boolean, default: !1 },
    externalVisibility: { type: Boolean, default: !1 },
    visibilityLoading: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: "default" },
    strengthLabel: { default: "Password strength:" },
    weakLabel: { default: "Weak" },
    mediumLabel: { default: "Medium" },
    strongLabel: { default: "Strong" },
    minLengthRuleLabel: { default: "At least 8 characters" },
    uppercaseRuleLabel: { default: "At least 1 uppercase letter" },
    lowercaseRuleLabel: { default: "At least 1 lowercase letter" },
    numberRuleLabel: { default: "At least 1 number" }
  },
  emits: ["update:modelValue", "blur", "toggle-visibility"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = R(!1), o = C(() => t.externalVisibility ? t.visible : n.value), u = () => {
      if (!(t.disabled || t.readonly || t.visibilityLoading)) {
        if (t.externalVisibility) {
          a("toggle-visibility", !t.visible);
          return;
        }
        n.value = !n.value;
      }
    }, d = C(() => {
      const p = t.modelValue || "";
      if (!p) return 0;
      let b = 0;
      return p.length >= 8 && (b += 1), /[A-Z]/.test(p) && (b += 1), /[a-z]/.test(p) && (b += 1), /[0-9]/.test(p) && (b += 1), /[^A-Za-z0-9]/.test(p) && (b += 1), b;
    }), m = C(() => t.modelValue ? d.value <= 1 ? t.weakLabel : d.value <= 3 ? t.mediumLabel : t.strongLabel : ""), y = C(() => t.modelValue ? d.value <= 1 ? "bg-red-500" : d.value <= 3 ? "bg-yellow-500" : "bg-green-500" : "bg-gray-200");
    return (p, b) => (l(), s("div", fr, [
      U(Ke, We(p.$attrs, {
        id: e.id,
        "model-value": e.modelValue,
        type: o.value ? "text" : "password",
        placeholder: e.placeholder,
        disabled: e.disabled,
        readonly: e.readonly,
        error: e.error,
        required: e.required,
        size: e.size,
        variant: e.variant,
        label: e.label,
        "onUpdate:modelValue": b[0] || (b[0] = (L) => a("update:modelValue", L)),
        onBlur: b[1] || (b[1] = (L) => a("blur", L))
      }), At({ _: 2 }, [
        e.toggleMask ? {
          name: "end",
          fn: ne(() => [
            i("button", {
              type: "button",
              class: "focus:outline-none text-gray-400 dark:text-gray-500 hover:text-primary transition-all p-1.5 rounded-lg hover:bg-primary/5 dark:hover:bg-primary/20 active:bg-primary/10 dark:active:bg-primary/30",
              disabled: e.disabled || e.readonly || e.visibilityLoading,
              "aria-label": o.value ? "Hide password" : "Show password",
              "aria-busy": e.visibilityLoading,
              onClick: u
            }, [
              e.visibilityLoading ? (l(), _(Z(Ba), {
                key: 0,
                class: "w-4.5 h-4.5 animate-spin"
              })) : (l(), _(pt(o.value ? Z(Ta) : Z(Ea)), {
                key: 1,
                class: "w-4.5 h-4.5"
              }))
            ], 8, mr)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["id", "model-value", "type", "placeholder", "disabled", "readonly", "error", "required", "size", "variant", "label"]),
      e.showStrength && e.modelValue ? (l(), s("div", vr, [
        i("div", br, [
          i("span", hr, I(e.strengthLabel), 1),
          i("span", {
            class: E(["text-xs font-bold", {
              "text-red-500 dark:text-red-400": d.value <= 1,
              "text-yellow-500 dark:text-yellow-400": d.value > 1 && d.value <= 3,
              "text-green-500 dark:text-green-400": d.value > 3
            }])
          }, I(m.value), 3)
        ]),
        i("div", gr, [
          i("div", {
            class: E(["h-full transition-all duration-300 ease-out rounded-full", y.value]),
            style: re({ width: `${d.value / 5 * 100}%` })
          }, null, 6)
        ])
      ])) : w("", !0),
      e.showRules ? (l(), s("div", yr, [
        N(p.$slots, "rules", {}, () => [
          i("ul", pr, [
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": e.modelValue.length >= 8 })
            }, I(e.minLengthRuleLabel), 3),
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[A-Z]/.test(e.modelValue) })
            }, I(e.uppercaseRuleLabel), 3),
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[a-z]/.test(e.modelValue) })
            }, I(e.lowercaseRuleLabel), 3),
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[0-9]/.test(e.modelValue) })
            }, I(e.numberRuleLabel), 3)
          ])
        ])
      ])) : w("", !0)
    ]));
  }
}), xr = ["onClick"], wr = { class: "font-medium" }, kr = /* @__PURE__ */ ae({
  __name: "BaseSplitButton",
  props: {
    label: {},
    menuItems: { default: () => [] },
    menuLabel: { default: "More actions" },
    size: { default: "md" },
    variant: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    menuPlacement: { default: "bottom-start" },
    menuOffset: { default: 8 },
    menuWidth: { default: "w-48" },
    menuClassName: { default: "custom-scrollbar" },
    menuPadding: { default: "py-1" }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = R(!1), o = (d) => {
      t.disabled || a("click", d);
    }, u = (d) => {
      t.disabled || (d.command(), n.value = !1);
    };
    return (d, m) => (l(), s("div", {
      class: E(["relative items-stretch split-action-button-container", e.block ? "flex w-full" : "inline-flex"])
    }, [
      U(at, {
        label: e.label,
        size: e.size,
        variant: e.variant,
        disabled: e.disabled,
        block: e.block,
        class: E(["z-10 min-w-0", [
          { "rounded-r-none": e.menuItems.length > 0 },
          e.block ? "flex-1" : ""
        ]]),
        onClick: o
      }, null, 8, ["label", "size", "variant", "disabled", "block", "class"]),
      e.menuItems.length > 0 ? (l(), _(Ja, {
        key: 0,
        visible: n.value,
        "onUpdate:visible": m[0] || (m[0] = (y) => n.value = y),
        size: e.size,
        variant: e.variant,
        disabled: e.disabled,
        "aria-label": e.menuLabel,
        "has-popup": "menu",
        "chevron-size": e.size === "sm" ? 8 : 10,
        placement: e.menuPlacement,
        offset: e.menuOffset,
        "popover-width": e.menuWidth,
        "popover-padding": e.menuPadding,
        "popover-class-name": e.menuClassName,
        class: "shrink-0 rounded-l-none border-l border-white/20 -ml-px min-w-8 px-2"
      }, {
        popover: ne(() => [
          i("div", null, [
            (l(!0), s(te, null, oe(e.menuItems, (y, p) => (l(), s("button", {
              key: p,
              class: "flex w-full items-center gap-2.5 px-4 py-2.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-dark-200",
              type: "button",
              onClick: (b) => u(y)
            }, [
              y.icon ? (l(), _(X, {
                key: 0,
                name: y.icon,
                class: "text-gray-400 dark:text-gray-500",
                size: 12
              }, null, 8, ["name"])) : w("", !0),
              i("span", wr, I(y.label), 1)
            ], 8, xr))), 128))
          ])
        ]),
        _: 1
      }, 8, ["visible", "size", "variant", "disabled", "aria-label", "chevron-size", "placement", "offset", "popover-width", "popover-padding", "popover-class-name"])) : w("", !0)
    ], 2));
  }
}), hi = /* @__PURE__ */ ce(kr, [["__scopeId", "data-v-c1fa8d54"]]), $r = { class: "flex flex-col w-full" }, Cr = ["disabled", "onClick"], Lr = { key: 0 }, Sr = {
  key: 1,
  class: "flex-1 min-h-0 flex flex-col w-full relative"
}, zr = {
  key: 0,
  class: "flex-1 min-h-0 flex flex-col"
}, Br = /* @__PURE__ */ ae({
  __name: "BaseTabs",
  props: {
    modelValue: {},
    tabs: { default: () => [] },
    variant: { default: "default" },
    transitionMode: { default: "none" },
    tabListClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = ft(t, "modelValue");
    nt("activeTab", n), nt("updateTab", (m) => {
      n.value !== m && (a("change", m, n.value), a("update:modelValue", m));
    }), nt("variant", ft(t, "variant")), nt("transitionMode", ft(t, "transitionMode"));
    const o = C(() => t.tabs.filter((m) => m.visible !== !1)), u = C(() => t.transitionMode === "none" ? "" : t.transitionMode === "slide" ? "tab-slide" : "tab-fade"), d = (m) => {
      n.value !== m && (a("change", m, n.value), a("update:modelValue", m));
    };
    return (m, y) => (l(), s("div", $r, [
      e.tabs.length > 0 ? (l(), s("div", {
        key: 0,
        class: E(["flex border-b border-gray-200 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-50/50 rounded-t-lg overflow-hidden shrink-0 overflow-x-auto", e.tabListClass])
      }, [
        U(Ye, {
          name: "tabs-list",
          tag: "div",
          class: "flex w-full"
        }, {
          default: ne(() => [
            (l(!0), s(te, null, oe(o.value, (p) => (l(), s("button", {
              key: p.id,
              type: "button",
              disabled: p.disabled,
              class: E(["px-6 py-3 text-sm font-semibold transition-all cursor-pointer border-b-2 flex items-center gap-2 whitespace-nowrap", [
                n.value === p.id ? "text-primary border-primary" : "text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200",
                p.disabled ? "opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-500 dark:hover:text-gray-600" : ""
              ]]),
              onClick: (b) => d(p.id)
            }, [
              N(m.$slots, `tab-${p.id}`, {}, () => [
                p.emoji ? (l(), s("span", Lr, I(p.emoji), 1)) : w("", !0),
                p.icon ? (l(), _(X, {
                  key: 1,
                  name: p.icon,
                  size: 16
                }, null, 8, ["name"])) : w("", !0),
                i("span", null, I(p.label), 1)
              ], !0)
            ], 10, Cr))), 128))
          ]),
          _: 3
        })
      ], 2)) : w("", !0),
      e.tabs.length > 0 ? (l(), s("div", Sr, [
        U(we, {
          name: u.value,
          mode: "out-in"
        }, {
          default: ne(() => [
            (l(), s("div", {
              key: n.value,
              class: "flex-1 min-h-0 flex flex-col w-full"
            }, [
              (l(!0), s(te, null, oe(o.value, (p) => (l(), s(te, {
                key: p.id
              }, [
                n.value === p.id ? (l(), s("div", zr, [
                  N(m.$slots, p.id, {}, void 0, !0)
                ])) : w("", !0)
              ], 64))), 128))
            ]))
          ]),
          _: 3
        }, 8, ["name"])
      ])) : N(m.$slots, "default", {}, void 0, !0, 2)
    ]));
  }
}), gi = /* @__PURE__ */ ce(Br, [["__scopeId", "data-v-63b42ec4"]]), Tr = ["disabled"], Er = { key: 0 }, yi = /* @__PURE__ */ ae({
  __name: "BaseTab",
  props: {
    value: {},
    icon: {},
    emoji: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const r = e, t = He("activeTab"), a = He("updateTab"), n = C(() => t?.value === r.value), o = () => {
      !r.disabled && a && a(r.value);
    };
    return (u, d) => (l(), s("button", {
      type: "button",
      disabled: e.disabled,
      class: E(["px-6 py-3 text-sm font-semibold transition-all cursor-pointer border-b-2 flex items-center gap-2 whitespace-nowrap", [
        n.value ? "text-primary border-primary" : "text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200",
        e.disabled ? "opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-500 dark:hover:text-gray-600" : ""
      ]]),
      onClick: o
    }, [
      e.emoji ? (l(), s("span", Er, I(e.emoji), 1)) : w("", !0),
      e.icon ? (l(), _(X, {
        key: 1,
        name: e.icon,
        size: 16
      }, null, 8, ["name"])) : w("", !0),
      N(u.$slots, "default", {}, () => [
        i("span", null, [
          N(u.$slots, "label")
        ])
      ])
    ], 10, Tr));
  }
}), pi = /* @__PURE__ */ ae({
  __name: "BaseTabList",
  setup(e) {
    const r = He("variant");
    return (t, a) => (l(), s("div", {
      class: E(["flex border-b border-gray-200 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-50/50 rounded-t-lg overflow-hidden shrink-0 overflow-x-auto", { "gap-1 p-1": Z(r) === "compact" }])
    }, [
      N(t.$slots, "default")
    ], 2));
  }
}), Mr = { class: "w-full relative" }, Ir = /* @__PURE__ */ ae({
  __name: "BaseTabPanels",
  setup(e) {
    const r = He("activeTab"), t = He("transitionMode"), a = C(() => t?.value === "none" ? "" : t?.value === "slide" ? "tab-slide" : "tab-fade");
    return (n, o) => (l(), s("div", Mr, [
      U(we, {
        name: a.value,
        mode: "out-in"
      }, {
        default: ne(() => [
          (l(), s("div", {
            key: Z(r),
            class: "w-full"
          }, [
            N(n.$slots, "default", {}, void 0, !0)
          ]))
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), xi = /* @__PURE__ */ ce(Ir, [["__scopeId", "data-v-24cf149f"]]), wi = /* @__PURE__ */ ae({
  __name: "BaseTabPanel",
  props: {
    value: {}
  },
  setup(e) {
    const r = He("activeTab");
    return (t, a) => xt((l(), s("div", null, [
      N(t.$slots, "default")
    ], 512)), [
      [Qt, Z(r) === e.value]
    ]);
  }
}), Dr = {
  key: 0,
  class: "my-1 border-t border-gray-100 dark:border-white/8"
}, Vr = ["disabled", "onClick"], ki = /* @__PURE__ */ ae({
  __name: "BaseContextMenu",
  props: {
    menu: {},
    teleportTo: { default: "#app" }
  },
  emits: ["close"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = R(null);
    me(() => t.menu, async (d) => {
      if (!d) return;
      await pe();
      const m = n.value;
      if (!m) return;
      const { innerWidth: y, innerHeight: p } = window, { offsetWidth: b, offsetHeight: L } = m;
      d.x + b > y && (m.style.left = `${y - b - 8}px`), d.y + L > p && (m.style.top = `${p - L - 8}px`);
    });
    function o(d) {
      d.disabled || (d.action(), a("close"));
    }
    function u(d) {
      d.target.closest("[data-context-menu]") || a("close");
    }
    return me(() => t.menu, (d) => {
      d ? window.addEventListener("mousedown", u, !0) : window.removeEventListener("mousedown", u, !0);
    }, { immediate: !0 }), dt(() => window.removeEventListener("mousedown", u, !0)), (d, m) => (l(), _(De, { to: e.teleportTo }, [
      e.menu ? (l(), s("div", {
        key: 0,
        ref_key: "menuRef",
        ref: n,
        "data-context-menu": "",
        class: "fixed z-[9999] min-w-[160px] py-1 rounded-lg shadow-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-dark-100 text-sm",
        style: re({ left: `${e.menu.x}px`, top: `${e.menu.y}px` })
      }, [
        (l(!0), s(te, null, oe(e.menu.items, (y, p) => (l(), s(te, { key: p }, [
          y.label === "---" ? (l(), s("div", Dr)) : (l(), s("button", {
            key: 1,
            class: E(["w-full flex items-center gap-2.5 px-3 py-1.5 transition-colors text-left", [
              y.disabled ? "text-gray-300 dark:text-gray-600 cursor-not-allowed" : y.danger ? "text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10" : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-200"
            ]]),
            disabled: y.disabled,
            onClick: (b) => o(y)
          }, [
            y.icon ? (l(), _(X, {
              key: 0,
              name: y.icon,
              size: 13,
              class: "shrink-0 opacity-70"
            }, null, 8, ["name"])) : w("", !0),
            i("span", null, I(y.label), 1)
          ], 10, Vr))
        ], 64))), 128))
      ], 4)) : w("", !0)
    ], 8, ["to"]));
  }
}), Ar = { class: "relative w-full" }, Rr = { class: "flex items-center relative" }, Pr = {
  key: 0,
  class: "px-3 py-4 text-center"
}, Hr = { class: "text-[10px] text-ui-muted mt-1" }, Wr = {
  key: 0,
  class: "base-autocomplete-group-label px-3 pt-3 pb-1 text-[11px] font-black uppercase tracking-widest text-ui-muted",
  role: "presentation",
  "aria-hidden": "true"
}, Or = ["onMousedown"], jr = { class: "truncate flex-1 text-ui-muted" }, Fr = {
  key: 1,
  class: "px-3 py-6 text-center text-ui-muted"
}, Kr = { class: "text-[10px] mb-1" }, Nr = {
  key: 2,
  class: "border-t border-ui px-3 py-2.5 text-center text-ui-muted",
  role: "status"
}, Ur = { class: "text-[10px]" }, qr = {
  key: 3,
  class: "border-t border-ui px-3 py-2 text-center text-[10px] text-ui-muted",
  role: "status"
}, $i = /* @__PURE__ */ ae({
  __name: "BaseAutocomplete",
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    itemKey: { default: "id" },
    displayKey: { default: "name" },
    searchKeys: { default: () => ["name"] },
    size: { default: "md" },
    variant: { default: "default" },
    loading: { type: Boolean, default: !1 },
    label: { default: "" },
    error: { type: [String, Boolean] },
    loadingLabel: { default: "Searching..." },
    loadingMore: { type: Boolean, default: !1 },
    loadingMoreLabel: { default: "Loading more..." },
    hasMore: { type: Boolean, default: void 0 },
    endLabel: { default: "End of list" },
    emptyLabel: { default: "No options available" },
    noMatchesLabel: { default: "No matching items" },
    teleportTo: { default: "body" }
  },
  emits: ["update:modelValue", "select", "toggle", "reach-end"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = R(!1), o = R(!1), u = R({}), d = R(null), m = R(!1), y = R(""), p = C(() => d.value?.$el?.querySelector("input")), b = C(() => {
      if (o.value || !y.value.trim())
        return t.options;
      const V = y.value.toLowerCase();
      return t.options.filter((B) => t.searchKeys.some((O) => {
        const j = L(B, O);
        return j && String(j).toLowerCase().includes(V);
      }));
    });
    function L(V, B) {
      return V ? V[B] : void 0;
    }
    const c = (V) => {
      const B = V ? String(V) : "";
      a("update:modelValue", B), y.value = B, o.value = !1, n.value = !0, k();
    }, v = () => {
      m.value = !0, o.value = !0, y.value = "", n.value = !0, a("toggle", !0), k(), setTimeout(() => {
        p.value?.select();
      }, 0);
    }, f = () => {
      n.value || (o.value = !0, y.value = "", n.value = !0, a("toggle", !0), k()), setTimeout(() => {
        p.value?.select();
      }, 0);
    }, h = () => {
      setTimeout(() => {
        n.value = !1;
      }, 200);
    }, x = (V) => {
      a("update:modelValue", String(L(V, t.displayKey) ?? "")), a("select", V), n.value = !1, o.value = !1;
    }, S = (V) => {
      if (t.loadingMore || t.hasMore !== !0) return;
      const B = V.currentTarget;
      B && B.scrollHeight - B.scrollTop - B.clientHeight <= 24 && a("reach-end");
    };
    function k() {
      const V = p.value || d.value?.$el;
      if (!V) return;
      const B = V.getBoundingClientRect();
      u.value = {
        position: "fixed",
        top: `${B.bottom}px`,
        left: `${B.left}px`,
        width: `${B.width}px`
      };
    }
    const M = (V) => {
      t.disabled || (V && (V.preventDefault(), V.stopPropagation()), n.value = !n.value, a("toggle", n.value), n.value && (o.value = !0, k(), setTimeout(() => {
        p.value?.focus(), p.value?.select();
      }, 50)));
    };
    me(n, (V) => {
      V ? (window.addEventListener("resize", k), window.addEventListener("scroll", k, !0)) : (window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0));
    }), dt(() => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    });
    const F = (V) => {
      const B = L(V, t.displayKey);
      return !B || !t.modelValue ? !1 : String(B).trim().toLowerCase() === String(t.modelValue).trim().toLowerCase();
    };
    return (V, B) => (l(), s("div", Ar, [
      i("div", Rr, [
        U(Ke, {
          ref_key: "baseInputRef",
          ref: d,
          "model-value": e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          size: e.size,
          variant: e.variant,
          "input-class": e.size === "sm" ? "h-8" : void 0,
          label: e.label,
          error: e.error,
          autocomplete: "off",
          "onUpdate:modelValue": c,
          onFocus: v,
          onClick: f,
          onBlur: h
        }, {
          end: ne(() => [
            e.disabled ? w("", !0) : (l(), s("button", {
              key: 0,
              type: "button",
              class: "text-ui-muted hover:text-primary transition-all cursor-pointer focus:outline-none p-1 -mr-1",
              tabindex: "-1",
              onMousedown: fe(M, ["stop"])
            }, [
              i("div", {
                class: E(["transition-transform duration-200", { "rotate-180": n.value }])
              }, [
                U(X, {
                  name: "ChevronDown",
                  size: e.size === "sm" ? 16 : 18
                }, null, 8, ["size"])
              ], 2)
            ], 32))
          ]),
          _: 1
        }, 8, ["model-value", "placeholder", "disabled", "size", "variant", "input-class", "label", "error"])
      ]),
      (l(), _(De, { to: e.teleportTo }, [
        n.value ? (l(), s("div", {
          key: 0,
          class: "fixed z-9999 mt-1 bg-surface border border-ui text-ui shadow-xl max-h-60 overflow-y-auto min-w-30 custom-scrollbar",
          style: re(u.value),
          onScroll: S
        }, [
          e.loading && e.options.length === 0 ? (l(), s("div", Pr, [
            U(X, {
              name: "Loader2",
              class: "animate-spin text-primary",
              size: 14
            }),
            i("div", Hr, I(e.loadingLabel), 1)
          ])) : (l(), s(te, { key: 1 }, [
            b.value.length > 0 ? (l(!0), s(te, { key: 0 }, oe(b.value, (O) => (l(), s(te, {
              key: String(L(O, e.itemKey))
            }, [
              L(O, "group") && L(b.value[b.value.indexOf(O) - 1], "group") !== L(O, "group") ? (l(), s("div", Wr, I(L(O, "group")), 1)) : w("", !0),
              i("div", {
                class: E(["px-3 py-2 text-xs cursor-pointer transition-colors hover:bg-primary/15 hover:text-primary-light flex items-center justify-between gap-2", { "bg-primary/15 text-primary-light font-bold": F(O) }]),
                onMousedown: fe((j) => x(O), ["prevent"])
              }, [
                i("div", jr, [
                  N(V.$slots, "default", { item: O }, () => [
                    $e(I(L(O, e.displayKey)), 1)
                  ])
                ]),
                F(O) ? (l(), _(X, {
                  key: 0,
                  name: "Check",
                  class: "text-primary",
                  size: 10
                })) : w("", !0)
              ], 42, Or)
            ], 64))), 128)) : (l(), s("div", Fr, [
              i("div", Kr, I(e.options.length === 0 ? e.emptyLabel : e.noMatchesLabel), 1)
            ])),
            e.loadingMore ? (l(), s("div", Nr, [
              U(X, {
                name: "Loader2",
                class: "mr-1 inline-block animate-spin text-primary",
                size: 13
              }),
              i("span", Ur, I(e.loadingMoreLabel), 1)
            ])) : e.hasMore === !1 && e.options.length > 0 ? (l(), s("div", qr, I(e.endLabel), 1)) : w("", !0)
          ], 64))
        ], 36)) : w("", !0)
      ], 8, ["to"]))
    ]));
  }
}), Xr = { class: "flex items-center gap-3 rounded-lg bg-gray-800 px-4 py-3 select-none" }, Yr = ["disabled"], Gr = {
  key: 0,
  viewBox: "0 0 24 24",
  class: "ml-0.5 h-4 w-4",
  fill: "currentColor"
}, Zr = {
  key: 1,
  viewBox: "0 0 24 24",
  class: "h-4 w-4",
  fill: "currentColor"
}, Jr = { class: "w-10 flex-shrink-0 text-right text-xs text-gray-400 tabular-nums" }, Qr = { class: "w-10 flex-shrink-0 text-xs text-gray-400 tabular-nums" }, Ci = /* @__PURE__ */ ae({
  __name: "BaseAudioPlayer",
  props: {
    autoplay: { type: Boolean }
  },
  emits: ["ended", "error"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = R(!1), u = R(0), d = R(0), m = R(0);
    let y = null, p = null, b = null, L = 0, c = 0, v = 0;
    function f() {
      return y || (y = new AudioContext()), y;
    }
    function h($) {
      const A = f(), z = $.reduce((ge, q) => ge + q.length, 0), K = $[0], de = K.sampleRate, ue = K.numberOfChannels, ie = A.createBuffer(ue, z, de);
      for (let ge = 0; ge < ue; ge++) {
        const q = ie.getChannelData(ge);
        let G = 0;
        for (const Q of $)
          q.set(Q.getChannelData(ge), G), G += Q.length;
      }
      return ie;
    }
    async function x($) {
      const A = f();
      try {
        const z = await A.decodeAudioData($.slice(0));
        b = h(b ? [b, z] : [z]), d.value = b.duration, a.autoplay && !o.value && k();
      } catch (z) {
        n("error", z instanceof Error ? z : new Error(String(z)));
      }
    }
    async function S($) {
      const A = f();
      try {
        const K = await (await fetch($)).arrayBuffer();
        b = await A.decodeAudioData(K), d.value = b.duration, a.autoplay && k();
      } catch (z) {
        n("error", z instanceof Error ? z : new Error(String(z)));
      }
    }
    function k() {
      if (!b || o.value) return;
      const $ = f();
      $.state === "suspended" && $.resume(), p = $.createBufferSource(), p.buffer = b, p.connect($.destination), p.onended = () => {
        o.value && (o.value = !1, u.value = 100, m.value = d.value, cancelAnimationFrame(v), n("ended"));
      };
      const A = c;
      p.start(0, A), L = $.currentTime - A, o.value = !0, B();
    }
    function M() {
      !o.value || !p || !y || (c = y.currentTime - L, p.onended = null, p.stop(), p = null, o.value = !1, cancelAnimationFrame(v));
    }
    function F() {
      o.value ? M() : k();
    }
    function V($) {
      if (!b) return;
      const z = $.currentTarget.getBoundingClientRect(), K = Math.max(0, Math.min(1, ($.clientX - z.left) / z.width)), de = o.value;
      de && M(), c = K * d.value, m.value = c, u.value = K * 100, de && k();
    }
    function B() {
      if (!o.value || !y) return;
      const $ = y.currentTime - L;
      m.value = Math.min($, d.value), u.value = d.value > 0 ? m.value / d.value * 100 : 0, v = requestAnimationFrame(B);
    }
    function O() {
      M(), b = null, u.value = 0, d.value = 0, m.value = 0, c = 0, L = 0;
    }
    function j($) {
      const A = Math.floor($ / 60), z = Math.floor($ % 60);
      return `${A}:${z.toString().padStart(2, "0")}`;
    }
    const J = C(() => !!b);
    return dt(() => {
      if (cancelAnimationFrame(v), p) {
        p.onended = null;
        try {
          p.stop();
        } catch {
        }
      }
      y && y.close();
    }), r({
      appendChunk: x,
      loadAudio: S,
      play: k,
      pause: M,
      reset: O
    }), ($, A) => (l(), s("div", Xr, [
      i("button", {
        disabled: !J.value,
        class: E(["flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-colors", J.value ? "bg-blue-600 text-white hover:bg-blue-500" : "cursor-not-allowed bg-gray-700 text-gray-500"]),
        onClick: F
      }, [
        o.value ? (l(), s("svg", Zr, [...A[1] || (A[1] = [
          i("rect", {
            x: "6",
            y: "4",
            width: "4",
            height: "16"
          }, null, -1),
          i("rect", {
            x: "14",
            y: "4",
            width: "4",
            height: "16"
          }, null, -1)
        ])])) : (l(), s("svg", Gr, [...A[0] || (A[0] = [
          i("polygon", { points: "6,4 20,12 6,20" }, null, -1)
        ])]))
      ], 10, Yr),
      i("span", Jr, I(j(m.value)), 1),
      i("div", {
        class: "relative h-2 flex-1 cursor-pointer overflow-hidden rounded-full bg-gray-700",
        onClick: V
      }, [
        i("div", {
          class: "h-full rounded-full bg-blue-500 transition-[width] duration-100",
          style: re({ width: `${u.value}%` })
        }, null, 4)
      ]),
      i("span", Qr, I(j(d.value)), 1)
    ]));
  }
}), ke = [], mt = "__lunaMobileHistoryEntry";
let _r = 0, Ge = null, Pe = null, Xt = !1, qe = 0, St = !1;
function Yt() {
  St || (St = !0, window.addEventListener("popstate", () => {
    if (qe > 0) {
      qe--, qe === 0 && ke.length === 0 && (Pe = null);
      return;
    }
    ke.at(-1)?.();
  }));
}
function zt() {
  ke.length > 0 || (Ge?.destroy?.(), Ge = null, Pe = null);
}
function en() {
  if (Xt || typeof window > "u" || !("CloseWatcher" in window)) return !1;
  if (Ge) return !0;
  try {
    const e = globalThis.CloseWatcher;
    if (!e) return !1;
    const r = new e();
    return r.onclose = () => {
      ke.at(-1)?.();
    }, Ge = r, !0;
  } catch {
    return !1;
  }
}
function Li() {
  ke.length > 0 || (Xt = !0, Ge?.destroy?.(), Ge = null, Pe = "history", Yt());
}
function Si() {
  return ke;
}
function tn() {
  const e = R(!1), r = [];
  let t, a = null;
  function n() {
    if (Pe !== "history" || typeof window > "u" || !a) return !1;
    const b = window.history.state;
    return !!b && typeof b == "object" && b[mt] === a;
  }
  function o() {
    if (r.length > 0) {
      r.pop()(), u();
      return;
    }
    const b = ke.lastIndexOf(o);
    b !== -1 && ke.splice(b, 1), e.value = !1, u(), a = null, zt(), t?.();
  }
  function u() {
    n() && (qe++, history.back());
  }
  function d(b) {
    if (!e.value) {
      if (t = b, ke.length === 0 && (Pe = "history", Yt(), en()), ke.push(o), Pe === "history") {
        a = `mobile-${++_r}`;
        const L = history.state && typeof history.state == "object" ? history.state : {};
        history.pushState({
          ...L,
          [mt]: a,
          mobileEntry: !0
        }, "");
      }
      e.value = !0;
    }
  }
  function m() {
    if (!e.value) return;
    const b = 1 + r.length;
    r.length = 0;
    const L = ke.lastIndexOf(o);
    L !== -1 && ke.splice(L, 1), e.value = !1;
    const c = n();
    a = null, c && (qe++, history.go(-b)), zt();
  }
  function y(b) {
    if (e.value && (r.push(b), Pe === "history")) {
      const L = history.state && typeof history.state == "object" ? history.state : {};
      history.pushState({
        ...L,
        [mt]: a,
        mobileStep: !0
      }, "");
    }
  }
  function p() {
    r.length !== 0 && (r.pop(), Pe === "history" && (qe++, history.back()));
  }
  return Ie(() => {
    e.value && m();
  }), { push: d, consume: m, pushBackStep: y, popBackStep: p, pushed: e };
}
const an = ["aria-label"], ln = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, rn = { class: "flex-1 min-w-0 mr-4" }, nn = {
  key: 0,
  class: "text-base md:text-lg font-bold text-ui truncate"
}, sn = { class: "flex items-center gap-1 shrink-0" }, on = {
  key: 0,
  class: "flex items-center"
}, un = {
  key: 0,
  class: "w-px h-6 bg-ui-border mx-1.5 sm:mx-2.5"
}, dn = ["title"], cn = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, fn = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, mn = { class: "flex items-center justify-end gap-2 w-full" }, vn = "body", bn = 100, Fe = 300, it = 200, hn = /* @__PURE__ */ ae({
  inheritAttrs: !1,
  __name: "BaseDialog",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    dialogLabel: { default: "" },
    width: { default: "auto" },
    maxWidth: { default: "md" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !1 },
    blockScroll: { type: Boolean, default: !0 },
    contentClass: { default: "" },
    bodyClass: { default: "" },
    footerClass: { default: "" },
    blurBackground: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !0 },
    zIndex: { default: 2e3 },
    fullScreen: { type: Boolean, default: !1 },
    maximizable: { type: Boolean, default: !1 },
    mobileStyle: { default: "modal" },
    closeOnBrowserBack: { type: Boolean, default: !0 },
    customBack: { type: Boolean, default: !1 },
    height: {},
    minHeight: {},
    resizable: { type: Boolean, default: !1 },
    resizeStorageKey: {},
    hideHeaderMobile: { type: Boolean },
    bodyOverflow: { default: "auto" },
    keyboardAware: { type: Boolean, default: !1 }
  },
  emits: ["update:visible", "update:fullScreen", "show", "after-show", "hide", "close", "maximize", "back", "viewport-resize", "after-hide"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = C(() => {
      const H = {
        sm: "max-w-sm w-full",
        md: "max-w-md w-full",
        lg: "max-w-lg w-full",
        xl: "max-w-xl w-full",
        "2xl": "max-w-2xl w-full",
        "3xl": "max-w-3xl w-full",
        "4xl": "max-w-4xl w-full",
        "5xl": "max-w-5xl w-full",
        "6xl": "max-w-6xl w-full",
        "7xl": "max-w-7xl w-full",
        "8xl": "max-w-8xl w-full",
        full: "max-w-full w-full",
        none: ""
      };
      return H[a.maxWidth] || H.md;
    }), u = C(() => a.mobileStyle === "sheet"), d = C(() => `w-full h-full max-w-full sm:w-full sm:h-auto sm:max-h-[90%] ${{
      sm: "sm:max-w-sm",
      md: "sm:max-w-md",
      lg: "sm:max-w-lg",
      xl: "sm:max-w-xl",
      "2xl": "sm:max-w-2xl",
      "3xl": "sm:max-w-3xl",
      "4xl": "sm:max-w-4xl",
      "5xl": "sm:max-w-5xl",
      "6xl": "sm:max-w-6xl",
      "7xl": "sm:max-w-7xl",
      "8xl": "sm:max-w-8xl",
      full: "sm:max-w-full",
      none: ""
    }[a.maxWidth] || "sm:max-w-md"}`), m = Ft(), y = C(() => u.value && m.value), p = R(null);
    let b = null, L = 0;
    wt(() => {
      if (a.keyboardAware && window.visualViewport) {
        L = window.visualViewport.height;
        let H = !1;
        b = () => {
          const Y = window.visualViewport.height, ee = L - Y;
          ee > bn && !H ? (H = !0, p.value = Y, n("viewport-resize", Y)) : ee < 50 && H && (H = !1, p.value = null, n("viewport-resize", L));
        }, window.visualViewport.addEventListener("resize", b);
      }
    });
    const c = R({ x: 0, y: 0 }), v = R(!1), f = R({ x: 0, y: 0 }), h = C(() => {
      const H = {};
      if ((c.value.x !== 0 || c.value.y !== 0) && (H["--dialog-tx"] = `${c.value.x}px`, H["--dialog-ty"] = `${c.value.y}px`), !a.fullScreen)
        if (O.value ? (H.width = `${O.value}px`, H.maxWidth = `${O.value}px`) : a.width && a.width !== "auto" && (H.width = a.width, H.maxWidth = a.width), a.keyboardAware && p.value) {
          const ee = m.value ? p.value : Math.min(p.value - 48, 700);
          H.height = `${ee}px`, H.maxHeight = `${ee}px`;
        } else j.value && (H.height = `${j.value}px`, H.maxHeight = `${j.value}px`);
      return H;
    }), x = C(() => {
      const H = {};
      return !a.fullScreen && !y.value && !j.value && (a.height && (H.height = a.height), a.minHeight && (H.minHeight = a.minHeight)), H;
    }), S = (H) => {
      a.draggable && (H.target.closest("button, a, input, textarea") || (v.value = !0, f.value = { x: H.clientX - c.value.x, y: H.clientY - c.value.y }, document.addEventListener("mousemove", k), document.addEventListener("mouseup", M)));
    }, k = (H) => {
      if (v.value) {
        if (H.buttons === 0) {
          M();
          return;
        }
        c.value = { x: H.clientX - f.value.x, y: H.clientY - f.value.y };
      }
    }, M = () => {
      v.value = !1, document.removeEventListener("mousemove", k), document.removeEventListener("mouseup", M);
    }, F = () => {
      c.value = { x: 0, y: 0 };
    };
    function V() {
      if (!a.resizeStorageKey) return null;
      try {
        const H = localStorage.getItem(a.resizeStorageKey);
        if (H) {
          const { w: Y, h: ee } = JSON.parse(H);
          if (typeof Y == "number" && typeof ee == "number") return { w: Y, h: ee };
        }
      } catch {
      }
      return null;
    }
    const B = V(), O = R(B?.w ?? null), j = R(B?.h ?? null), J = R(!1), $ = R("se"), A = R({ mouseX: 0, mouseY: 0, width: 0, height: 0, tx: 0, ty: 0 });
    function z() {
      if (!(!a.resizeStorageKey || !O.value || !j.value))
        try {
          localStorage.setItem(a.resizeStorageKey, JSON.stringify({ w: O.value, h: j.value }));
        } catch {
        }
    }
    function K(H, Y) {
      if (!a.resizable) return;
      H.preventDefault(), H.stopPropagation();
      const ee = G.value;
      if (!ee) return;
      const se = ee.getBoundingClientRect();
      J.value = !0, $.value = Y, A.value = { mouseX: H.clientX, mouseY: H.clientY, width: se.width, height: se.height, tx: c.value.x, ty: c.value.y }, document.addEventListener("mousemove", de), document.addEventListener("mouseup", ue);
    }
    function de(H) {
      if (!J.value) return;
      if (H.buttons === 0) {
        ue();
        return;
      }
      const { mouseX: Y, mouseY: ee, width: se, height: xe, tx: ye, ty: Te } = A.value, Ee = H.clientX - Y, Oe = H.clientY - ee, Ve = window.innerWidth - 48, T = window.innerHeight - 48, D = $.value;
      if (D === "s") {
        const P = Math.min(T, Math.max(it, xe + Oe));
        j.value = P, c.value = { x: ye, y: Te + (P - xe) / 2 };
        return;
      }
      if (D === "n") {
        const P = Math.min(T, Math.max(it, xe - Oe));
        j.value = P, c.value = { x: ye, y: Te - (P - xe) / 2 };
        return;
      }
      if (D === "e") {
        const P = Math.min(Ve, Math.max(Fe, se + Ee));
        O.value = P, c.value = { x: ye + (P - se) / 2, y: Te };
        return;
      }
      if (D === "w") {
        const P = Math.min(Ve, Math.max(Fe, se - Ee));
        O.value = P, c.value = { x: ye - (P - se) / 2, y: Te };
        return;
      }
      if (D === "se" || D === "sw") {
        const P = Math.min(T, Math.max(it, xe + Oe));
        j.value = P;
        const le = D === "se" ? Math.min(Ve, Math.max(Fe, se + Ee)) : Math.min(Ve, Math.max(Fe, se - Ee));
        O.value = le, c.value = { x: D === "se" ? ye + (le - se) / 2 : ye - (le - se) / 2, y: Te + (P - xe) / 2 };
        return;
      }
      const g = Math.min(T, Math.max(it, xe - Oe));
      j.value = g;
      const W = D === "ne" ? Math.min(Ve, Math.max(Fe, se + Ee)) : Math.min(Ve, Math.max(Fe, se - Ee));
      O.value = W, c.value = { x: D === "ne" ? ye + (W - se) / 2 : ye - (W - se) / 2, y: Te - (g - xe) / 2 };
    }
    function ue() {
      J.value = !1, z(), document.removeEventListener("mousemove", de), document.removeEventListener("mouseup", ue);
    }
    const ie = () => {
      n("after-show");
    }, ge = () => {
      F(), n("after-hide");
    }, q = () => {
      n("update:visible", !1), n("close");
    }, G = R(null), Q = () => {
      const H = G.value, Y = !a.fullScreen;
      if (!H) {
        n("update:fullScreen", Y), n("maximize", Y);
        return;
      }
      const ee = H.getBoundingClientRect();
      n("update:fullScreen", Y), n("maximize", Y), pe(() => {
        const se = H.getBoundingClientRect(), xe = ee.width / se.width, ye = ee.height / se.height, Te = ee.left + ee.width / 2 - (se.left + se.width / 2), Ee = ee.top + ee.height / 2 - (se.top + se.height / 2);
        H.animate([
          { transform: `translate(${Te}px, ${Ee}px) scale(${xe}, ${ye})`, borderRadius: Y ? "12px" : "0px" },
          { transform: "translate(0, 0) scale(1, 1)", borderRadius: Y ? "0px" : "12px" }
        ], { duration: 350, easing: "cubic-bezier(0.4, 0, 0.2, 1)" });
      });
    }, be = () => {
      a.dismissableMask && a.closable && q();
    };
    let Ze = null;
    function rt() {
      return Array.from(G.value?.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ) ?? []).filter((H) => H.getClientRects().length > 0);
    }
    function ct() {
      const [H] = rt();
      H?.focus();
    }
    const he = (H) => {
      if (!a.visible) return;
      if (a.closeOnEscape && H.key === "Escape") {
        H.preventDefault(), q();
        return;
      }
      if (H.key !== "Tab") return;
      const Y = rt();
      if (!Y.length) return;
      const ee = Y[0], se = Y[Y.length - 1];
      H.shiftKey && document.activeElement === ee ? (H.preventDefault(), se.focus()) : !H.shiftKey && document.activeElement === se && (H.preventDefault(), ee.focus());
    }, { push: Le, consume: Se, pushBackStep: ze, popBackStep: Be } = tn();
    return r({ pushBackStep: ze, popBackStep: Be, wrapperRef: G }), me(() => [a.visible, a.closeOnBrowserBack, a.closable, m.value], ([H]) => {
      const Y = H && a.closeOnBrowserBack && a.closable && m.value;
      H ? (Ze = document.activeElement instanceof HTMLElement ? document.activeElement : null, n("show"), a.blockScroll && (document.body.style.overflow = "hidden"), window.addEventListener("keydown", he), pe(ct), Y ? Le(q) : Se()) : (n("hide"), a.blockScroll && (document.body.style.overflow = ""), window.removeEventListener("keydown", he), Ze?.focus(), Ze = null, Se());
    }, { immediate: !0 }), Ie(() => {
      a.blockScroll && (document.body.style.overflow = ""), window.removeEventListener("keydown", he), document.removeEventListener("mousemove", k), document.removeEventListener("mouseup", M), document.removeEventListener("mousemove", de), document.removeEventListener("mouseup", ue), b && window.visualViewport?.removeEventListener("resize", b);
    }), (H, Y) => (l(), _(De, { to: vn }, [
      U(we, {
        name: y.value ? "dialog-slide" : "dialog",
        appear: "",
        onAfterEnter: ie,
        onAfterLeave: ge
      }, {
        default: ne(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            class: E(["fixed inset-0 flex justify-center", {
              "pointer-events-none": !e.modal,
              "p-4 sm:p-6": !e.fullScreen && !u.value,
              "sm:p-6": u.value && !e.fullScreen,
              "select-none": J.value,
              "items-start": e.keyboardAware && !!p.value && y.value,
              "items-center": !(e.keyboardAware && p.value && y.value)
            }]),
            style: re({ zIndex: e.zIndex }),
            onMousedown: Y[10] || (Y[10] = fe(() => {
            }, ["stop"]))
          }, [
            e.modal ? (l(), s("div", {
              key: 0,
              class: E(["fixed inset-0 bg-black/40 transition-opacity dialog-backdrop", { "backdrop-blur-[2px]": e.blurBackground }]),
              onClick: be
            }, null, 2)) : w("", !0),
            i("div", {
              ref_key: "wrapperRef",
              ref: G,
              class: E(["relative z-10 dialog-scale-wrapper flex flex-col pointer-events-auto origin-center", [e.fullScreen ? "w-full h-full max-w-full" : u.value ? d.value : `${o.value} max-h-[90%]`]]),
              style: re(h.value)
            }, [
              i("div", {
                class: E(["base-dialog-panel relative shadow-2xl w-full h-full flex flex-col overflow-hidden border bg-surface text-ui border-ui", [e.contentClass, e.fullScreen ? "max-h-full rounded-none" : u.value ? "max-h-full rounded-none sm:rounded-xl" : "rounded-xl"]]),
                style: re(x.value),
                role: "dialog",
                "aria-modal": "true",
                "aria-label": e.dialogLabel || e.header || void 0
              }, [
                H.$slots.header || e.header || e.closable ? (l(), s("div", {
                  key: 0,
                  class: E(["base-dialog-header border-b border-ui flex items-center min-h-12 md:min-h-14 shrink-0 transition-all duration-500", [
                    e.fullScreen ? "px-4 py-2" : y.value ? "px-3 py-3" : "px-6 py-3",
                    { "cursor-move select-none": e.draggable },
                    { "max-sm:hidden": e.hideHeaderMobile }
                  ]]),
                  onMousedown: S,
                  onDblclick: Y[1] || (Y[1] = (ee) => {
                    e.maximizable && !y.value && !ee.target.closest("button, a, input") && Q();
                  })
                }, [
                  e.closable && y.value ? (l(), s("button", {
                    key: 0,
                    type: "button",
                    title: "返回",
                    "aria-label": "返回",
                    "data-testid": "base-dialog-mobile-back",
                    onClick: Y[0] || (Y[0] = (ee) => e.customBack ? n("back") : q()),
                    class: "flex items-center justify-center mr-2 shrink-0 transition-colors"
                  }, [
                    i("div", ln, [
                      U(X, {
                        name: "ArrowLeft",
                        size: 18
                      })
                    ])
                  ])) : w("", !0),
                  i("div", rn, [
                    N(H.$slots, "header", {}, () => [
                      e.header ? (l(), s("h3", nn, I(e.header), 1)) : w("", !0)
                    ], !0)
                  ]),
                  i("div", sn, [
                    H.$slots.actions ? (l(), s("div", on, [
                      N(H.$slots, "actions", {}, void 0, !0),
                      y.value ? w("", !0) : (l(), s("div", un))
                    ])) : w("", !0),
                    e.maximizable && e.closable && !y.value ? (l(), s("button", {
                      key: 1,
                      onClick: Q,
                      class: "flex items-center justify-center transition-colors group/max",
                      title: e.fullScreen ? "還原視窗" : "全螢幕顯示"
                    }, [
                      i("div", cn, [
                        U(X, {
                          name: e.fullScreen ? "minimize-2" : "maximize-2",
                          size: 14
                        }, null, 8, ["name"])
                      ])
                    ], 8, dn)) : w("", !0),
                    e.closable && !y.value ? (l(), s("button", {
                      key: 2,
                      onClick: q,
                      class: "flex items-center justify-center transition-colors group/close",
                      title: "關閉對話框"
                    }, [
                      i("div", fn, [
                        U(X, {
                          name: "X",
                          size: 14
                        })
                      ])
                    ])) : w("", !0)
                  ])
                ], 34)) : w("", !0),
                H.$slots["body-top"] ? (l(), s("div", {
                  key: 1,
                  class: E(["base-dialog-body-top shrink-0 border-b border-ui", e.fullScreen ? "px-3 py-2 md:px-6" : "px-6 py-4"])
                }, [
                  N(H.$slots, "body-top", {}, void 0, !0)
                ], 2)) : w("", !0),
                i("div", {
                  class: E(["base-dialog-body flex-1", [e.bodyClass, e.bodyOverflow === "hidden" ? "overflow-hidden" : "overflow-y-auto custom-scrollbar", e.fullScreen ? "px-3 py-2 md:px-6 md:py-4" : "px-6 py-4"]])
                }, [
                  N(H.$slots, "default", {}, void 0, !0)
                ], 2),
                H.$slots.footer ? (l(), s("div", {
                  key: 2,
                  class: E(["border-t border-ui bg-surface-muted rounded-b-xl shrink-0", [e.fullScreen ? "px-4 py-3" : "px-6 py-4", e.footerClass]])
                }, [
                  i("div", mn, [
                    N(H.$slots, "footer", {}, void 0, !0)
                  ])
                ], 2)) : w("", !0)
              ], 14, an),
              e.resizable && !e.fullScreen && !y.value ? (l(), s(te, { key: 0 }, [
                i("div", {
                  class: "absolute right-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: Y[2] || (Y[2] = fe((ee) => K(ee, "e"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute left-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: Y[3] || (Y[3] = fe((ee) => K(ee, "w"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute top-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: Y[4] || (Y[4] = fe((ee) => K(ee, "n"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute bottom-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: Y[5] || (Y[5] = fe((ee) => K(ee, "s"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute top-0 right-0 w-5 h-5 cursor-nesw-resize z-30",
                  onMousedown: Y[6] || (Y[6] = fe((ee) => K(ee, "ne"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute top-0 left-0 w-5 h-5 cursor-nwse-resize z-30",
                  onMousedown: Y[7] || (Y[7] = fe((ee) => K(ee, "nw"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute bottom-0 right-0 w-5 h-5 cursor-nwse-resize z-30 group/rs",
                  onMousedown: Y[8] || (Y[8] = fe((ee) => K(ee, "se"), ["stop"]))
                }, [...Y[11] || (Y[11] = [
                  i("svg", {
                    class: "absolute bottom-0.5 right-0.5 w-2.5 h-2.5 text-ui-dim opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    i("path", {
                      d: "M9 1L1 9M9 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32),
                i("div", {
                  class: "absolute bottom-0 left-0 w-5 h-5 cursor-nesw-resize z-30 group/rs",
                  onMousedown: Y[9] || (Y[9] = fe((ee) => K(ee, "sw"), ["stop"]))
                }, [...Y[12] || (Y[12] = [
                  i("svg", {
                    class: "absolute bottom-0.5 left-0.5 w-2.5 h-2.5 text-ui-dim opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    i("path", {
                      d: "M1 1L9 9M1 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32)
              ], 64)) : w("", !0)
            ], 6)
          ], 38)) : w("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), gn = /* @__PURE__ */ ce(hn, [["__scopeId", "data-v-21a4b8f6"]]), yn = {
  key: 0,
  class: "flex flex-shrink-0 justify-center pt-3"
}, pn = {
  key: 1,
  class: "flex flex-shrink-0 items-center justify-between gap-3 px-4 py-3"
}, xn = { class: "min-w-0" }, wn = "body", Bt = "Close drawer", kn = /* @__PURE__ */ ae({
  inheritAttrs: !1,
  __name: "BaseDrawer",
  props: {
    visible: { type: Boolean, default: !1 },
    title: {},
    subtitle: {},
    position: { default: "bottom" },
    theme: { default: "light" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !0 },
    zIndex: { default: 2200 },
    maxHeight: { default: "72vh" },
    width: { default: "24rem" },
    showHandle: { type: Boolean, default: !0 },
    panelClass: { default: "" },
    bodyClass: { default: "" }
  },
  emits: ["update:visible", "close", "after-hide"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => t.position === "left" ? "base-drawer-left" : t.position === "right" ? "base-drawer-right" : "base-drawer-bottom"), o = C(() => t.position === "right" ? "right-0 top-0 h-full rounded-l-2xl" : t.position === "left" ? "left-0 top-0 h-full rounded-r-2xl" : "inset-x-0 bottom-0 rounded-t-3xl"), u = C(() => t.position === "bottom" ? "w-full" : "max-w-[92vw]"), d = C(() => t.position === "bottom" ? { maxHeight: t.maxHeight } : { width: t.width }), m = C(() => t.theme === "dark" ? "border-white/10 bg-[#0b1320] text-white shadow-black/50" : "border-slate-200 bg-white text-slate-950 shadow-slate-900/20"), y = C(() => t.theme === "dark" ? "bg-black/45" : "bg-slate-950/35"), p = C(() => t.theme === "dark" ? "bg-white/20" : "bg-slate-300"), b = C(() => t.theme === "dark" ? "text-white" : "text-slate-950"), L = C(() => t.theme === "dark" ? "text-slate-400" : "text-slate-500"), c = C(() => t.theme === "dark" ? "bg-white/8 text-slate-200 hover:bg-white/12" : "bg-slate-100 text-slate-700 hover:bg-slate-200"), v = C(() => t.theme === "dark" ? "border-white/10" : "border-slate-200");
    function f() {
      a("update:visible", !1), a("close");
    }
    function h() {
      a("after-hide");
    }
    function x() {
      t.dismissableMask && f();
    }
    function S(k) {
      k.key === "Escape" && t.closeOnEscape && t.visible && f();
    }
    return me(() => t.visible, (k) => {
      document.body.style.overflow = k ? "hidden" : "";
    }), wt(() => document.addEventListener("keydown", S)), Ie(() => {
      document.removeEventListener("keydown", S), document.body.style.overflow = "";
    }), (k, M) => (l(), _(De, { to: wn }, [
      U(we, {
        name: n.value,
        appear: "",
        onAfterLeave: h
      }, {
        default: ne(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            class: "fixed inset-0",
            style: re({ zIndex: e.zIndex })
          }, [
            e.modal ? (l(), s("button", {
              key: 0,
              type: "button",
              class: E(["absolute inset-0 transition-colors", y.value]),
              "aria-label": Bt,
              onClick: x
            }, null, 2)) : w("", !0),
            i("section", {
              class: E(["absolute flex flex-col overflow-hidden border shadow-2xl", [o.value, u.value, e.panelClass, m.value]]),
              style: re(d.value),
              role: "dialog",
              "aria-modal": "true"
            }, [
              e.showHandle && e.position === "bottom" ? (l(), s("div", yn, [
                i("span", {
                  class: E(["h-1.5 w-11 rounded-full", p.value])
                }, null, 2)
              ])) : w("", !0),
              k.$slots.header || e.title || e.closable ? (l(), s("header", pn, [
                i("div", xn, [
                  N(k.$slots, "header", {}, () => [
                    e.title ? (l(), s("p", {
                      key: 0,
                      class: E(["truncate text-sm font-semibold", b.value])
                    }, I(e.title), 3)) : w("", !0),
                    e.subtitle ? (l(), s("p", {
                      key: 1,
                      class: E(["mt-0.5 truncate text-xs", L.value])
                    }, I(e.subtitle), 3)) : w("", !0)
                  ], !0)
                ]),
                e.closable ? (l(), s("button", {
                  key: 0,
                  type: "button",
                  class: E(["flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full transition-colors", c.value]),
                  "aria-label": Bt,
                  onClick: f
                }, [
                  U(X, {
                    name: "X",
                    size: 16
                  })
                ], 2)) : w("", !0)
              ])) : w("", !0),
              i("div", {
                class: E(["base-drawer-body custom-scrollbar min-h-0 flex-1 overflow-y-auto px-4 pb-4", e.bodyClass])
              }, [
                N(k.$slots, "default", {}, void 0, !0)
              ], 2),
              k.$slots.footer ? (l(), s("footer", {
                key: 2,
                class: E(["flex flex-shrink-0 items-center justify-end gap-2 border-t px-4 py-3", v.value])
              }, [
                N(k.$slots, "footer", {}, void 0, !0)
              ], 2)) : w("", !0)
            ], 6)
          ], 4)) : w("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), zi = /* @__PURE__ */ ce(kn, [["__scopeId", "data-v-daaade83"]]), $n = { class: "overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-xs custom-scrollbar dark:border-dark-200 dark:bg-dark-50" }, Cn = { class: "w-full min-w-250 border-collapse text-left" }, Ln = { class: "border-b border-gray-200 bg-gray-50 dark:border-dark-200 dark:bg-dark-100" }, Sn = {
  key: 0,
  class: "w-24 px-3 py-2.5 text-center text-[11px] font-bold uppercase tracking-wider text-gray-700 dark:text-gray-300"
}, zn = { class: "divide-y divide-gray-200 dark:divide-gray-700" }, Bn = {
  key: 3,
  class: "text-gray-900 dark:text-gray-200"
}, Tn = {
  key: 0,
  class: "border-r border-gray-200 px-3 py-2 text-center text-xs last:border-r-0 dark:border-dark-200"
}, En = { class: "flex items-center justify-center gap-2" }, Mn = ["title", "aria-label"], In = ["title", "aria-label"], Dn = ["title", "aria-label", "onClick"], Vn = ["title", "aria-label", "onClick"], An = {
  key: 0,
  class: "bg-primary/5 transition-colors hover:bg-primary/10 dark:bg-primary/10 dark:hover:bg-primary/15"
}, Rn = {
  key: 3,
  class: "text-gray-400 italic dark:text-gray-500"
}, Pn = { class: "border-r border-gray-200 px-3 py-2 text-center text-xs last:border-r-0 dark:border-dark-200" }, Hn = ["title", "aria-label"], Wn = {
  key: 1,
  class: "border-t-2 border-gray-200 bg-gray-50/80 font-bold dark:border-dark-200 dark:bg-dark-100/80"
}, On = ["colspan"], jn = { class: "flex w-full items-center justify-between" }, Fn = { class: "text-left text-gray-700 dark:text-gray-300" }, Kn = { class: "text-right text-gray-700 dark:text-gray-300" }, Nn = { class: "px-3 py-3 text-right text-sm whitespace-nowrap text-primary" }, Bi = /* @__PURE__ */ ae({
  __name: "BaseEditableTable",
  props: {
    data: {},
    columns: {},
    editingIndex: {},
    editingRow: {},
    newItem: {},
    totalLabel: {},
    totalValue: {},
    readonly: { type: Boolean, default: !1 },
    actionsLabel: { default: "Actions" },
    saveLabel: { default: "Save" },
    cancelLabel: { default: "Cancel" },
    editLabel: { default: "Edit" },
    deleteLabel: { default: "Delete" },
    addLabel: { default: "Add" },
    autoLabel: { default: "Auto" }
  },
  emits: ["start-edit", "save-edit", "cancel-edit", "remove-row", "add-item"],
  setup(e, { emit: r }) {
    const t = r, a = (n) => n === "center" ? "text-center" : n === "right" ? "text-right" : "text-left";
    return (n, o) => (l(), s("div", $n, [
      i("table", Cn, [
        i("thead", null, [
          i("tr", Ln, [
            (l(!0), s(te, null, oe(e.columns, (u) => (l(), s("th", {
              key: u.key,
              style: re({ width: u.width }),
              class: E(["border-r border-gray-200 px-3 py-2.5 text-[11px] font-bold uppercase tracking-wider whitespace-pre-line text-gray-700 last:border-r-0 dark:border-dark-200 dark:text-gray-300", a(u.align)])
            }, I(u.label), 7))), 128)),
            e.readonly ? w("", !0) : (l(), s("th", Sn, I(e.actionsLabel), 1))
          ])
        ]),
        i("tbody", zn, [
          (l(!0), s(te, null, oe(e.data, (u, d) => (l(), s("tr", {
            key: d,
            class: E([d % 2 === 1 ? "bg-gray-50/50 dark:bg-dark-100/30" : "bg-white dark:bg-dark-50/40", "transition-colors hover:bg-primary/5 dark:hover:bg-primary/10"])
          }, [
            (l(!0), s(te, null, oe(e.columns, (m) => (l(), s("td", {
              key: m.key,
              class: E(["border-r border-gray-200 px-3 py-2 text-xs last:border-r-0 dark:border-dark-200", a(m.align)])
            }, [
              e.editingIndex === d && e.editingRow ? N(n.$slots, `edit-${m.key}`, {
                row: e.editingRow,
                index: d
              }, () => [
                m.type === "text" ? (l(), _(Ke, {
                  key: 0,
                  modelValue: e.editingRow[m.key],
                  "onUpdate:modelValue": (y) => e.editingRow[m.key] = y,
                  placeholder: m.placeholder,
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : m.type === "number" ? (l(), _(Ke, {
                  key: 1,
                  modelValue: e.editingRow[m.key],
                  "onUpdate:modelValue": (y) => e.editingRow[m.key] = y,
                  modelModifiers: { number: !0 },
                  type: "number",
                  step: "any",
                  placeholder: m.placeholder,
                  size: "sm",
                  class: E({ "text-right": m.align === "right" })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])) : m.type === "select" ? (l(), _(gt, {
                  key: 2,
                  modelValue: e.editingRow[m.key],
                  "onUpdate:modelValue": (y) => e.editingRow[m.key] = y,
                  options: m.options || [],
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])) : (l(), s("span", Bn, I(u[m.key]), 1))
              ], void 0, 0) : N(n.$slots, `cell-${m.key}`, {
                row: u,
                index: d
              }, () => [
                i("span", {
                  class: E(m.type === "readonly" ? "text-gray-500 dark:text-gray-400" : "text-gray-900 dark:text-gray-200")
                }, I(u[m.key]), 3)
              ], void 0, 1)
            ], 2))), 128)),
            e.readonly ? w("", !0) : (l(), s("td", Tn, [
              i("div", En, [
                e.editingIndex === d ? (l(), s(te, { key: 0 }, [
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-green-600 transition-colors hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20",
                    title: e.saveLabel,
                    "aria-label": e.saveLabel,
                    onClick: o[0] || (o[0] = (m) => t("save-edit"))
                  }, [
                    U(X, {
                      name: "Save",
                      size: 14
                    })
                  ], 8, Mn),
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-gray-400 transition-colors hover:bg-gray-100 dark:text-gray-500 dark:hover:bg-dark-200",
                    title: e.cancelLabel,
                    "aria-label": e.cancelLabel,
                    onClick: o[1] || (o[1] = (m) => t("cancel-edit"))
                  }, [
                    U(X, {
                      name: "X",
                      size: 14
                    })
                  ], 8, In)
                ], 64)) : (l(), s(te, { key: 1 }, [
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-primary transition-colors hover:bg-primary/5 dark:hover:bg-primary/10",
                    title: e.editLabel,
                    "aria-label": e.editLabel,
                    onClick: (m) => t("start-edit", d)
                  }, [
                    U(X, {
                      name: "Pencil",
                      size: 14
                    })
                  ], 8, Dn),
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20",
                    title: e.deleteLabel,
                    "aria-label": e.deleteLabel,
                    onClick: (m) => t("remove-row", d)
                  }, [
                    U(X, {
                      name: "Trash2",
                      size: 14
                    })
                  ], 8, Vn)
                ], 64))
              ])
            ]))
          ], 2))), 128)),
          e.readonly ? w("", !0) : (l(), s("tr", An, [
            (l(!0), s(te, null, oe(e.columns, (u) => (l(), s("td", {
              key: u.key,
              class: E(["border-r border-gray-200 px-3 py-2 text-xs last:border-r-0 dark:border-dark-200", a(u.align)])
            }, [
              N(n.$slots, `new-${u.key}`, { row: e.newItem }, () => [
                u.type === "text" ? (l(), _(Ke, {
                  key: 0,
                  modelValue: e.newItem[u.key],
                  "onUpdate:modelValue": (d) => e.newItem[u.key] = d,
                  placeholder: u.placeholder,
                  size: "sm",
                  onKeyup: o[2] || (o[2] = $t((d) => t("add-item"), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : u.type === "number" ? (l(), _(Ke, {
                  key: 1,
                  modelValue: e.newItem[u.key],
                  "onUpdate:modelValue": (d) => e.newItem[u.key] = d,
                  modelModifiers: { number: !0 },
                  type: "number",
                  step: "any",
                  placeholder: u.placeholder,
                  size: "sm",
                  class: E({ "text-right": u.align === "right" }),
                  onKeyup: o[3] || (o[3] = $t((d) => t("add-item"), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])) : u.type === "select" ? (l(), _(gt, {
                  key: 2,
                  modelValue: e.newItem[u.key],
                  "onUpdate:modelValue": (d) => e.newItem[u.key] = d,
                  options: u.options || [],
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])) : (l(), s("span", Rn, I(e.autoLabel), 1))
              ])
            ], 2))), 128)),
            i("td", Pn, [
              i("button", {
                type: "button",
                class: "mx-auto flex items-center justify-center rounded-full p-1.5 text-primary transition-colors hover:bg-primary/5 dark:hover:bg-primary/10",
                title: e.addLabel,
                "aria-label": e.addLabel,
                onClick: o[4] || (o[4] = (u) => t("add-item"))
              }, [
                U(X, {
                  name: "Plus",
                  size: 16
                })
              ], 8, Hn)
            ])
          ])),
          e.totalLabel ? (l(), s("tr", Wn, [
            i("td", {
              colspan: e.readonly ? e.columns.length - 1 : e.columns.length,
              class: "px-3 py-3 text-sm"
            }, [
              i("div", jn, [
                i("span", Fn, [
                  N(n.$slots, "footer-left")
                ]),
                i("span", Kn, I(e.totalLabel) + ": ", 1)
              ])
            ], 8, On),
            i("td", Nn, I(e.totalValue), 1)
          ])) : w("", !0)
        ])
      ])
    ]));
  }
}), Un = ["aria-busy"], qn = {
  key: 0,
  class: "base-table-header-cell px-4 py-3.5 w-10 text-center sticky top-0 z-10 backdrop-blur-md"
}, Xn = ["checked", "indeterminate"], Yn = ["onClick"], Gn = {
  key: 0,
  class: "text-[10px] text-primary animate-in fade-in zoom-in duration-300"
}, Zn = ["data-table-row-kind", "data-table-row-key", "onClick"], Jn = ["checked", "onChange"], Qn = {
  key: 0,
  class: "flex items-center gap-2"
}, _n = ["colspan"], es = {
  key: 0,
  class: "base-table-skeleton-table w-full border-collapse text-left text-xs",
  "aria-hidden": "true"
}, ts = {
  key: 0,
  class: "base-table-cell px-4 py-3 w-10"
}, as = {
  key: 1,
  class: "base-table-empty-state flex flex-col items-center justify-center py-12"
}, ls = { class: "base-table-empty-icon w-16 h-16 rounded-full flex items-center justify-center text-3xl mb-4 border shadow-inner" }, rs = { class: "base-table-empty-title text-sm font-bold mb-1" }, ns = {
  key: 0,
  class: "base-table-empty-description text-[11px] max-w-xs text-center"
}, ss = ["aria-label"], os = { class: "sr-only" }, is = /* @__PURE__ */ ae({
  __name: "BaseTable",
  props: {
    columns: {},
    data: {},
    sortField: { default: "" },
    sortDirection: { default: "" },
    loading: { type: Boolean, default: !1 },
    emptyMessage: { default: "No data" },
    emptyDescription: {},
    emptyIcon: { default: "Inbox" },
    loadingLabel: { default: "Loading" },
    rowKey: { type: [String, Function], default: "id" },
    rowAttrs: {},
    rowTransition: { default: "slide" },
    expandable: { type: Boolean, default: !1 },
    expandedRows: {},
    highlightIds: {},
    disableTransition: { type: Boolean, default: !1 },
    minHeight: { default: "" },
    fixedLayout: { type: Boolean, default: !1 },
    rowClass: {},
    selectable: { type: Boolean, default: !1 },
    selection: { default: () => /* @__PURE__ */ new Set() },
    selectionKey: { type: [String, Function], default: "id" },
    hoverable: { type: Boolean, default: !0 },
    striped: { type: Boolean, default: !1 },
    emptyText: {},
    headerClass: { default: "" }
  },
  emits: ["sort", "update:expandedRows", "row-click", "update:selection"],
  setup(e, { emit: r }) {
    const t = e, a = C(() => t.emptyMessage), n = C(() => t.emptyDescription || ""), o = R(t.disableTransition);
    me(
      () => t.disableTransition,
      ($) => {
        $ ? o.value = !0 : setTimeout(() => {
          o.value = !1;
        }, 100);
      },
      { immediate: !0 }
    );
    const u = r, d = R(/* @__PURE__ */ new Set()), m = ($) => (t.expandedRows || d.value).has($), y = ($) => {
      const A = new Set(t.expandedRows || d.value);
      A.has($) ? A.delete($) : A.add($), t.expandedRows ? u("update:expandedRows", A) : d.value = A;
    }, p = ($, A) => {
      t.expandable && y(A), u("row-click", $, A);
    }, b = C(() => t.columns.filter(($) => $.visible !== !1)), L = ($) => {
      u("sort", $);
    }, c = ($) => typeof t.selectionKey == "function" ? t.selectionKey($) : String($[t.selectionKey] ?? ""), v = ($) => t.selection.has(c($)), f = ($) => {
      const A = c($), z = new Set(t.selection);
      z.has(A) ? z.delete(A) : z.add(A), u("update:selection", z);
    }, h = C(() => t.data.length === 0 ? !1 : t.data.every(($) => t.selection.has(c($)))), x = C(() => {
      if (t.data.length === 0) return !1;
      const $ = t.data.filter(
        (A) => t.selection.has(c(A))
      ).length;
      return $ > 0 && $ < t.data.length;
    }), S = () => {
      const $ = new Set(t.selection);
      h.value ? t.data.forEach((A) => $.delete(c(A))) : t.data.forEach((A) => $.add(c(A))), u("update:selection", $);
    }, k = ($, A) => typeof t.rowKey == "function" ? t.rowKey($) : String($[t.rowKey] ?? A), M = ($, A) => {
      const z = String(A).split(".");
      let K = $;
      for (const de of z) {
        if (K == null || typeof K != "object") return null;
        K = K[de];
      }
      return K;
    }, F = ($, A) => {
      const z = M($, A.key);
      return z == null ? "-" : A.formatter ? A.formatter(z, $) : Array.isArray(z) ? z.join(", ") : String(z);
    }, V = ($) => {
      const A = [];
      return $.key === "name" ? A.push("font-medium") : $.key === "id" && A.push("font-mono text-[10px]"), A.join(" ");
    }, B = C(() => o.value || t.rowTransition === "none" ? "" : t.rowTransition === "fade-collapse" ? "base-table-fade-collapse" : "list"), O = ($, A, z) => t.rowAttrs?.($, A, z) || {}, j = ($, A) => {
      if (t.rowTransition !== "fade-collapse" || o.value || typeof window > "u") {
        A();
        return;
      }
      const z = $, K = z.getBoundingClientRect().height;
      z.style.height = `${K}px`, z.style.overflow = "hidden", z.style.pointerEvents = "none", window.requestAnimationFrame(() => {
        z.style.height = "0px", z.style.opacity = "0";
      }), window.setTimeout(A, 200);
    }, J = C(() => {
      const $ = [];
      return t.data.forEach((A, z) => {
        const K = k(A, z);
        $.push({ type: "main", row: A, index: z, key: K }), t.expandable && m(K) && $.push({ type: "expanded", row: A, index: z, key: `${K}-expanded` });
      }), $;
    });
    return ($, A) => (l(), s("div", {
      class: E([
        "base-table-surface overflow-auto custom-scrollbar border rounded-2xl shadow-sm relative transition-all duration-300",
        { "no-transitions": o.value }
      ]),
      "aria-busy": e.loading,
      style: re(e.minHeight ? { minHeight: e.minHeight } : {})
    }, [
      i("table", {
        class: E([
          "w-full border-collapse text-left text-xs",
          { "table-fixed": e.fixedLayout }
        ])
      }, [
        i("thead", null, [
          i("tr", {
            class: E(e.headerClass)
          }, [
            e.selectable ? (l(), s("th", qn, [
              i("input", {
                type: "checkbox",
                checked: h.value,
                indeterminate: x.value,
                onChange: S,
                class: "rounded border-gray-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer"
              }, null, 40, Xn)
            ])) : w("", !0),
            (l(!0), s(te, null, oe(b.value, (z) => (l(), s("th", {
              key: String(z.key),
              class: E([
                "base-table-header-cell px-4 py-3.5 font-bold transition-all duration-200 group sticky top-0 z-10 backdrop-blur-md",
                z.sortable ? "base-table-header-cell--sortable cursor-pointer" : "",
                z.align === "center" ? "text-center" : z.align === "right" ? "text-right" : "text-left"
              ]),
              style: re(z.width ? { width: z.width } : {}),
              onClick: (K) => z.sortable ? L(z.key) : null
            }, [
              N($.$slots, `header-${String(z.key)}`, { column: z }, () => [
                i("div", {
                  class: E(["flex items-center gap-1.5", z.align === "center" ? "justify-center" : z.align === "right" ? "justify-end" : ""])
                }, [
                  i("span", null, I(z.label), 1),
                  z.sortable && e.sortField === z.key ? (l(), s("span", Gn, I(e.sortDirection === "asc" ? "↑" : "↓"), 1)) : z.sortable ? (l(), _(X, {
                    key: 1,
                    name: "ChevronDown",
                    size: 10,
                    class: "opacity-0 group-hover:opacity-30 transition-opacity"
                  })) : w("", !0)
                ], 2)
              ], !0)
            ], 14, Yn))), 128))
          ], 2)
        ]),
        U(Ye, {
          name: B.value,
          css: !o.value && e.rowTransition !== "none",
          tag: "tbody",
          onLeave: j
        }, {
          default: ne(() => [
            (l(!0), s(te, null, oe(J.value, (z) => (l(), s("tr", We({
              key: z.key,
              "data-table-row-kind": z.type,
              "data-table-row-key": z.key
            }, { ref_for: !0 }, O(z.row, z.key, z.type), {
              class: [
                "base-table-row transition-colors duration-200 border-b",
                z.type === "main" ? " hover:bg-primary/5 dark:hover:bg-primary/10 cursor-pointer" + (e.highlightIds?.includes(z.key) ? " animate-highlight" : "") : " whitespace-normal",
                z.type === "main" && e.rowClass ? typeof e.rowClass == "function" ? e.rowClass(z.row) : e.rowClass : ""
              ],
              onClick: (K) => z.type === "main" ? p(z.row, z.key) : null
            }), [
              z.type === "main" ? (l(), s(te, { key: 0 }, [
                e.selectable ? (l(), s("td", {
                  key: 0,
                  class: "base-table-cell px-4 py-3 w-10 text-center",
                  onClick: A[0] || (A[0] = fe(() => {
                  }, ["stop"]))
                }, [
                  i("input", {
                    type: "checkbox",
                    checked: v(z.row),
                    onChange: (K) => f(z.row),
                    class: "rounded border-gray-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer"
                  }, null, 40, Jn)
                ])) : w("", !0),
                (l(!0), s(te, null, oe(b.value, (K) => (l(), s("td", {
                  key: String(K.key),
                  class: E([
                    "base-table-cell px-4 py-3 min-w-25",
                    K.key === "id" || K.key === "_id" || String(K.key).toLowerCase().includes("id") ? "whitespace-nowrap" : "",
                    K.align === "center" ? "text-center" : K.align === "right" ? "text-right" : "text-left",
                    V(K)
                  ])
                }, [
                  e.expandable && K === b.value[0] ? (l(), s("div", Qn, [
                    U(X, {
                      name: "ChevronRight",
                      size: 10,
                      class: E(["base-table-expand-icon transition-transform duration-300", { "rotate-90": m(z.key) }])
                    }, null, 8, ["class"]),
                    N($.$slots, `cell-${String(K.key)}`, {
                      row: z.row,
                      column: K,
                      value: M(z.row, K.key)
                    }, () => [
                      $e(I(F(z.row, K)), 1)
                    ], !0)
                  ])) : N($.$slots, `cell-${String(K.key)}`, {
                    row: z.row,
                    column: K,
                    value: M(z.row, K.key)
                  }, () => [
                    $e(I(F(z.row, K)), 1)
                  ], !0, 1)
                ], 2))), 128))
              ], 64)) : (l(), s("td", {
                key: 1,
                colspan: b.value.length + (e.selectable ? 1 : 0),
                class: "base-table-expanded-cell px-4 py-4 border-t"
              }, [
                N($.$slots, "expanded-row", {
                  row: z.row,
                  index: z.index
                }, void 0, !0)
              ], 8, _n))
            ], 16, Zn))), 128))
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2),
      e.loading && e.data.length === 0 ? (l(), s("table", es, [
        i("tbody", null, [
          (l(), s(te, null, oe(5, (z) => i("tr", {
            key: `loading-skeleton-${z}`,
            class: "base-table-row border-b"
          }, [
            e.selectable ? (l(), s("td", ts, [...A[1] || (A[1] = [
              i("div", { class: "base-table-skeleton-block mx-auto h-4 w-4 rounded" }, null, -1)
            ])])) : w("", !0),
            (l(!0), s(te, null, oe(b.value, (K) => (l(), s("td", {
              key: String(K.key),
              class: "base-table-cell px-4 py-3"
            }, [
              i("div", {
                class: E(["base-table-skeleton-block h-3 rounded", K.align === "right" ? "ml-auto w-2/3" : "w-3/4"])
              }, null, 2)
            ]))), 128))
          ])), 64))
        ])
      ])) : w("", !0),
      e.data.length === 0 && !e.loading ? (l(), s("div", as, [
        N($.$slots, "empty", {}, () => [
          i("div", ls, [
            U(X, { name: e.emptyIcon }, null, 8, ["name"])
          ]),
          i("h3", rs, I(a.value), 1),
          n.value ? (l(), s("p", ns, I(n.value), 1)) : w("", !0)
        ], !0)
      ])) : w("", !0),
      U(we, {
        "enter-active-class": "transition-opacity duration-300",
        "leave-active-class": "transition-opacity duration-300",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: ne(() => [
          e.loading && e.data.length > 0 ? (l(), s("div", {
            key: 0,
            class: "base-table-loading pointer-events-none absolute inset-x-0 top-0 z-20 h-0.5 overflow-hidden",
            role: "status",
            "aria-label": e.loadingLabel
          }, [
            A[2] || (A[2] = i("div", { class: "base-table-loading-progress h-full w-2/5" }, null, -1)),
            N($.$slots, "loading", {}, () => [
              i("span", os, I(e.loadingLabel), 1)
            ], !0)
          ], 8, ss)) : w("", !0)
        ]),
        _: 3
      })
    ], 14, Un));
  }
}), Ti = /* @__PURE__ */ ce(is, [["__scopeId", "data-v-9eb9da19"]]), us = ["aria-busy"], ds = {
  key: 0,
  class: "base-collection-view-empty flex min-h-48 items-center justify-center"
}, cs = { class: "base-collection-view-empty-content flex flex-col items-center gap-2 text-center" }, fs = { class: "base-collection-view-empty-title text-sm font-bold" }, ms = {
  key: 0,
  class: "base-collection-view-empty-description max-w-xs text-xs"
}, vs = {
  key: 0,
  class: "base-collection-view-loading absolute inset-0 z-10 flex items-center justify-center backdrop-blur-[1px]"
}, bs = { class: "flex flex-col items-center gap-3" }, hs = { class: "base-collection-view-loading-label text-[11px] font-bold uppercase tracking-widest animate-pulse" }, gs = /* @__PURE__ */ ae({
  __name: "BaseCollectionView",
  props: {
    items: {},
    itemKey: { type: [String, Function], default: "id" },
    itemTag: { default: "article" },
    itemClass: { type: [String, Function], default: "" },
    itemAttrs: { type: Function, default: void 0 },
    itemState: {},
    layout: { default: "grid" },
    minItemWidth: { default: "14rem" },
    gap: { default: "1rem" },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: "Loading" },
    emptyMessage: { default: "No items" },
    emptyDescription: { default: "" },
    emptyIcon: { default: "Inbox" },
    minHeight: { default: "" },
    transition: { default: "fade-collapse" },
    clickable: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    selection: { default: () => /* @__PURE__ */ new Set() },
    selectionKey: { type: [String, Function], default: "id" }
  },
  emits: ["item-click", "item-dblclick", "update:selection"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => t.layout === "grid" ? "grid" : "flex flex-col"), o = C(
      () => t.layout === "grid" ? {
        gridTemplateColumns: `repeat(auto-fill, minmax(${t.minItemWidth}, 1fr))`,
        gap: t.gap
      } : { gap: t.gap }
    ), u = C(() => t.transition === "none" ? "" : t.transition === "fade-collapse" ? "base-collection-fade-collapse" : "base-collection-slide"), d = (x, S) => typeof t.itemKey == "function" ? t.itemKey(x, S) : String(x[t.itemKey] ?? S), m = (x, S) => typeof t.selectionKey == "function" ? t.selectionKey(x, S) : String(x[t.selectionKey] ?? d(x, S)), y = (x, S = 0) => t.selection.has(m(x, S)), p = (x, S) => t.itemState?.(x, S, d(x, S)) || {}, b = (x, S) => t.itemAttrs?.(x, S, d(x, S)) || {}, L = (x, S = 0) => {
      if (!t.selectable || p(x, S).disabled) return;
      const k = new Set(t.selection), M = m(x, S);
      k.has(M) ? k.delete(M) : k.add(M), a("update:selection", k);
    }, c = (x, S) => {
      !t.clickable || p(x, S).disabled || a("item-click", x, d(x, S), S);
    }, v = (x, S, k) => {
      !t.clickable || p(S, k).disabled || x.key !== "Enter" && x.key !== " " || (x.preventDefault(), c(S, k));
    }, f = (x, S) => {
      !t.clickable || p(x, S).disabled || a("item-dblclick", x, d(x, S), S);
    }, h = (x, S) => {
      if (t.transition !== "fade-collapse" || typeof window > "u") {
        S();
        return;
      }
      const k = x;
      k.style.height = `${k.getBoundingClientRect().height}px`, k.style.overflow = "hidden", k.style.pointerEvents = "none", window.requestAnimationFrame(() => {
        k.style.height = "0px", k.style.opacity = "0";
      }), window.setTimeout(S, 200);
    };
    return (x, S) => (l(), s("div", {
      class: "base-collection-view relative",
      style: re(e.minHeight ? { minHeight: e.minHeight } : void 0),
      "aria-busy": e.loading || void 0
    }, [
      e.items.length === 0 && !e.loading ? (l(), s("div", ds, [
        N(x.$slots, "empty", {}, () => [
          i("div", cs, [
            U(X, {
              name: e.emptyIcon,
              size: 28
            }, null, 8, ["name"]),
            i("span", fs, I(e.emptyMessage), 1),
            e.emptyDescription ? (l(), s("span", ms, I(e.emptyDescription), 1)) : w("", !0)
          ])
        ], !0)
      ])) : e.items.length > 0 ? (l(), _(Ye, {
        key: 1,
        name: u.value,
        css: e.transition !== "none",
        tag: "div",
        role: "list",
        class: E(["base-collection-view-items", n.value]),
        style: re(o.value),
        onLeave: h
      }, {
        default: ne(() => [
          (l(!0), s(te, null, oe(e.items, (k, M) => (l(), _(pt(e.itemTag), We({
            key: d(k, M),
            class: ["base-collection-view-item", [
              typeof e.itemClass == "function" ? e.itemClass(k, M) : e.itemClass,
              {
                "base-collection-view-item--pending": p(k, M).pending,
                "base-collection-view-item--disabled": p(k, M).disabled
              }
            ]],
            "data-collection-item-key": d(k, M)
          }, { ref_for: !0 }, b(k, M), {
            role: "listitem",
            "aria-selected": e.selectable ? y(k) : void 0,
            "aria-disabled": p(k, M).disabled || void 0,
            tabindex: e.clickable && !p(k, M).disabled ? 0 : void 0,
            onClick: (F) => c(k, M),
            onDblclick: (F) => f(k, M),
            onKeydown: (F) => v(F, k, M)
          }), {
            default: ne(() => [
              N(x.$slots, "item", {
                item: k,
                index: M,
                keyValue: d(k, M),
                selected: y(k),
                pending: p(k, M).pending,
                disabled: p(k, M).disabled,
                toggleSelection: () => L(k)
              }, void 0, !0)
            ]),
            _: 2
          }, 1040, ["class", "data-collection-item-key", "aria-selected", "aria-disabled", "tabindex", "onClick", "onDblclick", "onKeydown"]))), 128))
        ]),
        _: 3
      }, 8, ["name", "css", "class", "style"])) : w("", !0),
      U(we, {
        "enter-active-class": "transition-opacity duration-200",
        "leave-active-class": "transition-opacity duration-200",
        "enter-from-class": "opacity-0",
        "leave-to-class": "opacity-0"
      }, {
        default: ne(() => [
          e.loading ? (l(), s("div", vs, [
            N(x.$slots, "loading", {}, () => [
              i("div", bs, [
                S[0] || (S[0] = i("div", { class: "base-collection-view-spinner h-8 w-8 animate-spin rounded-full border-2 border-transparent border-t-current" }, null, -1)),
                i("span", hs, I(e.loadingLabel), 1)
              ])
            ], !0)
          ])) : w("", !0)
        ]),
        _: 3
      })
    ], 12, us));
  }
}), Ei = /* @__PURE__ */ ce(gs, [["__scopeId", "data-v-ae3c38cf"]]), ys = {
  key: 0,
  class: "fixed bottom-8 left-1/2 z-50 -translate-x-1/2"
}, ps = { class: "flex items-center gap-5 rounded-2xl border border-white/10 bg-gray-900/90 px-5 py-2.5 text-white shadow-[0_20px_50px_rgba(0,0,0,0.3)] ring-1 ring-white/5 backdrop-blur-md dark:bg-dark-100/95" }, xs = { class: "flex items-center gap-3 border-r border-white/10 pr-5" }, ws = { class: "flex h-7 w-7 items-center justify-center rounded-lg bg-primary/20 text-xs font-bold text-primary-400 shadow-inner ring-1 ring-primary/30" }, ks = { class: "text-[13px] font-semibold tracking-wide whitespace-nowrap" }, $s = { class: "flex items-center gap-2" }, Cs = ["title", "aria-label"], Mi = /* @__PURE__ */ ae({
  __name: "BatchActionBar",
  props: {
    selectedCount: {},
    selectedLabel: { default: "Selected" },
    clearLabel: { default: "Clear selection" }
  },
  emits: ["clear"],
  setup(e) {
    return (r, t) => (l(), _(we, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "translate-y-full opacity-0",
      "enter-to-class": "translate-y-0 opacity-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "translate-y-0 opacity-100",
      "leave-to-class": "translate-y-full opacity-0"
    }, {
      default: ne(() => [
        e.selectedCount > 0 ? (l(), s("div", ys, [
          i("div", ps, [
            i("div", xs, [
              i("div", ws, I(e.selectedCount), 1),
              i("span", ks, I(e.selectedLabel), 1)
            ]),
            i("div", $s, [
              N(r.$slots, "default", { count: e.selectedCount })
            ]),
            i("button", {
              class: "group ml-1 rounded-xl p-1.5 text-white/40 transition-all duration-200 hover:bg-white/10 hover:text-white",
              title: e.clearLabel,
              "aria-label": e.clearLabel,
              onClick: t[0] || (t[0] = (a) => r.$emit("clear"))
            }, [
              U(X, {
                name: "x",
                size: 16,
                class: "transition-transform duration-300 group-hover:rotate-90"
              })
            ], 8, Cs)
          ])
        ])) : w("", !0)
      ]),
      _: 3
    }));
  }
}), Me = R([]);
function Ii() {
  function e(t) {
    return new Promise((a) => {
      Me.value = [...Me.value, { opts: t, resolve: a }];
    });
  }
  function r() {
    const t = Me.value[0];
    t && (t.resolve(!1), Me.value = Me.value.slice(1));
  }
  return { confirm: e, closeDialog: r };
}
const Ls = { class: "flex flex-col items-center text-center p-2 pt-6" }, Ss = { class: "confirmation-message text-sm mb-4 max-w-[90%] mx-auto" }, zs = {
  key: 0,
  class: "text-xs text-red-500 font-bold mb-6 italic"
}, Bs = {
  key: 0,
  class: "flex flex-col gap-1.5 mb-3"
}, Ts = { class: "confirmation-summary-label transition-colors" }, Es = { class: "confirmation-summary-value font-bold font-mono tracking-tight" }, Ms = {
  key: 1,
  class: "border-t border-gray-200 dark:border-dark-200 my-2 opacity-50"
}, Is = { class: "flex gap-2 text-left" }, Ds = { class: "flex flex-col gap-1.5 w-full" }, Vs = {
  key: 0,
  class: "confirmation-detail-text text-xs wrap-break-word whitespace-pre-wrap"
}, As = {
  key: 1,
  class: "confirmation-detail-text text-xs list-none p-0 m-0 space-y-1.5"
}, Rs = { class: "flex items-start gap-1.5 flex-1 leading-relaxed" }, Ps = {
  key: 0,
  class: "confirmation-detail-label font-bold whitespace-nowrap"
}, Hs = { class: "wrap-break-word flex-1" }, Ws = {
  key: 2,
  class: "mt-3 pt-2 border-t border-gray-200/60 dark:border-dark-200/60 flex gap-2 text-left"
}, Os = { class: "confirmation-note text-[10px]" }, js = { class: "grid grid-cols-2 gap-3 w-full mt-2" }, Fs = /* @__PURE__ */ ae({
  __name: "ConfirmationDialog",
  setup(e) {
    const r = {
      title: "確認",
      message: "確定要執行此操作嗎?",
      confirmLabel: "確認",
      cancelLabel: "取消",
      severity: "info",
      showInfoIcon: !1,
      showBulletPoints: !1,
      scrollable: !0,
      maxHeight: "240px"
    }, t = R(!1), a = R(!1), n = R({ ...r });
    me(Me, async (j) => {
      j.length > 0 && !t.value && (await pe(), a.value = !1, n.value = { ...r, ...j[0].opts }, t.value = !0);
    }, { immediate: !0 });
    function o(j) {
      const J = Me.value[0];
      J && J.resolve(j), Me.value = Me.value.slice(1), t.value = !1;
    }
    const u = C(() => {
      if (n.value.icon) return n.value.icon;
      switch (n.value.severity) {
        case "danger":
          return "AlertTriangle";
        case "warning":
          return "AlertCircle";
        case "success":
          return "CheckCircle2";
        default:
          return "Info";
      }
    }), d = C(() => {
      switch (n.value.severity) {
        case "danger":
          return "confirmation-icon--danger";
        case "warning":
          return "confirmation-icon--warning";
        case "success":
          return "confirmation-icon--success";
        default:
          return "confirmation-icon--info";
      }
    }), m = C(() => {
      switch (n.value.severity) {
        case "danger":
          return "bg-red-500";
        case "warning":
          return "bg-orange-500";
        case "success":
          return "bg-green-500";
        default:
          return "bg-blue-500";
      }
    }), y = C(() => {
      switch (n.value.severity) {
        case "danger":
          return "shadow-red-500/20";
        case "warning":
          return "shadow-primary/20";
        case "success":
          return "shadow-green-500/20";
        default:
          return "shadow-primary/20";
      }
    }), p = C(() => n.value.title), b = C(() => n.value.message), L = C(() => n.value.warning), c = C(() => n.value.details), v = C(() => n.value.detailsItems), f = C(() => n.value.summary), h = C(() => n.value.note), x = C(() => n.value.confirmLabel || "確認"), S = C(() => n.value.cancelLabel || "取消"), k = C(() => n.value.severity || "info"), M = C(() => n.value.width || "420px"), F = C(() => n.value.contentClass || ""), V = (j) => {
      const J = j.match(/^([^:：]+[:：])\s*(.*)$/s);
      return J ? { label: J[1], text: J[2] } : { label: "", text: j };
    };
    async function B() {
      if (n.value.onConfirm) {
        a.value = !0;
        try {
          await n.value.onConfirm();
        } finally {
          a.value = !1;
        }
      }
      o(!0);
    }
    function O() {
      n.value.onCancel?.(), o(!1);
    }
    return (j, J) => (l(), _(gn, {
      visible: t.value,
      "onUpdate:visible": J[0] || (J[0] = ($) => t.value = $),
      header: p.value,
      closable: !1,
      width: M.value,
      maxWidth: "sm",
      zIndex: 3e3,
      "content-class": F.value
    }, {
      default: ne(() => [
        i("div", Ls, [
          i("div", {
            class: E(["confirmation-icon relative flex items-center justify-center w-20 h-20 rounded-full mb-5 transition-transform hover:scale-105 duration-300", d.value])
          }, [
            i("div", {
              class: E(["absolute inset-0 rounded-full animate-ping opacity-20", m.value])
            }, null, 2),
            U(X, {
              name: u.value,
              class: "relative z-10",
              size: 40
            }, null, 8, ["name"])
          ], 2),
          i("p", Ss, I(b.value), 1),
          L.value ? (l(), s("p", zs, I(L.value), 1)) : w("", !0),
          c.value || f.value || h.value || v.value && v.value.length > 0 ? (l(), s("div", {
            key: 1,
            class: E(["confirmation-details w-full border rounded-xl p-3 mb-6 text-left animate-in fade-in slide-in-from-top-1", { "overflow-y-auto min-h-0": n.value.scrollable }]),
            style: re(n.value.scrollable ? { maxHeight: n.value.maxHeight || "200px" } : {})
          }, [
            f.value && f.value.length > 0 ? (l(), s("div", Bs, [
              (l(!0), s(te, null, oe(f.value, ($, A) => (l(), s("div", {
                key: A,
                class: E(["flex justify-between items-center text-xs group", $.class])
              }, [
                i("span", Ts, I($.label), 1),
                i("span", Es, I($.value), 1)
              ], 2))), 128))
            ])) : w("", !0),
            c.value && f.value && f.value.length > 0 ? (l(), s("div", Ms)) : w("", !0),
            i("div", Is, [
              n.value.showInfoIcon ? (l(), _(X, {
                key: 0,
                name: "Info",
                class: "text-gray-400 mt-1 shrink-0",
                size: 10
              })) : w("", !0),
              i("div", Ds, [
                c.value ? (l(), s("p", Vs, I(c.value), 1)) : w("", !0),
                v.value && v.value.length > 0 ? (l(), s("ul", As, [
                  (l(!0), s(te, null, oe(v.value, ($, A) => (l(), s("li", {
                    key: A,
                    class: "flex gap-2.5 py-0.5 transition-colors"
                  }, [
                    i("div", Rs, [
                      V($).label ? (l(), s("span", Ps, I(V($).label), 1)) : w("", !0),
                      i("span", Hs, I(V($).text), 1)
                    ])
                  ]))), 128))
                ])) : w("", !0)
              ])
            ]),
            h.value ? (l(), s("div", Ws, [
              U(X, {
                name: "Lightbulb",
                size: "12",
                class: "text-amber-500 mt-0.5 shrink-0"
              }),
              i("span", Os, I(h.value), 1)
            ])) : w("", !0)
          ], 6)) : w("", !0),
          i("div", js, [
            U(at, {
              label: S.value,
              variant: "secondary",
              onClick: O,
              class: "confirmation-cancel w-full font-bold"
            }, null, 8, ["label"]),
            U(at, {
              label: x.value,
              variant: k.value === "danger" ? "danger" : "primary",
              onClick: B,
              loading: a.value,
              disabled: n.value.confirmDisabled,
              class: E(["confirmation-confirm w-full shadow-md font-bold transition-all hover:-translate-y-0.5", [
                y.value,
                k.value === "info" || k.value === "warning" ? "bg-primary! border-primary! hover:bg-primary-hover!" : ""
              ]])
            }, null, 8, ["label", "variant", "loading", "disabled", "class"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header", "width", "content-class"]));
  }
}), Di = /* @__PURE__ */ ce(Fs, [["__scopeId", "data-v-83ded01f"]]), Ks = { key: 0 }, Ns = ["title"], Us = {
  key: 0,
  class: "text-gray-500"
}, qs = {
  key: 1,
  class: "text-blue-400"
}, Xs = {
  key: 2,
  class: "text-orange-400"
}, Ys = {
  key: 3,
  class: "text-gray-500"
}, Gs = { key: 1 }, Zs = { class: "shrink-0 text-[8px] leading-none text-gray-500 select-none" }, Js = { class: "text-gray-400" }, Qs = { class: "text-[11px]" }, _s = {
  key: 0,
  class: "text-purple-300"
}, eo = {
  key: 1,
  class: "text-gray-500"
}, to = {
  key: 2,
  class: "text-gray-600"
}, ao = {
  key: 0,
  class: "text-gray-500"
}, lo = { class: "text-gray-400" }, ro = {
  key: 1,
  class: "text-gray-400"
}, no = { class: "ml-4" }, so = {
  key: 0,
  class: "text-purple-400"
}, oo = {
  key: 1,
  class: "text-gray-600"
}, io = {
  key: 2,
  class: "text-gray-600"
}, uo = { class: "text-gray-400" }, Tt = 3, Et = 24, Vi = /* @__PURE__ */ ae({
  __name: "JsonViewer",
  props: {
    data: {},
    depth: { default: 0 },
    expandDepth: { default: -1 },
    stringTruncateThreshold: { default: 80 }
  },
  setup(e) {
    const r = e, t = R(r.expandDepth === -1 || r.depth < r.expandDepth), a = R(!1), n = C(() => r.data === null ? "null" : Array.isArray(r.data) ? "array" : typeof r.data), o = C(() => n.value === "object" || n.value === "array"), u = C(() => n.value === "array" ? r.data.map((f, h) => [String(h), f]) : n.value === "object" ? Object.entries(r.data) : []), d = C(() => u.value.length), m = C(() => n.value === "array" ? ["[", "]"] : ["{", "}"]), y = C(() => u.value.slice(0, Tt)), p = C(() => d.value > Tt);
    function b(f) {
      return f === null ? "null" : Array.isArray(f) ? `Array(${f.length})` : typeof f == "object" ? "{...}" : typeof f == "string" ? `'${f.length > Et ? `${f.slice(0, Et)}...` : f}'` : String(f);
    }
    function L(f) {
      return f === null || f !== null && typeof f == "object" ? "other" : typeof f;
    }
    const c = C(() => n.value === "string" && r.data.length > r.stringTruncateThreshold), v = C(() => {
      if (n.value !== "string") return "";
      const f = r.data;
      return !c.value || a.value ? f : f.slice(0, r.stringTruncateThreshold);
    });
    return (f, h) => {
      const x = _t("JsonViewer", !0);
      return o.value ? (l(), s("span", Gs, [
        i("button", {
          class: "inline-flex items-center gap-1 transition-opacity hover:opacity-70",
          onClick: h[1] || (h[1] = fe((S) => t.value = !t.value, ["stop"]))
        }, [
          i("span", Zs, I(t.value ? "▼" : "▶"), 1),
          t.value ? (l(), s("span", ro, I(m.value[0]), 1)) : (l(), s(te, { key: 0 }, [
            i("span", Js, I(m.value[0]), 1),
            i("span", Qs, [
              (l(!0), s(te, null, oe(y.value, ([S, k], M) => (l(), s(te, { key: S }, [
                n.value === "object" ? (l(), s("span", _s, I(S), 1)) : (l(), s("span", eo, I(S), 1)),
                h[2] || (h[2] = i("span", { class: "text-gray-500" }, ": ", -1)),
                i("span", {
                  class: E({
                    "text-emerald-400": L(k) === "string",
                    "text-blue-400": L(k) === "number",
                    "text-orange-400": L(k) === "boolean",
                    "text-gray-500": L(k) === "other"
                  })
                }, I(b(k)), 3),
                M < y.value.length - 1 ? (l(), s("span", to, ", ")) : w("", !0)
              ], 64))), 128)),
              p.value ? (l(), s("span", ao, ", ...")) : w("", !0)
            ]),
            i("span", lo, I(m.value[1]), 1)
          ], 64))
        ]),
        t.value ? (l(), s(te, { key: 0 }, [
          i("div", no, [
            (l(!0), s(te, null, oe(u.value, ([S, k], M) => (l(), s("div", {
              key: S,
              class: "leading-relaxed"
            }, [
              n.value === "object" ? (l(), s("span", so, '"' + I(S) + '"', 1)) : (l(), s("span", oo, I(S), 1)),
              h[3] || (h[3] = i("span", { class: "text-gray-500" }, ": ", -1)),
              U(x, {
                data: k,
                depth: e.depth + 1,
                "expand-depth": e.expandDepth
              }, null, 8, ["data", "depth", "expand-depth"]),
              M < u.value.length - 1 ? (l(), s("span", io, ",")) : w("", !0)
            ]))), 128))
          ]),
          i("span", uo, I(m.value[1]), 1)
        ], 64)) : w("", !0)
      ])) : (l(), s("span", Ks, [
        n.value === "string" ? (l(), s("span", {
          key: 0,
          title: c.value && !a.value ? e.data : void 0,
          class: E(["text-emerald-400", c.value && !a.value ? "cursor-pointer hover:opacity-70" : "whitespace-pre-wrap break-words"]),
          onClick: h[0] || (h[0] = fe((S) => c.value && (a.value = !a.value), ["stop"]))
        }, [
          $e(' "' + I(v.value) + '"', 1),
          c.value && !a.value ? (l(), s("span", Us, "...")) : w("", !0)
        ], 10, Ns)) : n.value === "number" ? (l(), s("span", qs, I(e.data), 1)) : n.value === "boolean" ? (l(), s("span", Xs, I(e.data), 1)) : (l(), s("span", Ys, "null"))
      ]));
    };
  }
}), co = {
  key: 0,
  class: "px-2 pt-2 pb-1.5"
}, fo = { class: "relative" }, mo = ["placeholder"], vo = {
  key: 1,
  class: "px-2 pb-1 flex justify-end"
}, bo = {
  key: 2,
  class: "mb-1"
}, ho = { class: "ml-auto font-normal normal-case tracking-normal opacity-60" }, go = ["data-tree-id", "onTouchstart", "onTouchmove", "onTouchend"], yo = ["draggable", "onClick", "onDragstart", "onDragover", "onDrop"], po = { class: "text-sm truncate flex-1" }, xo = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, wo = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, ko = {
  key: 3,
  class: "px-3 py-6 text-center text-sm text-gray-400 dark:text-gray-500"
}, $o = ["data-tree-id", "onClick", "onDblclick"], Co = { class: "py-1.5 text-sm truncate flex-1" }, Lo = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, So = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, zo = ["data-tree-id", "draggable", "onClick", "onDragstart", "onDragover", "onDrop"], Bo = ["onClick"], To = { class: "text-xs tracking-wide text-gray-700 dark:text-gray-200 flex-1 truncate" }, Eo = {
  key: 0,
  class: "text-[10px] text-gray-400 shrink-0"
}, Mo = {
  key: 0,
  class: "hidden group-hover:flex shrink-0 items-center gap-0.5 ml-auto pr-1"
}, Io = ["data-tree-id", "onTouchstart", "onTouchmove", "onTouchend"], Do = ["draggable", "onClick", "onDblclick", "onDragstart", "onDragover", "onDrop"], Vo = { class: "py-1.5 text-sm truncate flex-1" }, Ao = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, Ro = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, vt = "__favs__", Mt = 40, Po = 8, Ho = /* @__PURE__ */ ae({
  name: "TreeList",
  __name: "TreeList",
  props: {
    nodes: {},
    selectedId: {},
    defaultCollapsed: { default: () => [] },
    collapseKey: {},
    draggable: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    showFavourites: { type: Boolean, default: !1 },
    favouriteIds: { default: () => [] },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: {},
    flatViewToggle: { type: Boolean, default: !1 },
    filterPredicate: {},
    sortPredicate: {},
    swipeActions: { type: Boolean, default: !1 },
    swipeRevealWidth: { default: 120 },
    bareItems: { type: Boolean, default: !1 },
    canDrag: {},
    canDrop: {},
    enrichDrag: {}
  },
  emits: ["select", "toggle", "reorder", "move", "reorderFavourites", "dblclick"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t;
    function o() {
      if (a.collapseKey)
        try {
          const T = localStorage.getItem(a.collapseKey);
          if (T) {
            const D = JSON.parse(T);
            if (Array.isArray(D)) return new Set(D);
          }
        } catch {
        }
      return new Set(a.defaultCollapsed);
    }
    const u = R(o());
    me(u, (T) => {
      if (a.collapseKey)
        try {
          localStorage.setItem(a.collapseKey, JSON.stringify([...T]));
        } catch {
        }
    }, { deep: !0 }), me(() => a.collapseKey, () => {
      u.value = o();
    });
    function d(T) {
      return u.value.has(T);
    }
    function m(T) {
      const D = new Set(u.value);
      D.has(T) ? D.delete(T) : D.add(T), u.value = D, n("toggle", T, !D.has(T));
    }
    function y(T, D, g) {
      for (const W of T)
        g.push({ node: W, depth: D }), W.type === "group" && W.children?.length && !d(W.id) && y(W.children, D + 1, g);
    }
    const p = C(() => {
      const T = [];
      return y(a.nodes, 0, T), T;
    }), b = R(""), L = R(!1), c = C(() => a.searchable && b.value.trim().length > 0), v = C(() => c.value || L.value);
    function f(T, D) {
      return T.label.toLowerCase().includes(D.toLowerCase());
    }
    const h = C(() => {
      if (!v.value) return [];
      const T = [];
      function D(le) {
        for (const ve of le)
          ve.type === "item" && ve.meta?.kind !== "load-more" && T.push(ve), ve.children?.length && D(ve.children);
      }
      D(a.nodes);
      const g = b.value.trim(), W = a.filterPredicate ?? f, P = g ? T.filter((le) => W(le, g)) : T;
      return a.sortPredicate ? [...P].sort(a.sortPredicate) : P;
    });
    function x(T) {
      function D(g, W) {
        for (const P of g) {
          if (P.id === T) return W;
          if (P.children?.length) {
            const le = D(P.children, [...W, P.id]);
            if (le) return le;
          }
        }
        return null;
      }
      return D(a.nodes, []);
    }
    const S = C(() => {
      if (!a.showFavourites || !a.favouriteIds?.length) return [];
      const T = /* @__PURE__ */ new Map();
      function D(g) {
        for (const W of g)
          W.type === "item" && a.favouriteIds.includes(W.id) && T.set(W.id, W), W.children && D(W.children);
      }
      return D(a.nodes), a.favouriteIds.map((g) => T.get(g)).filter((g) => !!g);
    }), k = C({
      get: () => u.value.has(vt),
      set: (T) => {
        const D = new Set(u.value);
        T ? D.add(vt) : D.delete(vt), u.value = D;
      }
    });
    function M(T) {
      function D(g) {
        for (const W of g) {
          if (W.id === T) return W;
          if (W.children?.length) {
            const P = D(W.children);
            if (P) return P;
          }
        }
        return null;
      }
      return D(a.nodes);
    }
    function F(T) {
      function D(g, W) {
        for (const P of g) {
          if (P.id === T) return W;
          if (P.children?.length) {
            const le = D(P.children, P.type === "group" ? P : W);
            if (le !== void 0) return le;
          }
        }
      }
      return D(a.nodes, null) ?? null;
    }
    function V(T, D) {
      if (T === D) return !0;
      const g = M(D);
      if (!g?.children?.length) return !1;
      function W(P) {
        for (const le of P)
          if (le.id === T || le.children?.length && W(le.children)) return !0;
        return !1;
      }
      return W(g.children);
    }
    const B = R(null), O = R(null), j = R(null), J = R("before"), $ = R(!1), A = C(() => J.value === "after" ? "after" : "before"), z = C(() => {
      if (!j.value || J.value !== "into") return /* @__PURE__ */ new Set();
      const T = M(j.value);
      if (!T || T.type !== "group") return /* @__PURE__ */ new Set();
      const D = /* @__PURE__ */ new Set([j.value]);
      function g(W) {
        for (const P of W)
          D.add(P.id), P.type === "group" && P.children?.length && !d(P.id) && g(P.children);
      }
      return T.children?.length && !d(T.id) && g(T.children), D;
    });
    function K() {
      B.value = null, O.value = null, j.value = null, $.value = !1, ct();
    }
    function de(T, D, g = "tree") {
      if (a.draggable) {
        if (a.canDrag && !a.canDrag(D)) {
          T.preventDefault();
          return;
        }
        B.value = D, O.value = g, T.dataTransfer && (T.dataTransfer.effectAllowed = "move"), a.enrichDrag?.(D, T);
      }
    }
    function ue(T, D, g = "tree") {
      if (!a.reorderable || !B.value || B.value === D || O.value !== g || g === "tree" && V(D, B.value)) return;
      const W = T.currentTarget.getBoundingClientRect(), P = T.clientY - W.top, le = W.height, ve = g === "tree" ? M(D) : null, je = g === "tree" ? M(B.value) : null;
      let Ce = D, Ae;
      if (ve?.type === "group")
        if (je?.type === "group")
          Ae = P < le * 0.25 ? "before" : P > le * 0.75 ? "after" : "into";
        else {
          const Je = !d(D) && !!ve.children?.length;
          Ae = P > le * 0.75 && Je ? "after" : "into";
        }
      else if (je?.type === "group" && g === "tree") {
        const Je = F(D);
        Je && !V(Je.id, B.value) ? (Ce = Je.id, Ae = "into") : (Ce = null, Ae = "before");
      } else
        Ae = P < le / 2 ? "before" : "after";
      if (!Ce || a.canDrop && !a.canDrop(B.value, Ce, Ae)) {
        Ce ? (T.preventDefault(), T.dataTransfer && (T.dataTransfer.dropEffect = "none"), j.value = Ce, J.value = Ae, $.value = !0) : (j.value = null, $.value = !1);
        return;
      }
      T.preventDefault(), j.value = Ce, J.value = Ae, $.value = !1, rt(T);
    }
    function ie() {
      j.value = null, $.value = !1;
    }
    function ge(T, D, g = "tree") {
      if ($.value) {
        K();
        return;
      }
      if (!(!a.reorderable || !B.value || B.value === D)) {
        if (O.value !== g) {
          K();
          return;
        }
        if (g === "tree" && V(D, B.value)) {
          K();
          return;
        }
        if (T.preventDefault(), g === "favs") {
          const W = S.value.map((Ce) => Ce.id), P = B.value, le = W.filter((Ce) => Ce !== P), ve = le.indexOf(D);
          if (ve === -1) {
            K();
            return;
          }
          const je = J.value === "before" ? ve : ve + 1;
          le.splice(je, 0, P), n("reorderFavourites", le);
        } else {
          const W = J.value, P = j.value ?? D;
          if (V(P, B.value)) {
            K();
            return;
          }
          const le = W === "into" ? { intoGroup: !0, groupId: P } : {
            ...W === "before" ? { beforeId: P } : { afterId: P },
            parentGroupId: F(P)?.id ?? void 0
          };
          n("move", B.value, le), W !== "into" && n("reorder", B.value, P, W);
        }
        K();
      }
    }
    function q() {
      K();
    }
    let G = null, Q = 0, be = null;
    function Ze(T) {
      let D = T;
      for (; D && D !== document.body; ) {
        const g = getComputedStyle(D);
        if (/(auto|scroll|overlay)/.test(g.overflowY)) return D;
        D = D.parentElement;
      }
      return null;
    }
    function rt(T) {
      if (be || (be = Ze(ye.value)), !be) return;
      const D = be.getBoundingClientRect();
      if (T.clientY < D.top + Mt ? Q = -1 : T.clientY > D.bottom - Mt ? Q = 1 : Q = 0, Q !== 0 && G === null) {
        const g = () => {
          if (Q === 0 || !be) {
            G = null;
            return;
          }
          be.scrollTop += Q * Po, G = requestAnimationFrame(g);
        };
        G = requestAnimationFrame(g);
      }
    }
    function ct() {
      G !== null && (cancelAnimationFrame(G), G = null), Q = 0, be = null;
    }
    const he = R(null), Le = R(0), Se = R(!1);
    let ze = null, Be = null;
    function H() {
      he.value === null && Le.value === 0 || (Se.value = !0, Le.value = 0, he.value = null, setTimeout(() => {
        Se.value = !1;
      }, 200));
    }
    function Y(T, D) {
      if (!a.swipeActions) return;
      const g = T.touches[0];
      if (!g) return;
      const W = he.value === D ? Le.value : 0;
      he.value && he.value !== D && H(), ze = { x: g.clientX, y: g.clientY, id: D, baseDx: W }, Be = null, Se.value = !1;
    }
    function ee(T, D) {
      if (!a.swipeActions || !ze || ze.id !== D) return;
      const g = T.touches[0];
      if (!g) return;
      const W = g.clientX - ze.x, P = g.clientY - ze.y;
      if (Be === null) {
        const le = Math.abs(W), ve = Math.abs(P);
        le > 8 && le > ve ? Be = "h" : ve > 8 && (Be = "v");
      }
      if (Be === "h") {
        T.cancelable && T.preventDefault();
        const le = ze.baseDx + W;
        Le.value = Math.max(-a.swipeRevealWidth, Math.min(0, le)), he.value = D;
      }
    }
    function se(T) {
      if (a.swipeActions) {
        if (Be !== "h") {
          ze = null, Be = null;
          return;
        }
        ze = null, Be = null, Se.value = !0, Le.value < -a.swipeRevealWidth / 2 ? (Le.value = -a.swipeRevealWidth, he.value = T) : (Le.value = 0, he.value = null), setTimeout(() => {
          Se.value = !1;
        }, 200);
      }
    }
    function xe(T) {
      return he.value === T ? Le.value : 0;
    }
    const ye = R(null);
    async function Te(T, D = { behavior: "smooth", block: "nearest" }) {
      const g = x(T);
      if (g === null) return;
      if (g.length) {
        const le = new Set(u.value);
        let ve = !1;
        for (const je of g)
          le.delete(je) && (ve = !0);
        ve && (u.value = le);
      }
      await pe();
      const W = ye.value;
      if (!W) return;
      const P = W.querySelector(`[data-tree-id="${CSS.escape(T)}"]`);
      P && P.scrollIntoView(D);
    }
    function Ee(T) {
      if (!u.value.has(T)) return;
      const D = new Set(u.value);
      D.delete(T), u.value = D;
    }
    function Oe(T) {
      if (u.value.has(T)) return;
      const D = new Set(u.value);
      D.add(T), u.value = D;
    }
    r({ scrollIntoView: Te, expand: Ee, collapse: Oe, closeSwipe: H });
    function Ve(T) {
      return T > 0 ? { paddingLeft: `${8 + T * 14}px` } : void 0;
    }
    return (T, D) => (l(), s("div", {
      ref_key: "rootRef",
      ref: ye,
      class: E(["tree-list relative flex flex-col select-none", { "gap-1": e.bareItems }])
    }, [
      e.searchable ? (l(), s("div", co, [
        i("div", fo, [
          U(X, {
            name: "Search",
            size: 13,
            class: "absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
          }),
          xt(i("input", {
            "onUpdate:modelValue": D[0] || (D[0] = (g) => b.value = g),
            type: "text",
            placeholder: e.searchPlaceholder ?? "Search...",
            class: "w-full pl-8 pr-7 py-1.5 text-sm bg-gray-100 dark:bg-dark-200 rounded-md outline-none focus:ring-1 focus:ring-primary/40 text-gray-800 dark:text-gray-200 placeholder-gray-400"
          }, null, 8, mo), [
            [Rt, b.value]
          ]),
          b.value ? (l(), s("button", {
            key: 0,
            onClick: D[1] || (D[1] = (g) => b.value = ""),
            class: "absolute right-1.5 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded transition-colors"
          }, [
            U(X, {
              name: "X",
              size: 11
            })
          ])) : w("", !0)
        ])
      ])) : w("", !0),
      e.flatViewToggle && !c.value ? (l(), s("div", vo, [
        i("button", {
          onClick: D[2] || (D[2] = (g) => L.value = !L.value),
          class: "text-[10px] uppercase tracking-wider text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 flex items-center gap-1 px-1.5 py-0.5 rounded transition-colors"
        }, [
          U(X, {
            name: L.value ? "List" : "FolderTree",
            size: 11
          }, null, 8, ["name"]),
          $e(" " + I(L.value ? "Flat" : "Tree"), 1)
        ])
      ])) : w("", !0),
      e.showFavourites && S.value.length && !c.value ? (l(), s("div", bo, [
        i("button", {
          class: "w-full flex items-center gap-1.5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors rounded-md",
          onClick: D[3] || (D[3] = (g) => k.value = !k.value)
        }, [
          U(X, {
            name: k.value ? "ChevronRight" : "ChevronDown",
            size: 10,
            class: "shrink-0"
          }, null, 8, ["name"]),
          U(X, {
            name: "Star",
            size: 10,
            class: "shrink-0 text-amber-400"
          }),
          D[4] || (D[4] = i("span", null, "Favourites", -1)),
          i("span", ho, I(S.value.length), 1)
        ]),
        k.value ? w("", !0) : (l(), _(Ye, {
          key: 0,
          name: "tree-row",
          tag: "div",
          class: "space-y-0.5 mt-0.5"
        }, {
          default: ne(() => [
            (l(!0), s(te, null, oe(S.value, (g) => (l(), s("div", {
              key: "fav-" + g.id,
              "data-tree-id": "fav-" + g.id,
              class: E(["relative", e.swipeActions ? "overflow-hidden" : ""]),
              onTouchstart: (W) => Y(W, "fav-" + g.id),
              onTouchmove: (W) => ee(W, "fav-" + g.id),
              onTouchend: (W) => se("fav-" + g.id)
            }, [
              e.swipeActions && T.$slots["swipe-actions"] && he.value === "fav-" + g.id ? (l(), s("div", {
                key: 0,
                class: "absolute right-0 top-0 bottom-0 flex items-stretch",
                style: re({ width: e.swipeRevealWidth + "px" })
              }, [
                N(T.$slots, "swipe-actions", {
                  node: g,
                  close: H
                }, void 0, !0)
              ], 4)) : w("", !0),
              i("div", {
                class: E(["group/item relative", [
                  e.bareItems ? "block cursor-pointer min-w-0" : "flex items-center gap-2 px-2 py-1.5 rounded-md transition-colors",
                  !e.bareItems && (e.selectedId === g.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200"),
                  !e.bareItems && (e.draggable ? "cursor-grab active:cursor-grabbing" : "cursor-pointer"),
                  j.value === g.id && O.value === "favs" && A.value === "before" ? "border-t-2 border-primary" : "",
                  j.value === g.id && O.value === "favs" && A.value === "after" ? "border-b-2 border-primary" : ""
                ]]),
                style: re({
                  transform: e.swipeActions ? `translateX(${xe("fav-" + g.id)}px)` : void 0,
                  transition: e.swipeActions && Se.value ? "transform 200ms" : void 0
                }),
                draggable: e.draggable,
                onClick: (W) => n("select", g.id, !0),
                onDragstart: (W) => de(W, g.id, "favs"),
                onDragover: (W) => ue(W, g.id, "favs"),
                onDragleave: ie,
                onDrop: (W) => ge(W, g.id, "favs"),
                onDragend: q
              }, [
                N(T.$slots, "item", {
                  node: g,
                  selected: e.selectedId === g.id,
                  depth: 0,
                  isFav: !0
                }, () => [
                  g.icon ? (l(), _(X, {
                    key: 0,
                    name: g.icon,
                    size: 13,
                    class: "shrink-0 text-gray-400"
                  }, null, 8, ["name"])) : w("", !0),
                  i("span", po, I(g.label), 1),
                  g.badge !== void 0 ? (l(), s("span", xo, I(g.badge), 1)) : w("", !0)
                ], !0),
                T.$slots["item-actions"] ? (l(), s("div", wo, [
                  N(T.$slots, "item-actions", { node: g }, void 0, !0)
                ])) : w("", !0)
              ], 46, yo)
            ], 42, go))), 128))
          ]),
          _: 3
        }))
      ])) : w("", !0),
      (v.value ? h.value.length === 0 : p.value.length === 0) ? (l(), s("div", ko, [
        N(T.$slots, "empty", {
          searching: c.value,
          query: b.value
        }, () => [
          $e(I(c.value ? "No matches" : "No items"), 1)
        ], !0)
      ])) : w("", !0),
      v.value ? (l(!0), s(te, { key: 4 }, oe(h.value, (g) => (l(), s("div", {
        key: "flat-" + g.id,
        "data-tree-id": g.id,
        class: E(["group/item relative flex items-center cursor-pointer", [
          e.bareItems ? "" : "gap-2 rounded-md transition-colors px-2",
          !e.bareItems && (e.selectedId === g.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200")
        ]]),
        onClick: (W) => n("select", g.id),
        onDblclick: (W) => n("dblclick", g.id)
      }, [
        N(T.$slots, "item", {
          node: g,
          selected: e.selectedId === g.id,
          depth: 0,
          isFav: !1
        }, () => [
          g.icon ? (l(), _(X, {
            key: 0,
            name: g.icon,
            size: 13,
            class: "shrink-0 text-gray-400"
          }, null, 8, ["name"])) : w("", !0),
          i("span", Co, I(g.label), 1),
          g.badge !== void 0 ? (l(), s("span", Lo, I(g.badge), 1)) : w("", !0)
        ], !0),
        T.$slots["item-actions"] ? (l(), s("div", So, [
          N(T.$slots, "item-actions", { node: g }, void 0, !0)
        ])) : w("", !0)
      ], 42, $o))), 128)) : (l(), _(Ye, {
        key: 5,
        name: "tree-row",
        tag: "div",
        class: E(["flex flex-col min-w-0", { "gap-1": e.bareItems }])
      }, {
        default: ne(() => [
          (l(!0), s(te, null, oe(p.value, ({ node: g, depth: W }) => (l(), s(te, {
            key: g.id
          }, [
            g.type === "group" ? (l(), s("div", {
              key: 0,
              "data-tree-id": g.id,
              class: E(["group flex items-center gap-1 rounded-md transition-colors pr-2 shrink-0", [
                W === 0 ? "h-8 pl-2 font-semibold" : "h-7 font-medium",
                "hover:bg-gray-100 dark:hover:bg-dark-200",
                e.draggable && (!e.canDrag || e.canDrag(g.id)) ? "cursor-grab active:cursor-grabbing" : "cursor-pointer",
                O.value === "tree" && j.value === g.id && J.value === "into" && !$.value ? "ring-2 ring-primary/60 bg-primary/5" : "",
                O.value === "tree" && j.value === g.id && J.value === "into" && $.value ? "ring-2 ring-red-400/50 bg-red-500/5" : "",
                O.value === "tree" && j.value === g.id && J.value === "before" && !$.value ? "border-t-2 border-primary" : "",
                O.value === "tree" && j.value === g.id && J.value === "after" && !$.value ? "border-b-2 border-primary" : "",
                O.value === "tree" && z.value.has(g.id) && j.value !== g.id && !$.value ? "bg-primary/5" : "",
                O.value === "tree" && z.value.has(g.id) && j.value !== g.id && $.value ? "bg-red-500/5" : ""
              ]]),
              style: re(Ve(W)),
              draggable: e.draggable && (!e.canDrag || e.canDrag(g.id)),
              onClick: (P) => n("select", g.id),
              onDragstart: (P) => de(P, g.id),
              onDragover: (P) => ue(P, g.id),
              onDragleave: ie,
              onDrop: (P) => ge(P, g.id),
              onDragend: q
            }, [
              N(T.$slots, "group-header", {
                node: g,
                collapsed: d(g.id),
                depth: W,
                toggle: () => m(g.id)
              }, () => [
                i("button", {
                  class: "shrink-0 p-0.5 -ml-0.5 rounded hover:bg-black/10 dark:hover:bg-white/10 transition-colors",
                  onClick: fe((P) => m(g.id), ["stop"])
                }, [
                  U(X, {
                    name: d(g.id) ? "ChevronRight" : "ChevronDown",
                    size: W === 0 ? 12 : 10,
                    class: "text-gray-500 dark:text-gray-400 transition-transform duration-150"
                  }, null, 8, ["name", "size"])
                ], 8, Bo),
                U(X, {
                  name: g.meta?.loading ? "Loader2" : g.icon ?? (W === 0 ? "Folder" : "FolderOpen"),
                  size: W === 0 ? 12 : 10,
                  class: E(["shrink-0 text-gray-500 dark:text-gray-400", g.meta?.loading ? "animate-spin" : ""])
                }, null, 8, ["name", "size", "class"]),
                i("span", To, [
                  N(T.$slots, "group-label", {
                    node: g,
                    depth: W
                  }, () => [
                    $e(I(g.label), 1)
                  ], !0)
                ]),
                g.badge !== void 0 ? (l(), s("span", Eo, I(g.badge), 1)) : w("", !0)
              ], !0),
              T.$slots["group-actions"] ? (l(), s("div", Mo, [
                N(T.$slots, "group-actions", { node: g }, void 0, !0)
              ])) : w("", !0)
            ], 46, zo)) : (l(), s("div", {
              key: 1,
              "data-tree-id": g.id,
              class: E(["relative", e.swipeActions ? "overflow-hidden" : ""]),
              onTouchstart: (P) => Y(P, g.id),
              onTouchmove: (P) => ee(P, g.id),
              onTouchend: (P) => se(g.id)
            }, [
              e.swipeActions && T.$slots["swipe-actions"] && he.value === g.id ? (l(), s("div", {
                key: 0,
                class: "absolute right-0 top-0 bottom-0 flex items-stretch",
                style: re({ width: e.swipeRevealWidth + "px" })
              }, [
                N(T.$slots, "swipe-actions", {
                  node: g,
                  close: H
                }, void 0, !0)
              ], 4)) : w("", !0),
              i("div", {
                class: E(["group/item relative cursor-pointer min-w-0", [
                  e.bareItems ? "block" : "flex items-center gap-2 rounded-md bg-gray-50 dark:bg-dark-50",
                  !e.bareItems && (e.swipeActions ? "" : "transition-colors"),
                  !e.bareItems && (e.selectedId === g.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200"),
                  O.value === "tree" && j.value === g.id && A.value === "before" && !$.value ? "border-t-2 border-primary" : "",
                  O.value === "tree" && j.value === g.id && A.value === "after" && !$.value ? "border-b-2 border-primary" : "",
                  O.value === "tree" && z.value.has(g.id) && !$.value ? "bg-primary/5" : "",
                  O.value === "tree" && z.value.has(g.id) && $.value ? "bg-red-500/5" : "",
                  e.draggable ? "cursor-grab active:cursor-grabbing" : ""
                ]]),
                style: re({
                  paddingLeft: e.bareItems ? `${W * 8}px` : `${8 + W * 14}px`,
                  paddingRight: e.bareItems ? void 0 : "8px",
                  transform: e.swipeActions ? `translateX(${xe(g.id)}px)` : void 0,
                  transition: e.swipeActions && Se.value ? "transform 200ms" : void 0
                }),
                draggable: e.draggable,
                onClick: (P) => n("select", g.id),
                onDblclick: (P) => n("dblclick", g.id),
                onDragstart: (P) => de(P, g.id),
                onDragover: (P) => ue(P, g.id),
                onDragleave: ie,
                onDrop: (P) => ge(P, g.id),
                onDragend: q
              }, [
                N(T.$slots, "item", {
                  node: g,
                  selected: e.selectedId === g.id,
                  depth: W,
                  isFav: !1
                }, () => [
                  g.icon ? (l(), _(X, {
                    key: 0,
                    name: g.icon,
                    size: 13,
                    class: "shrink-0 text-gray-400"
                  }, null, 8, ["name"])) : w("", !0),
                  i("span", Vo, I(g.label), 1),
                  g.badge !== void 0 ? (l(), s("span", Ao, I(g.badge), 1)) : w("", !0)
                ], !0),
                T.$slots["item-actions"] ? (l(), s("div", Ro, [
                  N(T.$slots, "item-actions", { node: g }, void 0, !0)
                ])) : w("", !0)
              ], 46, Do)
            ], 42, Io))
          ], 64))), 128))
        ]),
        _: 3
      }, 8, ["class"])),
      N(T.$slots, "footer", {}, void 0, !0)
    ], 2));
  }
}), Ai = /* @__PURE__ */ ce(Ho, [["__scopeId", "data-v-49d31aac"]]), Wo = {
  light: {
    primary: "#2563eb",
    primaryLight: "#60a5fa",
    primaryHover: "#1d4ed8",
    primary50: "#eff6ff",
    primary100: "#dbeafe",
    primary200: "#bfdbfe",
    primary300: "#93c5fd",
    primary400: "#60a5fa",
    primary500: "#3b82f6",
    primary600: "#2563eb",
    primary700: "#1d4ed8",
    primary800: "#1e40af",
    primary900: "#1e3a8a",
    surface: "#ffffff",
    surfaceMuted: "#f9fafb",
    surfaceElevated: "#ffffff",
    surfaceInverse: "#111827",
    tooltipSurface: "#1f2937",
    tooltipText: "#f9fafb",
    tooltipBorder: "#374151",
    shadow: "rgba(15, 23, 42, 0.18)",
    text: "#111827",
    textMuted: "#6b7280",
    textDim: "#9ca3af",
    border: "#e5e7eb",
    borderStrong: "#d1d5db",
    scrollbarThumb: "#cbd5e1",
    scrollbarThumbHover: "#94a3b8",
    scrollbarTrack: "transparent",
    focus: "#2563eb",
    success: "#16a34a",
    warning: "#d97706",
    danger: "#dc2626",
    info: "#2563eb"
  },
  dark: {
    primary: "#60a5fa",
    primaryLight: "#93c5fd",
    primaryHover: "#3b82f6",
    primary500: "#60a5fa",
    surface: "#111827",
    surfaceMuted: "#0f172a",
    surfaceElevated: "#1f2937",
    surfaceInverse: "#ffffff",
    tooltipSurface: "#121f28",
    tooltipText: "#e5edf8",
    tooltipBorder: "#385163",
    shadow: "rgba(0, 0, 0, 0.55)",
    text: "#f9fafb",
    textMuted: "#d1d5db",
    textDim: "#9ca3af",
    border: "#1f2937",
    borderStrong: "#374151",
    scrollbarThumb: "#475569",
    scrollbarThumbHover: "#64748b",
    scrollbarTrack: "transparent",
    focus: "#93c5fd",
    success: "#4ade80",
    warning: "#fbbf24",
    danger: "#f87171",
    info: "#93c5fd",
    dark50: "#0f172a",
    dark100: "#111827",
    dark200: "#1f2937",
    dark300: "#374151",
    darkText: "#f9fafb",
    darkTextMuted: "#d1d5db",
    darkTextDim: "#9ca3af"
  }
}, It = "luna-vue-ui-theme";
function Oo(e) {
  return `--color-${e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`).replace(/([a-z])([0-9])/g, "$1-$2")}`;
}
function Dt(e) {
  return e ? Object.entries(e).filter((r) => typeof r[1] == "string" && r[1].length > 0).map(([r, t]) => `  ${Oo(r)}: ${t};`).join(`
`) : "";
}
function jo(e = Wo) {
  if (typeof document > "u") return;
  let r = document.getElementById(It);
  r || (r = document.createElement("style"), r.id = It, r.dataset.vueUiTheme = "true", document.head.appendChild(r));
  const t = Dt(e.light), a = Dt(e.dark);
  r.textContent = [
    t ? `:root {
${t}
}` : "",
    a ? `.dark {
${a}
}` : ""
  ].filter(Boolean).join(`
`);
}
function Fo(e = {}) {
  return {
    install(r) {
      r.provide(Ht, Wt(e.icons)), r.directive("base-hover-label", ot), r.directive("basehoverlabel", ot), r.directive("base-tooltip", ot), r.directive("basetooltip", ot), e.theme && jo(e.theme);
    }
  };
}
const Ri = Fo();
function Ko(e) {
  return typeof DOMException < "u" && e instanceof DOMException && e.name === "AbortError";
}
function No() {
  const e = R(!1), r = R(null);
  let t = 0, a = null;
  const n = () => {
    t += 1, a?.abort(), a = null, e.value = !1;
  };
  return { loading: e, error: r, run: async (u) => {
    n();
    const d = t, m = new AbortController();
    a = m, r.value = null, e.value = !0;
    try {
      const y = await u(m.signal);
      return d === t ? y : void 0;
    } catch (y) {
      if (d === t && !m.signal.aborted && !Ko(y))
        throw r.value = y, y;
      return;
    } finally {
      d === t && (a = null, e.value = !1);
    }
  }, cancel: n };
}
function Pi(e) {
  const r = ea([]), t = R(0), a = R(Math.max(1, e.page ?? 1)), n = R(Math.max(1, e.pageSize ?? 10)), o = No(), u = C(() => Math.max(1, Math.ceil(t.value / n.value))), d = C(() => a.value > 1), m = C(() => a.value < u.value), y = async (v = {}) => {
    const f = Math.max(1, v.page ?? a.value), h = Math.max(1, v.pageSize ?? n.value);
    a.value = f, n.value = h;
    const x = await o.run((S) => e.fetcher({ page: f, pageSize: h, signal: S }));
    return x && (r.value = x.items, t.value = Math.max(0, x.total)), x;
  }, p = (v) => y({ page: v }), b = (v) => y({ page: 1, pageSize: v }), L = () => {
    o.cancel(), r.value = [], t.value = 0, a.value = Math.max(1, e.page ?? 1), n.value = Math.max(1, e.pageSize ?? 10);
  }, c = {
    items: r,
    total: t,
    page: a,
    pageSize: n,
    totalPages: u,
    hasPrevious: d,
    hasNext: m,
    loading: o.loading,
    error: o.error,
    request: o,
    load: y,
    setPage: p,
    setPageSize: b,
    reset: L
  };
  return e.immediate !== !1 && y(), c;
}
const Xe = R([]);
function Qe(e) {
  Xe.value = Xe.value.filter((r) => r.id !== e);
}
function Hi() {
  function e(u) {
    const d = crypto.randomUUID();
    Xe.value = [...Xe.value, { ...u, id: d, startTime: Date.now() }];
    const m = u.life ?? 3e3;
    m > 0 && setTimeout(() => Qe(d), m);
  }
  function r(u, d, m = 3e3) {
    e({ severity: "success", summary: u, detail: d, life: m });
  }
  function t(u, d, m = 5e3) {
    e({ severity: "error", summary: u, detail: d, life: m });
  }
  function a(u, d, m = 4e3) {
    e({ severity: "warning", summary: u, detail: d, life: m });
  }
  function n(u, d, m = 3e3) {
    e({ severity: "info", summary: u, detail: d, life: m });
  }
  function o() {
    Xe.value = [];
  }
  return { add: e, success: r, error: t, warning: a, info: n, clear: o };
}
const Uo = ["onClick", "onTouchstart", "onTouchmove", "onTouchend"], qo = { class: "toast-content flex items-start" }, Xo = { class: "toast-icon shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-xl" }, Yo = { class: "flex-1 min-w-0" }, Go = {
  key: 0,
  class: "font-semibold text-sm mb-1 text-inherit leading-tight"
}, Zo = {
  key: 1,
  class: "text-sm m-0 text-inherit opacity-90 leading-snug wrap-break-word whitespace-pre-wrap"
}, Jo = ["onClick"], Qo = ["onClick"], bt = 80, Vt = 5, _o = /* @__PURE__ */ ae({
  __name: "ToastNotification",
  props: {
    position: { default: "top-right" },
    toastClass: {},
    toastStyle: {}
  },
  setup(e) {
    const r = /* @__PURE__ */ new Map();
    function t(b, L) {
      const c = b.touches[0];
      if (!c) return;
      const v = b.currentTarget;
      v.style.transition = "none", r.set(L, { startX: c.clientX, startY: c.clientY, el: v, dir: null, locked: !1 });
    }
    function a(b, L) {
      const c = r.get(L);
      if (!c) return;
      const v = b.touches[0];
      if (!v) return;
      const f = v.clientX - c.startX, h = v.clientY - c.startY;
      if (!c.locked) {
        if (Math.abs(f) < Vt && Math.abs(h) < Vt) return;
        c.dir = Math.abs(f) >= Math.abs(h) ? "h" : "v", c.locked = !0;
      }
      if (c.dir === "v" && h > 0) return;
      b.preventDefault();
      let x = 0, S = 0;
      c.dir === "h" ? x = f > 0 ? f : f * 0.15 : S = h < 0 ? h : h * 0.15;
      const k = c.dir === "h" ? Math.max(0, f) : Math.max(0, -h), M = Math.max(0.3, 1 - k / bt * 0.7);
      c.el.style.transform = `translate(${x}px,${S}px)`, c.el.style.opacity = String(M);
    }
    function n(b, L) {
      const c = r.get(L);
      if (r.delete(L), !c) return;
      const v = b.changedTouches[0];
      if (!v) return;
      const f = v.clientX - c.startX, h = v.clientY - c.startY;
      c.dir === "h" && f > bt || c.dir === "v" && h < -bt ? (c.el.style.transition = "transform 0.2s ease-out, opacity 0.2s ease-out", c.el.style.transform = c.dir === "h" ? "translateX(120%)" : "translateY(-120%)", c.el.style.opacity = "0", setTimeout(() => Qe(L), 200)) : (c.el.style.transition = "transform 0.3s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s ease", c.el.style.transform = "", c.el.style.opacity = "");
    }
    const o = e, u = C(() => ({
      "top-right": "top-4 right-4 items-end",
      "top-center": "top-4 left-1/2 -translate-x-1/2 items-center",
      "top-left": "top-4 left-4 items-start",
      "bottom-right": "bottom-4 right-4 items-end",
      "bottom-center": "bottom-4 left-1/2 -translate-x-1/2 items-center",
      "bottom-left": "bottom-4 left-4 items-start"
    })[o.position] + " flex flex-col");
    function d(b) {
      return {
        success: "toast-success",
        error: "toast-error",
        warning: "toast-warning",
        info: "toast-info"
      }[b];
    }
    function m(b) {
      return {
        success: "CheckCircle2",
        error: "XCircle",
        warning: "AlertTriangle",
        info: "Info"
      }[b];
    }
    function y(b) {
      return typeof o.toastClass == "function" ? o.toastClass(b) : o.toastClass;
    }
    function p(b) {
      return { ...typeof o.toastStyle == "function" ? o.toastStyle(b) : o.toastStyle, ...b.style };
    }
    return (b, L) => (l(), _(De, { to: "body" }, [
      i("div", {
        class: E(["fixed z-20000 pointer-events-none sm:mx-0 mx-4", u.value])
      }, [
        U(Ye, { name: "toast" }, {
          default: ne(() => [
            (l(!0), s(te, null, oe(Z(Xe), (c) => (l(), s("div", {
              key: c.id,
              class: E(["toast-shell pointer-events-auto mb-3 overflow-hidden relative transition-all duration-300 ease-out hover:-translate-y-0.5 w-full max-w-sm sm:min-w-75", [d(c.severity), c.class, y(c), c.action ? "" : "cursor-pointer"]]),
              style: re(p(c)),
              onClick: (v) => !c.action && Z(Qe)(c.id),
              onTouchstart: (v) => t(v, c.id),
              onTouchmove: (v) => a(v, c.id),
              onTouchend: (v) => n(v, c.id)
            }, [
              i("div", qo, [
                i("div", Xo, [
                  U(X, {
                    name: m(c.severity),
                    size: 24
                  }, null, 8, ["name"])
                ]),
                i("div", Yo, [
                  c.summary ? (l(), s("h4", Go, I(c.summary), 1)) : w("", !0),
                  c.detail ? (l(), s("p", Zo, I(c.detail), 1)) : w("", !0),
                  c.action ? (l(), s("button", {
                    key: 2,
                    class: "toast-action mt-3 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors cursor-pointer",
                    onClick: fe((v) => {
                      Z(Qe)(c.id), c.action.onClick();
                    }, ["stop"])
                  }, I(c.action.label) + " → ", 9, Jo)) : w("", !0)
                ]),
                i("button", {
                  class: "toast-dismiss shrink-0 bg-transparent border-none cursor-pointer p-1 opacity-70 hover:opacity-100 transition-opacity",
                  onClick: fe((v) => Z(Qe)(c.id), ["stop"])
                }, [
                  U(X, {
                    name: "X",
                    size: 14
                  })
                ], 8, Qo)
              ]),
              c.life ? (l(), s("div", {
                key: 0,
                class: "toast-progress h-0.75 absolute bottom-0 left-0 progress-bar",
                style: re({ animationDuration: `${c.life}ms` })
              }, null, 4)) : w("", !0)
            ], 46, Uo))), 128))
          ]),
          _: 1
        })
      ], 2)
    ]));
  }
}), Wi = /* @__PURE__ */ ce(_o, [["__scopeId", "data-v-4fd11d07"]]);
export {
  fi as BaseAccordion,
  ri as BaseAlert,
  Ci as BaseAudioPlayer,
  $i as BaseAutocomplete,
  mi as BaseBreadcrumb,
  at as BaseButton,
  Ei as BaseCollectionView,
  ki as BaseContextMenu,
  gn as BaseDialog,
  zi as BaseDrawer,
  Bi as BaseEditableTable,
  oi as BaseHoverLabel,
  X as BaseIcon,
  Ke as BaseInput,
  vi as BasePagination,
  bi as BasePasswordInput,
  Ot as BasePopover,
  Ja as BasePopoverButton,
  ii as BaseProgressBar,
  ui as BasePullToRefresh,
  di as BasePullToRefreshTrigger,
  gt as BaseSelect,
  hi as BaseSplitButton,
  ci as BaseSwitch,
  yi as BaseTab,
  pi as BaseTabList,
  wi as BaseTabPanel,
  xi as BaseTabPanels,
  Ti as BaseTable,
  gi as BaseTabs,
  ni as BaseTag,
  si as BaseTooltip,
  Mi as BatchActionBar,
  Di as ConfirmationDialog,
  Wo as DEFAULT_VUE_UI_THEME,
  Vi as JsonViewer,
  Wi as ToastNotification,
  Ai as TreeList,
  Ri as VueUiPlugin,
  jo as applyVueUiTheme,
  ot as baseHoverLabel,
  li as clearIconRegistry,
  Me as confirmQueue,
  Wt as createIconRegistry,
  Fo as createVueUi,
  Li as disableCloseWatcherPath,
  Si as getMobileCloseStack,
  Ht as iconRegistryKey,
  ut as normalizeIconName,
  Ia as registerIcon,
  Da as registerIcons,
  Qe as removeToast,
  Va as resolveIcon,
  Xe as toasts,
  Ii as useConfirmDialog,
  Aa as useIconRegistry,
  Ft as useIsMobile,
  No as useLatestRequest,
  tn as useMobileHistoryEntry,
  Pi as usePaginatedQuery,
  Bl as usePullToRefresh,
  Ml as usePullToRefreshTrigger,
  Hi as useToast
};
